'use strict';
define(['chart.js'], function (Chart) {
    function suiteThemeToken(name, fallback) {
        var value = window.getComputedStyle(document.documentElement).getPropertyValue(name);
        return value && value.trim() ? value.trim() : fallback;
    }

    var cruxLineColors = {
        good: '#238b57',
        warning: '#c47a00',
        poor: '#c62828'
    };
    function cruxBandForValue(value, bands) {
        if (value <= bands.good) return 'good';
        if (value <= bands.poor) return 'warning';
        return 'poor';
    }
    var cruxBandsPlugin = {
        beforeDraw: function (chart) {
            var bands = chart.options && chart.options.cruxBands;
            var area = chart.chartArea;
            var yAxis = chart.scales && chart.scales['y-axis-0'];
            if (!bands || !area || !yAxis) return;
            var goodY = Math.max(area.top, Math.min(area.bottom, yAxis.getPixelForValue(bands.good)));
            var poorY = Math.max(area.top, Math.min(area.bottom, yAxis.getPixelForValue(bands.poor)));
            chart.ctx.save();
            chart.ctx.fillStyle = 'rgba(40, 182, 112, .10)';
            chart.ctx.fillRect(area.left, goodY, area.right - area.left, area.bottom - goodY);
            chart.ctx.fillStyle = 'rgba(251, 140, 0, .11)';
            chart.ctx.fillRect(area.left, poorY, area.right - area.left, goodY - poorY);
            chart.ctx.fillStyle = 'rgba(244, 67, 54, .08)';
            chart.ctx.fillRect(area.left, area.top, area.right - area.left, poorY - area.top);
            chart.ctx.restore();
        },
        afterDatasetsDraw: function (chart) {
            var bands = chart.options && chart.options.cruxBands;
            var dataset = chart.data && chart.data.datasets && chart.data.datasets[0];
            var meta = chart.getDatasetMeta && chart.getDatasetMeta(0);
            var points = meta && meta.data;
            if (!bands || !dataset || !points || !points.length) return;
            var values = dataset.data || [];
            var ctx = chart.ctx;
            ctx.save();
            ctx.lineWidth = 2;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            for (var index = 1; index < points.length; index += 1) {
                var from = points[index - 1] && points[index - 1]._model;
                var to = points[index] && points[index]._model;
                var fromValue = Number(values[index - 1]);
                var toValue = Number(values[index]);
                if (!from || !to || from.skip || to.skip || isNaN(fromValue) || isNaN(toValue)) continue;
                var cuts = [0, 1];
                [bands.good, bands.poor].forEach(function (threshold) {
                    if ((fromValue < threshold && toValue > threshold) || (fromValue > threshold && toValue < threshold)) {
                        cuts.push((threshold - fromValue) / (toValue - fromValue));
                    }
                });
                cuts.sort(function (a, b) { return a - b; });
                for (var cut = 1; cut < cuts.length; cut += 1) {
                    var start = cuts[cut - 1];
                    var end = cuts[cut];
                    var middle = fromValue + (toValue - fromValue) * ((start + end) / 2);
                    ctx.strokeStyle = cruxLineColors[cruxBandForValue(middle, bands)];
                    ctx.beginPath();
                    ctx.moveTo(from.x + (to.x - from.x) * start, from.y + (to.y - from.y) * start);
                    ctx.lineTo(from.x + (to.x - from.x) * end, from.y + (to.y - from.y) * end);
                    ctx.stroke();
                }
            }
            points.forEach(function (point, index) {
                var model = point && point._model;
                var value = Number(values[index]);
                if (!model || model.skip || isNaN(value)) return;
                var color = cruxLineColors[cruxBandForValue(value, bands)];
                ctx.beginPath();
                ctx.arc(model.x, model.y, 2.3, 0, Math.PI * 2);
                ctx.fillStyle = color;
                ctx.fill();
                ctx.lineWidth = 1;
                ctx.strokeStyle = suiteThemeToken('--sto-color-surface', '#fff');
                ctx.stroke();
            });
            ctx.restore();
        }
    };
    if (!Chart.__stoCruxBandsPluginRegistered) {
        Chart.pluginService.register(cruxBandsPlugin);
        Chart.__stoCruxBandsPluginRegistered = true;
    }

    function Controller($scope, $stateParams, $state, $window, $localStorage, $filter, $timeout, ProjectsService,
                        KeywordTrackerService, SeospiderService, SeospiderPagesService, SeospiderBulkExportService, ReportPdfService,
                        SearchConsoleService, TrafficInsightsService, FavIconService,
                        ScreenshotService, SeocheckerService, UserService, $translate, $sce, $interval, SuiteNavigation) {
        var vm = $scope;
        vm.toggleSuiteNavigation = SuiteNavigation.toggle;
        var projectSidebarStorageKey = 'projectWorkspaceSidebarCollapsed';
        vm.projectSidebarCollapsed = $window.localStorage.getItem(projectSidebarStorageKey) === '1';
        vm.toggleProjectSidebar = toggleProjectSidebar;
        var destroyed = false;
        var requestId = 0;
        var overviewTrafficChartInstance = null;
        var sessionRequestId = 0;
        var reportRequestId = 0;
        var sitemapsRequestId = 0;
        var projectStatePrefix = 'app.project.detail.';
        var workspaceId = $localStorage.currentUser && $localStorage.currentUser.workspace && $localStorage.currentUser.workspace.id;
        var projectSidebarIcons = {
            overview: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
            traffic: '<path d="M3 20h18"/><path d="M6 20v-6"/><path d="M11 20V8"/><path d="M16 20v-9"/><path d="M21 20V4"/>',
            issues: '<path d="M12 3 2.5 20h19L12 3z"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
            aeo: '<path d="M12 3v3"/><path d="m5 7 2 2"/><path d="m19 7-2 2"/><rect x="4" y="9" width="16" height="10" rx="3"/><path d="M9 14h.01"/><path d="M15 14h.01"/><path d="M9 18h6"/>',
            history: '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l3 2"/>',
            tracker: '<path d="M3 17 8 12l3 3 7-8"/><path d="M15 7h4v4"/>',
            spider: '<path d="M4 9V5a1 1 0 0 1 1-1h4"/><path d="M15 4h4a1 1 0 0 1 1 1v4"/><path d="M20 15v4a1 1 0 0 1-1 1h-4"/><path d="M9 20H5a1 1 0 0 1-1-1v-4"/><circle cx="12" cy="12" r="2.5"/>',
            table: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M9 9v11"/><path d="M15 9v11"/>',
            links: '<path d="M4 7h14"/><path d="m15 4 3 3-3 3"/><path d="M20 17H6"/><path d="m9 14-3 3 3 3"/>',
            structure: '<rect x="9" y="3" width="6" height="4" rx="1"/><rect x="3" y="17" width="6" height="4" rx="1"/><rect x="15" y="17" width="6" height="4" rx="1"/><path d="M12 7v4"/><path d="M6 17v-2h12v2"/>',
            export: '<path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/>',
            crux: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><path d="m15 9 5-5"/><path d="m9 15-5 5"/>',
            settings: '<path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><circle cx="12" cy="12" r="3"/>'
        };
        var projectSidebarIconCache = {};
        vm.projectSidebarIcon = function (name) {
            if (!projectSidebarIconCache[name]) {
                projectSidebarIconCache[name] = $sce.trustAsHtml(
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                    'stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                    (projectSidebarIcons[name] || '') + '</svg>'
                );
            }
            return projectSidebarIconCache[name];
        };

        function toggleProjectSidebar() {
            vm.projectSidebarCollapsed = !vm.projectSidebarCollapsed;
            $window.localStorage.setItem(projectSidebarStorageKey, vm.projectSidebarCollapsed ? '1' : '0');
        }
        /* Keep the sidebar in sync with the route even when a section view
           reuses its controller while switching between sibling states. */
        $scope.$on('$stateChangeSuccess', function (event, toState) {
            var name = toState && toState.name || '';
            if (name.indexOf(projectStatePrefix) !== 0) return;
            var section = name.slice(projectStatePrefix.length);
            if (section === 'searchConsole') section = 'search-console';
            vm.section = section;
            vm.activeSection = section;
            syncSubOptions();
        });
        /* Same sections as the old SEO Spider, in the same order, plus a few
           generic views. `method` calls a dedicated endpoint, `params` runs the
           generic findAll with the filters of that section. */
        var columnLabelKeys = {
            Page: 'workspace.columnPage',
            Characters: 'workspace.columnCharacters',
            Words: 'workspace.columnWords',
            'Text/code ratio': 'workspace.columnTextCodeRatio',
            Depth: 'workspace.columnDepth',
            'Title tag': 'workspace.columnTitleTag',
            Canonical: 'workspace.columnCanonical',
            Duplicated: 'workspace.columnDuplicated',
            'H1 tag': 'workspace.columnH1Tag',
            Url: 'workspace.columnUrl',
            'H1 multiple': 'workspace.columnH1Multiple',
            'Duplicates in site': 'workspace.columnDuplicatesSite',
            'Duplicates in page': 'workspace.columnDuplicatesPage',
            'H2 tag': 'workspace.columnH2Tag',
            'Meta description': 'workspace.columnMetaDescription',
            Found: 'workspace.columnFound',
            Preview: 'workspace.columnPreview',
            Path: 'workspace.columnPath',
            Alt: 'workspace.columnAlt',
            Snippet: 'workspace.columnSnippet',
            'SEO URL': 'workspace.columnSeoUrl',
            Title: 'workspace.columnTitle',
            Description: 'workspace.columnDescription',
            Image: 'workspace.columnImage',
            Site: 'workspace.columnSite',
            Card: 'workspace.columnCard',
            Taxonomy: 'workspace.columnTaxonomy',
            'Secure page': 'workspace.columnSecurePage',
            Status: 'workspace.columnStatus',
            Origin: 'workspace.columnOrigin',
            Redirect: 'workspace.columnRedirect',
            'Page not found': 'workspace.columnPageNotFound',
            Referrer: 'workspace.columnReferrer',
            Hreflang: 'workspace.columnHreflang',
            Indexable: 'workspace.columnIndexable',
            'Meta robots': 'workspace.columnMetaRobots',
            'Meta Google bot': 'workspace.columnMetaGoogleBot',
            Value: 'workspace.columnValue',
            Images: 'workspace.blockImages',
            'x-Default': 'workspace.columnXDefault',
            Type: 'workspace.columnContentType'
        };
        function localizedColumns(columns) {
            return (columns || []).map(function (column) {
                var copy = Object.assign({}, column);
                copy.label = $translate.instant(columnLabelKeys[column.label] || column.label);
                return copy;
            });
        }
        var PAGE = {label: 'Page', field: 'url', type: 'url'};
        var chars = function (field) { return {label: 'Characters', field: field, type: 'length'}; };
        var CONTENT_FIELDS = ['id', 'url', 'title', 'depth', 'wordCount', 'ratioTextCode'];
        var CONTENT_COLUMNS = [PAGE, {label: 'Words', field: 'wordCount', type: 'number'}, {label: 'Text/code ratio', field: 'ratioTextCode'}, {label: 'Depth', field: 'depth', type: 'number'}];
        vm.spiderViews = [
            {id: 'pages', label: 'All pages', tkey: 'seospider.title.all', method: 'findAll', columns: [PAGE, {label: 'Title tag', field: 'title'}, {label: 'Canonical', field: 'canonical'}], variants: [
                {id: 'duplicated', label: 'Duplicated', tkey: 'seospider.title.duplicate', method: 'findAllPageDuplicated', columns: [PAGE, {label: 'Title tag', field: 'title'}, {label: 'Canonical', field: 'canonical'}, {label: 'Duplicated', field: 'duplicates', type: 'number'}]}
            ]},
            {id: 'title', label: 'Title', method: 'findAllTitle', columns: [PAGE, {label: 'Title tag', field: 'title'}, chars('title')], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.title.all'},
                {id: 'over', label: 'Too long', tkey: 'seospider.title.over', params: {size: 'over'}},
                {id: 'missing', label: 'Missing', tkey: 'seospider.title.missing', params: {missing: true}},
                {id: 'duplicated', label: 'Duplicated', tkey: 'seospider.title.duplicate', method: 'findAllTitleDuplicated', columns: [PAGE, {label: 'Title tag', field: 'title'}, {label: 'Canonical', field: 'canonical'}, {label: 'Duplicated', field: 'duplicates', type: 'number'}]},
                {id: 'multiple', label: 'Multiple', params: {multiple: true}}
            ]},
            {id: 'h1', label: 'H1', method: 'findAllH1', columns: [{label: 'Url', field: 'pageUrl', type: 'url'}, {label: 'H1 tag', field: 'h1'}, chars('h1')], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.h1.all'},
                {id: 'missing', label: 'Missing', tkey: 'seospider.h1.missing', params: {missing: true}},
                {id: 'multiple', label: 'Multiple', tkey: 'seospider.h1.multiple', params: {multiple: true}, columns: [{label: 'Url', field: 'pageUrl', type: 'url'}, {label: 'H1 tag', field: 'h1'}, {label: 'H1 multiple', field: 'pageOccurrences', type: 'number'}]},
                {id: 'duplicated', label: 'Duplicated', tkey: 'seospider.h1.duplicate', method: 'findAllH1Duplicated', columns: [{label: 'Url', field: 'pageUrl', type: 'url'}, {label: 'H1 tag', field: 'h1'}, {label: 'Canonical', field: 'canonical'}, {label: 'Duplicates in site', field: 'duplicates', type: 'number'}, {label: 'Duplicates in page', field: 'occurrences', type: 'number'}]},
                {id: 'over', label: 'Too long', tkey: 'seospider.h1.over', params: {size: 'overDesktop'}}
            ]},
            {id: 'h2', label: 'H2', method: 'findAllH2', columns: [{label: 'Url', field: 'pageUrl', type: 'url'}, {label: 'H2 tag', field: 'h2'}, chars('h2')], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.h2.all'},
                {id: 'missing', label: 'Missing', tkey: 'seospider.h2.missing', params: {missing: true}},
                {id: 'duplicated', label: 'Duplicated', tkey: 'seospider.h2.duplicate', method: 'findAllH2Duplicated', columns: [{label: 'Url', field: 'pageUrl', type: 'url'}, {label: 'H2 tag', field: 'h2'}, {label: 'Canonical', field: 'canonical'}, {label: 'Duplicates in site', field: 'duplicates', type: 'number'}, {label: 'Duplicates in page', field: 'occurrences', type: 'number'}]},
                {id: 'over', label: 'Too long', tkey: 'seospider.h2.over', params: {size: 'overDesktop'}}
            ]},
            {id: 'description', label: 'Meta description', method: 'findAllMetaDescription', columns: [PAGE, {label: 'Meta description', field: 'metaDescription'}, chars('metaDescription'), {label: 'Found', field: 'amount', type: 'number'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.description.all'},
                {id: 'below', label: 'Too short', tkey: 'seospider.description.below', params: {size: 'below'}, columns: [PAGE, {label: 'Meta description', field: 'metaDescription'}, chars('metaDescription'), {label: 'Found', field: 'amount', type: 'number'}]},
                {id: 'over', label: 'Too long', tkey: 'seospider.description.over', params: {size: 'over'}, columns: [PAGE, {label: 'Meta description', field: 'metaDescription'}, chars('metaDescription'), {label: 'Found', field: 'amount', type: 'number'}]},
                {id: 'missing', label: 'Missing', tkey: 'seospider.description.missing', params: {missing: true}, columns: [PAGE, {label: 'Meta description', field: 'metaDescription'}, chars('metaDescription'), {label: 'Found', field: 'amount', type: 'number'}]},
                {id: 'duplicated', label: 'Duplicated', tkey: 'seospider.description.duplicate', method: 'findAllMetaDescriptionDuplicated', columns: [PAGE, {label: 'Meta description', field: 'metaDescription'}, {label: 'Canonical', field: 'canonical'}, {label: 'Duplicated', field: 'duplicates', type: 'number'}]}
            ]},
            {id: 'content', label: 'Text content', params: {fields: CONTENT_FIELDS}, columns: CONTENT_COLUMNS, variants: [
                {id: 'all', label: 'All', tkey: 'seospider.content.all'},
                {id: 'low', label: 'Low text level', tkey: 'seospider.content.low', params: {textLevel: 'low'}},
                {id: 'med', label: 'Medium text level', tkey: 'seospider.content.med', params: {textLevel: 'med'}},
                {id: 'high', label: 'High text level', tkey: 'seospider.content.high', params: {textLevel: 'high'}},
                {id: 'low-ratio', label: 'Low text/code ratio', tkey: 'seospider.content.lowRatio', params: {lowRatio: 'low'}},
                {id: 'high-ratio', label: 'High text/code ratio', tkey: 'seospider.content.highRatio', params: {lowRatio: 'high'}}
            ]},
            {id: 'images', label: 'Images', method: 'findAllImages', columns: [{label: 'Page', field: 'pageUrl', type: 'url'}, {label: 'Preview', field: 'src', type: 'img'}, {label: 'Path', field: 'src', type: 'url'}, {label: 'Alt', field: 'alt'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.images.all'},
                {id: 'missing', label: 'Missing', tkey: 'seospider.images.missing', params: {missing: true}, columns: [{label: 'Page', field: 'pageUrl', type: 'url'}, {label: 'Images', field: 'src', type: 'url'}]},
                {id: 'missing-alt', label: 'Missing alt', tkey: 'seospider.images.missingAlt', params: {missingAlt: true}},
                {id: 'alt-over', label: 'Alt too long', tkey: 'seospider.images.altOver', params: {altSize: 'overDesktop'}}
            ]},
            {id: 'snippets', label: 'Snippets', params: {fields: ['id', 'url', 'metaRobots', 'status', 'title', 'metaDescription', 'contentType', 'wordCount']}, columns: [{label: 'Snippet', field: 'url', type: 'url'}, {label: 'SEO URL', field: 'url', type: 'seourl'}, {label: 'Title', field: 'title'}, {label: 'Description', field: 'metaDescription'}, {label: 'HTTPS', field: 'url', type: 'secure'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.description.all'},
                {id: 'optimized', label: 'Optimized', tkey: 'seospider.snippets.optimized', clientFilter: 'snippet-optimized'},
                {id: 'not-optimized', label: 'Not optimized', tkey: 'seospider.snippets.not-optimized', clientFilter: 'snippet-not-optimized'}
            ]},
            {id: 'opengraph', label: 'Open Graph', params: {fields: ['id', 'url', 'metaOgTitle', 'metaOgDescription', 'metaOgImage', 'metaOgUrl', 'metaOgType', 'metaOgSiteName']}, columns: [{label: 'Opengraph', field: 'url', type: 'url'}, {label: 'og:image', field: 'metaOgImage', type: 'link'}, {label: 'og:url', field: 'metaOgUrl', type: 'link'}, {label: 'og:title', field: 'metaOgTitle'}, {label: 'og:description', field: 'metaOgDescription'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.description.all'},
                {id: 'optimized', label: 'Optimized', tkey: 'seospider.snippets.optimized', clientFilter: 'og-optimized'},
                {id: 'not-optimized', label: 'Not optimized', tkey: 'seospider.snippets.not-optimized', clientFilter: 'og-not-optimized'}
            ]},
            {id: 'twittercard', label: 'Twitter cards', params: {fields: ['id', 'url', 'metaOgTitle', 'metaTwitterTitle', 'metaTwitterDescription', 'metaTwitterImage', 'metaTwitterCard', 'metaTwitterSite']}, columns: [{label: 'Twittercard', field: 'url', type: 'url'}, {label: 'Card', field: 'metaTwitterCard'}, {label: 'Image', field: 'metaTwitterImage', type: 'link'}, {label: 'Site', field: 'metaTwitterSite'}, {label: 'Title', field: 'metaTwitterTitle'}, {label: 'Description', field: 'metaTwitterDescription'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.description.all'},
                {id: 'optimized', label: 'Optimized', tkey: 'seospider.twittercard.optimized', clientFilter: 'tw-optimized'},
                {id: 'not-optimized', label: 'Not optimized', tkey: 'seospider.twittercard.not-optimized', clientFilter: 'tw-not-optimized'}
            ]},
            {id: 'taxonomies', label: 'Taxonomies', method: 'taxonomies', columns: [{label: 'Taxonomy', field: 'taxonomy'}]},
            {id: 'https', label: 'HTTPS', params: {fields: ['id', 'url', 'title']}, columns: [PAGE, {label: 'Secure page', field: 'url', type: 'secure'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.https.all'},
                {id: 'insecure', label: 'Not secure', tkey: 'seospider.https.insecure', params: {https: false}},
                {id: 'secure', label: 'Secure', tkey: 'seospider.https.secure', params: {https: true}}
            ]},
            {id: 'canonical', label: 'Canonical', params: {fields: ['id', 'url', 'title', 'canonical'], status: 200}, columns: [PAGE, {label: 'Canonical', field: 'canonical', type: 'link'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.canonical.all'},
                {id: 'defined', label: 'Defined', tkey: 'seospider.canonical.defined', params: {canonicalMissing: false}},
                {id: 'missing', label: 'Missing', tkey: 'seospider.canonical.withoutCanonical', params: {canonicalMissing: true}}
            ]},
            /* Without a variant this view lists every crawled page, any status:
               the Status Explorer lands on it and filters from there. */
            {id: 'httpstatus', label: 'HTTP status', method: 'findAll', params: {fields: ['id', 'url', 'title', 'status', 'depth'], status: undefined}, columns: [{label: 'Status', field: 'status', type: 'number'}, PAGE, {label: 'Depth', field: 'depth', type: 'number'}], variants: [
                {id: 'all-pages', label: 'All pages', tkey: 'seospider.lang.allPages'},
                {id: 'all', label: '200 OK', tkey: 'seospider.status.found', params: {status: 200}},
                {id: 'redirects', label: 'Redirects', tkey: 'seospider.status.redirect', method: 'findAllRedirect', columns: [{label: 'Status', field: 'status', type: 'number'}, {label: 'Origin', field: 'url', type: 'url'}, {label: 'Redirect', field: 'redirectTo', type: 'link'}, {label: 'Depth', field: 'depth', type: 'number'}]},
                {id: 'errors', label: 'Errors', tkey: 'seospider.status.pageNotFound', method: 'findAllError', columns: [{label: 'Status', field: 'status', type: 'number'}, {label: 'Page not found', field: 'url', type: 'url'}, {label: 'Referrer', field: 'referrer', type: 'link'}, {label: 'Depth', field: 'depth', type: 'number'}]}
            ]},
            {id: 'languages', label: 'Languages', method: 'hreflangs', columns: [PAGE, {label: 'x-Default', field: 'xDefault', type: 'bool'}, {label: 'Hreflang', field: 'founded', type: 'number'}], variants: [
                {id: 'all', label: 'All pages', tkey: 'seospider.lang.allPages'},
                {id: 'missing', label: 'Without hreflang', tkey: 'seospider.lang.withoutHreflang', params: {missing: true}},
                {id: 'no-x-default', label: 'Without x-default', tkey: 'seospider.lang.withoutXDefault', params: {noXDefault: true}}
            ]},
            {id: 'robots', label: 'Robots', params: {fields: ['id', 'url', 'title', 'metaRobots', 'metaGoogleBot']}, columns: [PAGE, {label: 'Indexable', field: 'metaRobots', type: 'indexable'}, {label: 'Noodp', field: 'metaRobots', type: 'noodp'}, {label: 'Noydir', field: 'metaRobots', type: 'noydir'}, {label: 'Meta robots', field: 'metaRobots'}, {label: 'Meta Google bot', field: 'metaGoogleBot'}], variants: [
                {id: 'all', label: 'All', tkey: 'seospider.robots.all'},
                {id: 'noindex', label: 'No index', tkey: 'seospider.robots.NoIndex', params: {noIndex: true}},
                {id: 'noodp', label: 'Noodp', tkey: 'seospider.robots.Noodp', params: {metaRobots: 'noodp'}},
                {id: 'noydir', label: 'Noydir', tkey: 'seospider.robots.Noydir', params: {metaRobots: 'noydir'}}
            ]},
            {id: 'links', label: 'Links', value: 'links', valueLabel: 'Links'},
            {id: 'metaKeywords', label: 'Meta keywords', value: 'metaKeywords', valueLabel: 'Meta keywords'}
        ];
        var spiderViewTkeys = {
            pages: 'workspace.allUrls',
            title: 'workspace.columnTitle',
            description: 'workspace.blockDescription',
            content: 'workspace.blockText',
            images: 'workspace.blockImages',
            snippets: 'workspace.blockSnippets',
            opengraph: 'workspace.blockOpengraph',
            twittercard: 'workspace.blockTwittercard',
            taxonomies: 'workspace.topTaxonomies',
            https: 'workspace.blockHttps',
            canonical: 'workspace.blockCanonical',
            httpstatus: 'workspace.blockStatus',
            languages: 'workspace.blockLanguages',
            robots: 'workspace.blockRobots',
            links: 'workspace.topLinks',
            metaKeywords: 'workspace.blockKeywords'
        };
        vm.spiderViews.forEach(function (view) {
            if (!view.tkey && spiderViewTkeys[view.id]) view.tkey = spiderViewTkeys[view.id];
            (view.variants || []).forEach(function (variant) {
                if (!variant.tkey && variant.id === 'multiple') variant.tkey = 'workspace.variantMultiple';
            });
        });
        var spiderColumnsCache = {key: '', columns: []};
        vm.spiderColumns = function () {
            var config = vm.spiderActiveConfig();
            var sourceColumns = config.columns && config.columns.length ? config.columns
                : [PAGE, {
                    label: config.valueLabel || 'Value',
                    field: config.value || vm.spiderView
                }, {label: 'Status', field: 'status'}];
            var cacheKey = [
                $translate.use(),
                vm.section,
                vm.spiderView,
                vm.explorerItemId,
                vm.linkItemId,
                JSON.stringify(sourceColumns)
            ].join('|');
            if (cacheKey !== spiderColumnsCache.key) {
                spiderColumnsCache = {
                    key: cacheKey,
                    columns: localizedColumns(sourceColumns)
                };
            }
            return spiderColumnsCache.columns;
        };
        function absoluteUrl(row, value) {
            if (!value || typeof value !== 'string') return value;
            if (/^(https?:)?\/\//.test(value)) return value;
            var base = row.pageUrl || row.url;
            if (!base) return value;
            try { return new $window.URL(value, base).href; } catch (err) { return value; }
        }
        vm.spiderCell = function (row, col) {
            var value = col.field ? row[col.field] : null;
            if (col.type === 'length') return value ? String(value).length : '—';
            if (col.type === 'number') return (value === 0 || value) ? value : '—';
            if (col.type === 'count') return Array.isArray(value) ? value.length : '—';
            if (col.type === 'secure') return String(row.url || '').indexOf('https://') === 0 ? 'HTTPS' : 'HTTP';
            if (col.type === 'seourl') {
                try { return /^[a-zA-Z\-/0-9]+$/.test(new $window.URL(value).pathname) ? 'Yes' : 'No'; } catch (err) { return '—'; }
            }
            if (col.type === 'bool') return value ? 'Yes' : 'No';
            if (col.type === 'img') { var img = absoluteUrl(row, value); return img || '—'; }
            if (col.type === 'url' || col.type === 'link') {
                var abs = absoluteUrl(row, value);
                if (typeof abs === 'string' && abs.indexOf('data:') === 0) {
                    var comma = abs.indexOf(',', 5);
                    var semi = abs.indexOf(';', 5);
                    var typeEnd = semi > 5 && (comma < 0 || semi < comma) ? semi : comma;
                    return 'data:' + (typeEnd > 5 ? abs.slice(5, typeEnd) : 'inline') + '…';
                }
                return abs || '—';
            }
            if (col.type === 'indexable') return /noindex/i.test(value || '') ? 'No' : (value ? 'Yes' : '—');
            if (col.type === 'noodp') return /noodp/i.test(value || '') ? 'Yes' : '—';
            if (col.type === 'noydir') return /noydir/i.test(value || '') ? 'Yes' : '—';
            return value || value === 0 ? value : '—';
        };
        vm.spiderCellLink = function (row, col) {
            if (col.type === 'img' || col.type === 'seourl' || col.type === 'bool') return null;
            var value = col.field ? row[col.field] : null;
            if (Array.isArray(value)) { var item = value[0] || {}; return item.path || item.url || null; }
            if (typeof value !== 'string' || !value.length) return null;
            if (value.indexOf('data:') === 0) return null;
            if (col.type === 'url' || col.type === 'link') return absoluteUrl(row, value);
            if (!/^(https?:)?\/\//.test(value)) return null;
            return col.type === 'url' ? absoluteUrl(row, value) : value;
        };
        vm.spiderVariant = null;
        /* A view merged with one of its sub-sections (variant): the merged
           config drives endpoint, params and columns of the table. */
        function mergedConfig(viewId, variantId) {
            var view = vm.spiderViews.filter(function (item) { return item.id === viewId; })[0] || {};
            var variant = (view.variants || []).filter(function (item) { return item.id === variantId; })[0];
            if (!variant) return view;
            var merged = {};
            ['method', 'params', 'columns', 'value', 'valueLabel', 'clientFilter'].forEach(function (key) {
                merged[key] = variant[key] !== undefined ? variant[key] : view[key];
            });
            if (view.params && variant.params) merged.params = Object.assign({}, view.params, variant.params);
            return merged;
        }
        vm.spiderActiveConfig = function () {
            if (vm.section === 'explorer') {
                var item = vm.explorerItem();
                return item ? mergedConfig(item.viewId, item.variantId) : mergedConfig('pages', null);
            }
            if (vm.section === 'links') {
                var link = vm.linkItem();
                /* No filter: every crawled page with its status (200, 3xx, 4xx). */
                return link ? mergedConfig(link.viewId, link.variantId) : mergedConfig('httpstatus', null);
            }
            return mergedConfig(vm.spiderView, vm.spiderVariant);
        };
        vm.spiderVariants = function () {
            var view = vm.spiderViews.filter(function (item) { return item.id === vm.spiderView; })[0];
            return view && view.variants || [];
        };
        /* Sets category and sub-section together, then loads the rows once:
           loading before the variant is known would render stale data. */
        vm.applySpiderRoute = function (category, variant) {
            if (vm.spiderViews.some(function (item) { return item.id === category; })) vm.spiderView = category;
            var known = vm.spiderVariants().filter(function (item) { return item.id === variant; })[0];
            vm.spiderVariant = known ? variant : null;
            syncSubOptions();
            vm.spiderOffset = 0;
            loadSpiderRows();
        };
        vm.selectSpiderVariant = function (variant) { vm.applySpiderRoute(vm.spiderView, variant); };
        vm.spiderVariantLabel = function () {
            var variant = vm.spiderVariants().filter(function (item) { return item.id === vm.spiderVariant; })[0];
            return variant ? variant.label : null;
        };
        /* ---- Page Explorer: one table, the filter picks the audit ----
           Every entry maps to an existing view + sub-section, so labels,
           filters and columns stay identical to the section siblings. */
        var explorerRef = function (viewId, variantId) { return {viewId: viewId, variantId: variantId || null}; };
        var explorerItems = function (refs) {
            return refs.map(function (ref) {
                var view = vm.spiderViews.filter(function (item) { return item.id === ref.viewId; })[0] || {};
                var variant = (view.variants || []).filter(function (item) { return item.id === ref.variantId; })[0] || null;
                return {id: ref.viewId + (ref.variantId ? ':' + ref.variantId : ''), viewId: ref.viewId, variantId: ref.variantId,
                    label: variant ? variant.label : view.label, tkey: variant ? variant.tkey : view.tkey};
            });
        };
        var explorerPagesItems = explorerItems([explorerRef('pages'), explorerRef('pages', 'duplicated')]);
        explorerPagesItems[0].label = 'All URLs';
        explorerPagesItems[0].tkey = 'workspace.allUrls';
        vm.explorerGroups = [
            {id: 'pages', label: 'Pages', tkey: 'workspace.groupPages', blocks: [
                {label: 'Pages', tkey: 'workspace.groupPages', items: explorerPagesItems}
            ]},
            {id: 'headings', label: 'Headings', tkey: 'workspace.groupHeadings', blocks: [
                {label: 'H1', tkey: 'workspace.blockH1', items: explorerItems([explorerRef('h1', 'all'), explorerRef('h1', 'missing'), explorerRef('h1', 'multiple'), explorerRef('h1', 'duplicated'), explorerRef('h1', 'over')])},
                {label: 'H2', tkey: 'workspace.blockH2', items: explorerItems([explorerRef('h2', 'all'), explorerRef('h2', 'missing'), explorerRef('h2', 'duplicated'), explorerRef('h2', 'over')])}
            ]},
            {id: 'content', label: 'Content', tkey: 'workspace.groupContent', blocks: [
                {label: 'Tag Title', tkey: 'workspace.blockTagTitle', items: explorerItems([explorerRef('title', 'all'), explorerRef('title', 'over'), explorerRef('title', 'missing'), explorerRef('title', 'duplicated')])},
                {label: 'Meta description', tkey: 'workspace.blockDescription', items: explorerItems([explorerRef('description', 'all'), explorerRef('description', 'below'), explorerRef('description', 'over'), explorerRef('description', 'missing'), explorerRef('description', 'duplicated')])},
                {label: 'Text', tkey: 'workspace.blockText', items: explorerItems([explorerRef('content', 'all'), explorerRef('content', 'low'), explorerRef('content', 'med'), explorerRef('content', 'high'), explorerRef('content', 'low-ratio'), explorerRef('content', 'high-ratio')])},
                {label: 'Images', tkey: 'workspace.blockImages', items: explorerItems([explorerRef('images', 'all'), explorerRef('images', 'missing'), explorerRef('images', 'missing-alt'), explorerRef('images', 'alt-over')])},
                {label: 'Meta keywords', tkey: 'workspace.blockKeywords', items: explorerItems([explorerRef('metaKeywords')])}
            ]},
            {id: 'preview', label: 'Preview', tkey: 'workspace.groupPreview', blocks: [
                {label: 'Snippets', tkey: 'workspace.blockSnippets', items: explorerItems([explorerRef('snippets', 'all'), explorerRef('snippets', 'optimized'), explorerRef('snippets', 'not-optimized')])},
                {label: 'Opengraph', tkey: 'workspace.blockOpengraph', items: explorerItems([explorerRef('opengraph', 'all'), explorerRef('opengraph', 'optimized'), explorerRef('opengraph', 'not-optimized')])},
                {label: 'Twittercard', tkey: 'workspace.blockTwittercard', items: explorerItems([explorerRef('twittercard', 'all'), explorerRef('twittercard', 'optimized'), explorerRef('twittercard', 'not-optimized')])}
            ]},
            {id: 'structure', label: 'Structure', tkey: 'workspace.groupStructure', blocks: [
                {label: 'HTTPS', tkey: 'workspace.blockHttps', items: explorerItems([explorerRef('https', 'all'), explorerRef('https', 'insecure'), explorerRef('https', 'secure')])},
                {label: 'Canonical', tkey: 'workspace.blockCanonical', items: explorerItems([explorerRef('canonical', 'all'), explorerRef('canonical', 'defined'), explorerRef('canonical', 'missing')])},
                {label: 'Status', tkey: 'workspace.blockStatus', items: explorerItems([explorerRef('httpstatus', 'all'), explorerRef('httpstatus', 'redirects'), explorerRef('httpstatus', 'errors')])},
                {label: 'Languages', tkey: 'workspace.blockLanguages', items: explorerItems([explorerRef('languages', 'all'), explorerRef('languages', 'missing'), explorerRef('languages', 'no-x-default')])},
                {label: 'Robots', tkey: 'workspace.blockRobots', items: explorerItems([explorerRef('robots', 'all'), explorerRef('robots', 'noindex'), explorerRef('robots', 'noodp'), explorerRef('robots', 'noydir')])}
            ]}
        ];
        vm.explorerItems = [];
        vm.explorerGroups.forEach(function (group) {
            group.blocks.forEach(function (block) { vm.explorerItems = vm.explorerItems.concat(block.items); });
        });
        /* Every crawled page is the default view, listed inside Pages. */
        vm.explorerDefaultItemId = 'pages';
        vm.explorerItemId = vm.explorerDefaultItemId;
        vm.explorerOpenGroup = null;
        vm.explorerItem = function () {
            return vm.explorerItems.filter(function (item) { return item.id === vm.explorerItemId; })[0] || null;
        };
        vm.explorerGroupIsActive = function (group) {
            return !!vm.explorerGroupActiveItem(group);
        };
        /* The selected filter of that group, with its block, so its chip can
           read "Content: Tag Title Missing" as soon as it is active. */
        vm.explorerGroupActiveSelection = function (group) {
            var item = vm.explorerItem();
            if (!item) return null;
            var selection = null;
            group.blocks.forEach(function (block) {
                block.items.forEach(function (entry) {
                    if (entry.id === item.id) selection = {block: block, item: entry};
                });
            });
            return selection;
        };
        vm.explorerGroupActiveItem = function (group) {
            var selection = vm.explorerGroupActiveSelection(group);
            return selection && selection.item;
        };
        /* Return a primitive label: a new object on every digest makes the
           ng-if watcher loop forever and leaves the loading skeleton visible. */
        vm.explorerGroupSelectionLabel = function (group) {
            var selection = vm.explorerGroupActiveSelection(group);
            if (!selection || selection.item.id === vm.explorerDefaultItemId) return '';
            var block = selection.block;
            var item = selection.item;
            var blockLabel = group.blocks.length > 1 ?
                $translate.instant(block.tkey || block.label) + ' ' : '';
            return blockLabel + $translate.instant(item.tkey || item.label);
        };
        vm.toggleExplorerGroup = function (group) {
            if (!group) { vm.explorerOpenGroup = null; return; }
            if (vm.explorerOpenGroup === group.id) { vm.explorerOpenGroup = null; return; }
            vm.explorerOpenGroup = group.id;
        };
        vm.selectExplorerItem = function (item) {
            var id = item && item.id || null;
            vm.explorerOpenGroup = null;
            if (id === vm.explorerItemId) return;
            $state.go('app.project.detail.explorer', {projectId: vm.project.id, filter: id});
        };
        /* Page Explorer is its own project section: the filter param picks the
           audit that feeds the single table, so its columns change with it. */
        vm.applyExplorerRoute = function (filter) {
            vm.explorerItemId = vm.explorerItems.some(function (item) { return item.id === filter; }) ? filter : vm.explorerDefaultItemId;
            vm.spiderOffset = 0;
            loadReport();
            buildExplorerCounts();
            loadSpiderRows();
        };
        /* Numbers on the filter chips come from the report API only: one call
           per session (loadReport caches it), then read from its exams. Each
           filter points at the exam arg holding its page count; filters without
           a number in the report simply show none. */
        var explorerCountSources = {
            'pages': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'pages:duplicated': {section: 'duplicated', exam: 'pagesDuplicated', arg: 0},
            'title:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'title:over': {section: 'base', exam: 'titleOversize', arg: 0},
            'title:missing': {section: 'base', exam: 'titleMissing', arg: 0},
            'title:duplicated': {section: 'duplicated', exam: 'titleDuplicated', arg: 0},
            'description:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'description:below': {section: 'base', exam: 'metaDescriptionBelowsize', arg: 0},
            'description:over': {section: 'base', exam: 'metaDescriptionOversize', arg: 0},
            'description:missing': {section: 'base', exam: 'metaDescriptionMissing', arg: 0},
            'description:duplicated': {section: 'duplicated', exam: 'metaDescriptionDuplicated', arg: 0},
            'content:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'content:low': {section: 'content', exam: 'pagesTextLevelLow', arg: 0},
            'content:low-ratio': {section: 'structure', exam: 'textCodeRatio', arg: 1},
            'h1:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'h1:missing': {section: 'content', exam: 'h1Missing', arg: 0},
            'h1:multiple': {section: 'content', exam: 'h1Multiple', arg: 0},
            'h1:duplicated': {section: 'duplicated', exam: 'h1Duplicated', arg: 0},
            'h1:over': {section: 'content', exam: 'h1Oversize', arg: 0},
            'h2:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'h2:missing': {section: 'content', exam: 'h2Missing', arg: 0},
            'h2:duplicated': {section: 'duplicated', exam: 'h2Duplicated', arg: 0},
            'h2:over': {section: 'content', exam: 'h2Oversize', arg: 0},
            'images:missing-alt': {section: 'structure', exam: 'imgMissAlt', arg: 0},
            'images:alt-over': {section: 'structure', exam: 'imgOversizeAlt', arg: 0},
            'opengraph:not-optimized': {section: 'social', exam: 'opengraphIncomplete', arg: 0},
            'twittercard:not-optimized': {section: 'social', exam: 'twittercardIncomplete', arg: 0},
            'snippets:not-optimized': {section: 'base', exam: 'optimizedGoogleSnippet', arg: 0},
            'httpstatus:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'httpstatus:errors': {section: 'structure', exam: 'pagesNotFound', arg: 0},
            'canonical:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'canonical:missing': {section: 'base', exam: 'canonical', arg: 0},
            'robots:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'https:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'https:insecure': {section: 'structure', exam: 'httpsMigration', arg: 0},
            'languages:all': {section: 'duplicated', exam: 'pagesDuplicated', arg: 1},
            'languages:missing': {section: 'base', exam: 'hreflangMissing', arg: 0},
            'languages:no-x-default': {section: 'base', exam: 'noXDefault', arg: 0}
        };
        function buildExplorerCounts() {
            vm.explorerItems.forEach(function (item) {
                var source = explorerCountSources[item.id];
                var value = null;
                var section = source && vm.report && vm.report[source.section];
                var exam = section && section.exams && section.exams[source.exam];
                var preview = exam && exam.preview && exam.preview[0];
                var arg = preview && preview.args && preview.args[source.arg];
                /* The API may deliver the counters as numbers or as numeric strings. */
                if (arg && arg.value !== null && arg.value !== '' && !isNaN(arg.value)) value = Number(arg.value);
                item.count = value;
            });
        }
        function spiderRequestFor(config, params, fallbackCategory) {
            if (config.method && SeospiderPagesService[config.method]) return SeospiderPagesService[config.method](params);
            if (config.params) return SeospiderPagesService.findAll(params);
            return SeospiderPagesService.workspaceCategory(fallbackCategory, params);
        }
        /* ---- Status Explorer: the crawl status lens (200 / 3xx / 4xx + links). ---- */
        vm.linkGroups = [
            {id: 'link-analysis', label: 'Status', tkey: 'workspace.blockStatus', blocks: [
                {label: 'Status', tkey: 'workspace.blockStatus', items: explorerItems([explorerRef('httpstatus', 'all-pages'), explorerRef('httpstatus', 'all'), explorerRef('httpstatus', 'redirects'), explorerRef('httpstatus', 'errors')])}
            ]},
        ];
        vm.linkItems = [];
        vm.linkGroups.forEach(function (group) {
            group.blocks.forEach(function (block) { vm.linkItems = vm.linkItems.concat(block.items); });
        });
        vm.linkItemId = null;
        vm.linkOpenGroup = null;
        vm.linkItem = function () {
            return vm.linkItems.filter(function (item) { return item.id === vm.linkItemId; })[0] || null;
        };
        vm.linkGroupActiveItem = function (group) {
            var item = vm.linkItem();
            if (!item) return null;
            var match = null;
            group.blocks.forEach(function (block) {
                block.items.forEach(function (entry) { if (entry.id === item.id) match = entry; });
            });
            return match;
        };
        vm.linkGroupIsActive = function (group) { return !!vm.linkGroupActiveItem(group); };
        vm.toggleLinkGroup = function (group) {
            if (!group) { vm.linkOpenGroup = null; return; }
            vm.linkOpenGroup = vm.linkOpenGroup === group.id ? null : group.id;
        };
        vm.selectLinkItem = function (item) {
            var id = item && item.id || null;
            vm.linkOpenGroup = null;
            if (id === vm.linkItemId) return;
            $state.go('app.project.detail.links', {projectId: vm.project.id, filter: id});
        };
        vm.applyLinkRoute = function (filter) {
            vm.linkItemId = vm.linkItems.some(function (item) { return item.id === filter; }) ? filter : null;
            vm.spiderOffset = 0;
            loadSpiderRows();
        };
        /* Status at a glance: the three numbers come from the crawl session
           (same source as the charts below), and each card filters the table. */
        vm.linkStatusCounts = function () {
            var counts = {found: 0, redirect: 0, error: 0};
            var codes = (vm.crawlSession && vm.crawlSession.codes) || [];
            codes.forEach(function (code) {
                var status = Number(code && code.status);
                var value = Number(code && code.count) || 0;
                if (status >= 200 && status < 300) counts.found += value;
                else if (status >= 300 && status < 400) counts.redirect += value;
                else if (status >= 400) counts.error += value;
            });
            return counts;
        };
        vm.linkStatusFilter = function (key) {
            var id = {found: 'httpstatus:all', redirect: 'httpstatus:redirects', error: 'httpstatus:errors'}[key];
            var item = vm.linkItems.filter(function (entry) { return entry.id === id; })[0];
            if (item) vm.selectLinkItem(item);
        };
        vm.linkStatusIsActive = function (key) {
            return vm.linkItemId === {found: 'httpstatus:all', redirect: 'httpstatus:redirects', error: 'httpstatus:errors'}[key];
        };
        /* HTTP status of a crawled page, coloured like the other status signals. */
        vm.statusBadgeClass = function (value) {
            var status = Number(value);
            if (!status) return '';
            if (status >= 200 && status < 300) return 'is-found';
            if (status >= 300 && status < 400) return 'is-redirect';
            if (status >= 400) return 'is-error';
            return '';
        };
        /* ---- Bulk export: one catalogue for every Page/Status Explorer view. ---- */
        vm.bulkExportGroups = [
            {id: 'page-explorer', label: 'Page Explorer', tkey: 'workspace.pageExplorer', groups: vm.explorerGroups},
            {id: 'status-explorer', label: 'Status Explorer', tkey: 'workspace.statusExplorer', groups: vm.linkGroups}
        ];
        /* The old section headings disappear here: every block becomes its own
           category (H1, H2, Tag Title...). Status is shared by both explorers,
           so the richer Status Explorer block replaces the Page Explorer one. */
        var bulkExportStatusBlock = null;
        vm.linkGroups.forEach(function (group) {
            group.blocks.forEach(function (block, index) {
                if (!bulkExportStatusBlock) {
                    bulkExportStatusBlock = {group: group, block: block, index: index};
                }
            });
        });
        vm.bulkExportCategories = [];
        vm.bulkExportGroups.forEach(function (section) {
            if (section.id === 'status-explorer') return;
            section.groups.forEach(function (group) {
                group.blocks.forEach(function (block, index) {
                    if (section.id === 'page-explorer' && block.tkey === 'workspace.blockStatus' && bulkExportStatusBlock) {
                        vm.bulkExportCategories.push({
                            id: 'status-explorer:' + bulkExportStatusBlock.group.id + ':' + bulkExportStatusBlock.index,
                            label: bulkExportStatusBlock.block.label,
                            tkey: bulkExportStatusBlock.block.tkey,
                            items: bulkExportStatusBlock.block.items,
                            sourceId: 'status-explorer'
                        });
                        return;
                    }
                    vm.bulkExportCategories.push({
                        id: section.id + ':' + group.id + ':' + index,
                        label: block.label,
                        tkey: block.tkey,
                        items: block.items,
                        sourceId: section.id
                    });
                });
            });
        });
        vm.bulkExportSelected = {};
        var bulkExportAllFoundLabels = {
            title: 'workspace.bulkExportAllTitle',
            h1: 'workspace.bulkExportAllH1',
            h2: 'workspace.bulkExportAllH2',
            description: 'workspace.bulkExportAllDescription',
            snippets: 'workspace.bulkExportAllSnippets',
            opengraph: 'workspace.bulkExportAllOpengraph',
            twittercard: 'workspace.bulkExportAllTwittercard',
            canonical: 'workspace.bulkExportAllCanonical',
            robots: 'workspace.bulkExportAllRobots'
        };
        vm.bulkExportItemTkey = function (item) {
            if (item && item.variantId === 'all' && bulkExportAllFoundLabels[item.viewId]) {
                return bulkExportAllFoundLabels[item.viewId];
            }
            return item && (item.tkey || item.label) || '';
        };
        vm.bulkExportKey = function (sectionId, item) {
            return sectionId + '|' + item.id;
        };
        vm.bulkExportSelectedCount = function () {
            return Object.keys(vm.bulkExportSelected).filter(function (key) {
                return vm.bulkExportSelected[key];
            }).length;
        };
        vm.bulkExportAllSelected = function () {
            var total = 0;
            var selected = 0;
            vm.bulkExportCategories.forEach(function (category) {
                category.items.forEach(function (item) {
                    total += 1;
                    if (vm.bulkExportSelected[vm.bulkExportKey(category.sourceId, item)]) selected += 1;
                });
            });
            return total > 0 && selected === total;
        };
        vm.toggleBulkExportSelection = function (event) {
            var select = event && event.target ? !!event.target.checked : !vm.bulkExportAllSelected();
            vm.bulkExportCategories.forEach(function (category) {
                category.items.forEach(function (item) {
                    var key = vm.bulkExportKey(category.sourceId, item);
                    vm.bulkExportSelected[key] = select;
                });
            });
        };
        vm.bulkExportCategoryAllSelected = function (category) {
            if (!category.items.length) return false;
            var selected = 0;
            category.items.forEach(function (item) {
                if (vm.bulkExportSelected[vm.bulkExportKey(category.sourceId, item)]) selected++;
            });
            return selected === category.items.length;
        };
        vm.toggleBulkExportCategory = function (category, event) {
            var select = event && event.target ? !!event.target.checked : !vm.bulkExportCategoryAllSelected(category);
            category.items.forEach(function (item) {
                vm.bulkExportSelected[vm.bulkExportKey(category.sourceId, item)] = select;
            });
        };
        vm.clearBulkExportSelection = function () {
            Object.keys(vm.bulkExportSelected).forEach(function (key) {
                vm.bulkExportSelected[key] = false;
            });
        };
        vm.bulkExport = {
            running: false, cancelling: false, error: false, itemId: null,
            name: '', loaded: 0, total: 0, token: null, success: null
        };
        function bulkExportLabel(item) {
            return $translate.instant(vm.bulkExportItemTkey(item));
        }
        vm.bulkExportCanRun = function () {
            return !!vm.form.sessionId && !vm.bulkExport.running;
        };
        vm.bulkExportZipAllowed = function () {
            return vm.bulkExportCanRun()
                && vm.bulkExportSelectedCount() > 0;
        };
        function bulkExportEntry(sectionId, item) {
            var config = mergedConfig(item.viewId, item.variantId);
            var clientFilter = config.clientFilter && clientFilters[config.clientFilter];
            var label = bulkExportLabel(item);
            var projectLabel = String(vm.url || (vm.project && vm.project.name) || 'project').replace(/^https?:\/\//, '');
            return {
                name: label,
                fileName: projectLabel + ' - ' + label,
                load: function (offset, limit) {
                    var params = {jobId: vm.form.sessionId, offset: offset, limit: limit};
                    Object.keys(config.params || {}).forEach(function (key) {
                        params[key] = config.params[key];
                    });
                    return spiderRequestFor(config, params, item.viewId || 'pages').then(function (response) {
                        return {
                            data: response && Array.isArray(response.data) ? response.data : [],
                            totalRows: response && response.totalRows
                        };
                    });
                },
                transform: clientFilter ? function (rows) { return rows.filter(clientFilter); } : null
            };
        }
        function bulkExportProgress(loaded, total) {
            vm.bulkExport.loaded = loaded;
            if (typeof total === 'number' && isFinite(total)) {
                vm.bulkExport.total = total;
            }
        }
        function startBulkExport(itemId, name, total) {
            var token = {cancelled: false};
            vm.bulkExport.running = true;
            vm.bulkExport.cancelling = false;
            vm.bulkExport.error = false;
            vm.bulkExport.success = null;
            vm.bulkExport.itemId = itemId;
            vm.bulkExport.name = name;
            vm.bulkExport.loaded = 0;
            vm.bulkExport.total = total || 0;
            vm.bulkExport.token = token;
            return token;
        }
        function finishBulkExport(token, error, success) {
            if (vm.bulkExport.token !== token) return;
            if (error && !error.cancelled) vm.bulkExport.error = true;
            if (!error && success) vm.bulkExport.success = success;
            vm.bulkExport.running = false;
            vm.bulkExport.cancelling = false;
            vm.bulkExport.itemId = null;
            vm.bulkExport.token = null;
        }
        vm.cancelBulkExport = function () {
            if (!vm.bulkExport.running || !vm.bulkExport.token) return;
            vm.bulkExport.cancelling = true;
            vm.bulkExport.token.cancelled = true;
        }
        vm.exportBulkItem = function (sectionId, item) {
            if (!vm.bulkExportCanRun()) return;
            var entry = bulkExportEntry(sectionId, item);
            var token = startBulkExport(item.id, entry.name);
            return SeospiderBulkExportService.exportCsv(entry, bulkExportProgress, token)
                .then(function () { finishBulkExport(token, null, entry.name); })
                .catch(function (error) { finishBulkExport(token, error); });
        };
        vm.exportXlsxItem = function (sectionId, item) {
            if (!vm.bulkExportCanRun()) return;
            var entry = bulkExportEntry(sectionId, item);
            var token = startBulkExport(item.id, entry.name);
            return SeospiderBulkExportService.exportXlsx(entry, bulkExportProgress, token)
                .then(function () { finishBulkExport(token, null, entry.name); })
                .catch(function (error) { finishBulkExport(token, error); });
        };
        vm.exportSelectedBulk = function () {
            if (!vm.bulkExportZipAllowed()) return;
            var entries = [];
            vm.bulkExportCategories.forEach(function (category) {
                category.items.forEach(function (item) {
                    if (vm.bulkExportSelected[vm.bulkExportKey(category.sourceId, item)]) {
                        entries.push(bulkExportEntry(category.sourceId, item));
                    }
                });
            });
            var projectLabel = String(vm.url || (vm.project && vm.project.name) || 'project').replace(/^https?:\/\//, '');
            var token = startBulkExport(null, $translate.instant('workspace.bulkExportAll'), entries.length);
            return SeospiderBulkExportService.exportZip(entries, projectLabel + ' - SEO Spider', function (progress) {
                vm.bulkExport.name = progress.name || vm.bulkExport.name;
                vm.bulkExport.loaded = progress.index + 1;
                vm.bulkExport.total = progress.count;
            }, token).then(function () { finishBulkExport(token, null, $translate.instant('workspace.bulkExportAll')); })
                .catch(function (error) { finishBulkExport(token, error); });
        };
        /* ---- Structure explorer: URL tree with the depth distribution. ---- */
        var structureDepthBuckets = [
            {id: '0', label: 'Home', tkey: 'workspace.depth0', color: '#1e88e5'},
            {id: '1', label: '1 click', tkey: 'workspace.depth1', color: '#42a5f5'},
            {id: '2', label: '2 clicks', tkey: 'workspace.depth2', color: '#90caf9'},
            {id: '3', label: '3 clicks', tkey: 'workspace.depth3', color: '#c5e1fb'},
            {id: 'other', label: '4+ clicks', tkey: 'workspace.depthOther', color: '#e8f3fe'}
        ];
        var structureExpanded = {};
        var structureTree = [];
        vm.structureHintOpen = true;
        vm.structureLoading = false;
        vm.structureError = false;
        vm.structureMissing = false;
        vm.structureTruncated = false;
        vm.structureMaxPages = 3000;
        vm.structureNodes = [];
        vm.structureBuckets = function () { return structureDepthBuckets; };
        vm.isStructureExpanded = function (node) { return !!structureExpanded[node.key]; };
        vm.toggleStructureNode = function (node) {
            if (!node.children.length) return;
            structureExpanded[node.key] = !structureExpanded[node.key];
        };
        /* Rows are always in the DOM and only hidden: removing them would wait
           for an Angular animation that never completes in this app. */
        vm.isStructureRowVisible = function (node) {
            var parent = node.parent;
            while (parent) {
                if (!structureExpanded[parent.key]) return false;
                parent = parent.parent;
            }
            return true;
        };
        vm.structureSegments = function (node) {
            if (node.structureSegments) return node.structureSegments;
            var counts = node.counts.depth || {};
            node.structureSegments = structureDepthBuckets.map(function (bucket) {
                return {pct: node.total ? ((counts[bucket.id] || 0) / node.total) * 100 : 0, color: bucket.color, label: bucket.label + ': ' + (counts[bucket.id] || 0)};
            }).filter(function (segment) { return segment.pct > 0; });
            return node.structureSegments;
        };
        vm.openStructureExplorer = function () { loadStructure(); };
        function structureNode(key, label, depth) {
            return {key: key, label: label, depth: depth, total: 0, counts: {}, children: [], map: {}};
        }
        function structureChild(parent, key, label, depth) {
            if (!parent.map[key]) {
                var child = structureNode(key, label, depth);
                child.parent = parent;
                parent.children.push(child);
                parent.map[key] = child;
            }
            return parent.map[key];
        }
        function pageUrlParts(url) {
            if (!url) return null;
            try {
                var parsed = new $window.URL(url);
                return {host: parsed.hostname, segments: parsed.pathname.split('/').filter(function (part) { return !!part; })};
            } catch (err) {
                var match = String(url).match(/^[a-z]+:\/\/([^/]+)(\/.*)?$/i);
                if (!match) return null;
                return {host: match[1], segments: (match[2] || '').split('/').filter(function (part) { return !!part; })};
            }
        }
        function structureDepthBucket(page) {
            var depth = Number(page.depth);
            if (isNaN(depth)) return 'other';
            return depth <= 3 ? String(depth) : 'other';
        }
        function countStructurePage(node, page) {
            node.total++;
            node.counts.depth = node.counts.depth || {};
            var bucket = structureDepthBucket(page);
            node.counts.depth[bucket] = (node.counts.depth[bucket] || 0) + 1;
        }
        function buildStructureTree(pages) {
            var roots = {};
            structureTree = [];
            pages.forEach(function (page) {
                var parts = pageUrlParts(page.url);
                if (!parts) return;
                if (!roots[parts.host]) {
                    roots[parts.host] = structureNode(parts.host, parts.host, 0);
                    structureTree.push(roots[parts.host]);
                    structureExpanded[parts.host] = true;
                }
                var node = roots[parts.host];
                countStructurePage(node, page);
                var path = '';
                parts.segments.forEach(function (segment, index) {
                    path += '/' + segment;
                    node = structureChild(node, path, '/' + segment, index + 1);
                    countStructurePage(node, page);
                });
            });
            var byTotal = function (a, b) { return b.total - a.total || a.label.localeCompare(b.label); };
            structureTree.sort(byTotal);
            (function sortChildren(nodes) {
                nodes.forEach(function (node) { node.children.sort(byTotal); sortChildren(node.children); });
            }(structureTree));
            refreshStructureRows();
        }
        /* Flat list in tree order: visibility is computed per row, so the DOM
           never has to remove nodes when a folder is collapsed. */
        function refreshStructureRows() {
            var rows = [];
            structureTree.forEach(function (node) {
                (function walk(current) {
                    rows.push(current);
                    current.children.forEach(walk);
                }(node));
            });
            vm.structureNodes = rows;
        }
        function loadStructure() {
            if (!vm.project) return;
            var sessionId = vm.form.sessionId || (vm.project.crawlerSession && vm.project.crawlerSession.id) || null;
            if (!sessionId) { vm.structureMissing = true; return; }
            if (vm.structureLoading || vm.structureLoadedFor === sessionId) return;
            vm.structureLoading = true;
            vm.structureError = false;
            vm.structureMissing = false;
            var fields = ['id', 'url', 'status', 'depth', 'contentType', 'metaRobots'];
            var pages = [];
            var batch = 500;
            function fetchBatch(offset) {
                return SeospiderPagesService.findAll({jobId: sessionId, offset: offset, limit: batch, fields: fields, ignoreLoadingBar: true})
                    .then(function (response) {
                        var rows = response && Array.isArray(response.data) ? response.data : [];
                        pages = pages.concat(rows);
                        var total = Number(response && response.totalRows) || pages.length;
                        vm.structureTruncated = total > pages.length;
                        if (rows.length && pages.length < Math.min(total, vm.structureMaxPages)) return fetchBatch(offset + rows.length);
                        return null;
                    });
            }
            fetchBatch(0).then(function () {
                if (destroyed) return;
                buildStructureTree(pages);
                vm.structureLoadedFor = sessionId;
            }).catch(function () { if (!destroyed) vm.structureError = true; })
                .finally(function () { if (!destroyed) vm.structureLoading = false; });
        }
        vm.reportVerdict = function () {
            var score = vm.reportScores && vm.reportScores.score;
            if (score >= 90) return $translate.instant('workspace.verdictExcellent');
            if (score >= 76) return $translate.instant('workspace.verdictGreat');
            if (score >= 60) return $translate.instant('workspace.verdictGood');
            return $translate.instant('workspace.verdictPoor');
        };
        vm.spiderViewConfig = function () {
            return vm.spiderActiveConfig();
        };
        vm.gscViews = [
            {id: 'query', label: 'Queries', tkey: 'workspace.gscViewQueries'},
            {id: 'page', label: 'Pages', tkey: 'workspace.gscViewPages'},
            {id: 'country', label: 'Countries', tkey: 'workspace.gscViewCountries'},
            {id: 'device', label: 'Devices', tkey: 'workspace.gscViewDevices'},
            {id: 'searchAppearance', label: 'Search appearance', tkey: 'workspace.gscFilterSearchAppearance'},
            {id: 'settings', label: 'Settings', tkey: 'workspace.gscViewSettings'}
        ];
        vm.reportSections = [
            {id: 'overview', label: 'Overview', tkey: 'seospider.overview', hint: 'Score, key metrics and website preview.'},
            {id: 'base', label: 'Base', tkey: 'seospider.base', hint: 'Core page settings: URLs, status codes and redirects.'},
            {id: 'structure', label: 'Structure', tkey: 'seospider.structure', hint: 'Headings and information architecture of the pages.'},
            {id: 'content', label: 'Content', tkey: 'seospider.content', hint: 'Titles, meta descriptions and on-page copy.'},
            {id: 'duplicated', label: 'Duplicated', tkey: 'seospider.duplicated', hint: 'Pages that repeat the same content.'},
            {id: 'social', label: 'Social', tkey: 'seospider.social', hint: 'Open Graph and Twitter card markup.'},
            {id: 'aeo', label: 'AI Agent Report', tkey: 'workspace.aeo', hint: 'Agent readiness and AI discovery checks.'}
        ];
        vm.reportOptions = vm.reportSections.map(function (item) { return {value: item.id, label: item.tkey}; });
        /* Compact section picker used on narrow screens: section first, its views second. */
        vm.sectionOptions = [
            {id: 'overview', label: 'Overview', tkey: 'workspace.overview', state: 'app.project.detail.overview'},
            {id: 'traffic', label: 'Traffic Insights', tkey: 'workspace.trafficInsights', state: 'app.project.detail.traffic'},
            {id: 'issues', label: 'Issues', tkey: 'workspace.issues', state: 'app.project.detail.issues'},
            {id: 'aeo', label: 'AI Agent Report', tkey: 'workspace.aeo', state: 'app.project.detail.aeo'},
            {id: 'log', label: 'Scan log', tkey: 'workspace.scanLog', state: 'app.project.detail.log'},
            /* Hidden from the menus for now: the Report page stays reachable by URL. */
            {id: 'report', label: 'Report', tkey: 'workspace.report', state: 'app.project.detail.report', hidden: true},
            {id: 'tracker', label: 'Rank Tracker', tkey: 'workspace.rankTracker', state: 'app.project.detail.tracker'},
            /* Hidden from the menus for now: Page Explorer covers crawl exploration. */
            {id: 'spider', label: 'SEO Spider', tkey: 'workspace.seoSpider', state: 'app.project.detail.spider', hidden: true},
            {id: 'explorer', label: 'Page Explorer', tkey: 'workspace.pageExplorer', state: 'app.project.detail.explorer'},
            {id: 'links', label: 'Status Explorer', tkey: 'workspace.statusExplorer', state: 'app.project.detail.links'},
            {id: 'structure', label: 'Structure Explorer', tkey: 'workspace.structureExplorer', state: 'app.project.detail.structure'},
            {id: 'export', label: 'Bulk export', tkey: 'workspace.bulkExport', state: 'app.project.detail.export'},
            {id: 'crux', label: 'CRUX', tkey: 'workspace.crux', state: 'app.project.detail.crux'},
            {id: 'search-console', label: 'Search Console', tkey: 'workspace.searchConsole', state: 'app.project.detail.searchConsole'},
            {id: 'sitemaps', label: 'Sitemap', tkey: 'workspace.sitemap', state: 'app.project.detail.sitemaps'}
        ];
        vm.showSpiderSection = false;
        vm.sectionSubOptions = [];
        vm.subSection = null;
        vm.variantOptions = [];
        vm.variantValue = null;
        var reportGroups = ['base', 'content', 'structure', 'duplicated', 'social', 'aeo'];
        /* Previous-report comparisons stay on the crawl categories: AEO is a
           live site audit and is not tied to the crawl history. */
        var comparisonGroups = ['base', 'content', 'structure', 'duplicated', 'social'];
        var issueReportGroups = reportGroups;
        /* AEO contributes 25% of the overall score; the five SEO categories
           share the remaining 75%. */
        var reportGroupWeights = {base: 0.15, content: 0.15, structure: 0.15, duplicated: 0.15, social: 0.15, aeo: 0.25};
        var issueGroupLabels = {aeo: 'workspace.aeo'};
        vm.section = 'overview';
        vm.activeSection = (function () {
            var name = $state.current && $state.current.name || '';
            var prefix = 'app.project.detail.';
            if (name.indexOf(prefix) !== 0) return 'overview';
            var section = name.slice(prefix.length);
            return section === 'searchConsole' ? 'search-console' : section;
        }());
        vm.spiderView = 'pages';
        vm.gscView = 'query';
        vm.reportSection = 'overview';
        vm.reportConfiguration = null;
        vm.reportLoading = false;
        vm.reportError = false;
        vm.reportMissing = false;
        vm.reportExams = [];
        vm.previews = {desktop: null, mobile: null, loading: false};
        /* ---- CRUX: Core Web Vitals sul campo per l'URL del progetto. ---- */
        vm.crux = {loading: false, error: false, loadedFor: null, data: null, raw: null, strategy: 'mobile', page: '', scope: '', extra: [], resourceType: null, lcpParts: []};
        vm.cruxPages = {
            loading: false,
            loadedFor: null,
            rows: [],
            total: 0,
            pageIndex: 0,
            pageSize: 20,
            pageCount: 0,
            rangeStart: 0,
            rangeEnd: 0,
            requestId: 0
        };
        vm.cruxTable = {loading: false, error: false, rows: [], loadedFor: null, requestId: 0};
        vm.cruxStrategies = [
            {id: 'mobile', key: 'workspace.cruxMobile'},
            {id: 'desktop', key: 'workspace.cruxDesktop'}
        ];
        vm.setCruxStrategy = function (id) {
            vm.crux.strategy = id;
            rebuildCruxPanels();
            buildCruxChart();
            vm.cruxTable.loadedFor = null;
            if (vm.cruxPages.rows.length) loadCruxTable();
        };
        function cruxMetric(key, name, value, unit, digits, category, good, poor) {
            return {key: key, name: name, value: value, unit: unit, digits: digits, category: category, good: good, poor: poor};
        }
        function cruxNumber(value) {
            if (value === null || value === undefined || value === '') return null;
            var number = Number(value);
            return isNaN(number) ? null : number;
        }
        /* La CrUX API può non restituire la categoria: la deriviamo dalle soglie. */
        function cruxCategory(category, value, fastMax, slowMin) {
            var normalized = String(category || '').toUpperCase();
            if (normalized === 'FAST' || normalized === 'AVERAGE' || normalized === 'SLOW') return normalized;
            if (value === null) return null;
            if (value <= fastMax) return 'FAST';
            if (value <= slowMin) return 'AVERAGE';
            return 'SLOW';
        }
        function buildCrux(cruxData) {
            var out = {mobile: [], desktop: []};
            ['mobile', 'desktop'].forEach(function (strategy) {
                var cwv = cruxData && cruxData[strategy];
                if (!cwv) return;
                var lcp = cruxNumber(cwv.lcp && cwv.lcp.percentile);
                var cls = cruxNumber(cwv.cls && cwv.cls.percentile);
                var inp = cruxNumber(cwv.inp && cwv.inp.percentile);
                var fid = cruxNumber(cwv.fid && cwv.fid.percentile);
                /* INP è il metrica di interattività attuale; FID resta il fallback. */
                var interaction = inp !== null
                    ? cruxMetric('INP', $translate.instant('workspace.cruxMetricInp'), inp, 'ms', 0, cruxCategory(cwv.inp && cwv.inp.category, inp, 200, 500), '200ms', '500ms')
                    : cruxMetric('FID', $translate.instant('workspace.cruxMetricFid'), fid, 'ms', 0, cruxCategory(cwv.fid && cwv.fid.category, fid, 100, 300), '100ms', '300ms');
                var lcpValue = lcp === null ? null : lcp / 1000;
                var clsValue = cls === null ? null : (cls > 1 ? cls / 100 : cls);
                out[strategy] = [
                    cruxMetric('LCP', $translate.instant('workspace.cruxMetricLcp'), lcpValue, 's', 1, cruxCategory(cwv.lcp && cwv.lcp.category, lcpValue, 2.5, 4), '2.5s', '4s'),
                    interaction,
                    /* La CrUX API restituisce CLS come frazione; la PageSpeed come ×100. */
                    cruxMetric('CLS', $translate.instant('workspace.cruxMetricCls'), clsValue, '', 2, cruxCategory(cwv.cls && cwv.cls.category, clsValue, 0.1, 0.25), '0.1', '0.25')
                ];
            });
            return out;
        }
        function loadCrux() {
            var cruxUrl = vm.url || (vm.project && vm.project.url) || '';
            if (!cruxUrl || vm.crux.loading) return;
            var page = vm.crux.page || '';
            var cacheKey = cruxUrl + '|' + page;
            if (vm.crux.loadedFor === cacheKey && vm.crux.data) return;
            vm.crux.loading = true;
            vm.crux.error = false;
            SeocheckerService.crux(cruxUrl, page).then(function (res) {
                vm.crux.scope = res && res.scope || '';
                vm.crux.raw = res;
                vm.crux.data = buildCrux(res);
                rebuildCruxPanels();
                vm.crux.loadedFor = cacheKey;
            }).catch(function () { vm.crux.error = true; })
                .finally(function () { vm.crux.loading = false; });
        }
        vm.loadCruxPage = function () {
            vm.crux.loadedFor = null;
            loadCrux();
            loadCruxHistory();
        };
        vm.selectCruxPage = function (row) {
            if (!row) return;
            vm.crux.page = row.url;
            vm.loadCruxPage();
        };
        function setCruxPagesRange() {
            var total = vm.cruxPages.total;
            vm.cruxPages.rangeStart = total ? vm.cruxPages.pageIndex * vm.cruxPages.pageSize + 1 : 0;
            vm.cruxPages.rangeEnd = total
                ? Math.min(total, vm.cruxPages.rangeStart + vm.cruxPages.pageSize - 1)
                : 0;
        }
        /* Pagine del crawl corrente: una sola pagina di 20 URL alla volta. */
        function loadCruxPages(force) {
            var sessionId = vm.form.sessionId || (vm.project && vm.project.crawlerSession && vm.project.crawlerSession.id) || null;
            if (!sessionId) return;
            var cacheKey = sessionId + '|' + vm.cruxPages.pageIndex;
            if (!force && vm.cruxPages.loadedFor === cacheKey && vm.cruxPages.rows.length) {
                loadCruxTable();
                return;
            }
            var requestId = ++vm.cruxPages.requestId;
            if (vm.cruxPages.loadedFor && vm.cruxPages.loadedFor.split('|')[0] !== String(sessionId)) {
                vm.cruxPages.pageIndex = 0;
                cacheKey = sessionId + '|0';
            }
            vm.cruxPages.loading = true;
            vm.cruxPages.loadedFor = cacheKey;
            vm.cruxPages.rows = [];
            SeospiderPagesService.findAll({
                jobId: sessionId,
                offset: vm.cruxPages.pageIndex * vm.cruxPages.pageSize,
                limit: vm.cruxPages.pageSize,
                fields: ['url'],
                ignoreLoadingBar: true
            })
                .then(function (response) {
                    if (requestId !== vm.cruxPages.requestId) return;
                    var rows = response && Array.isArray(response.data) ? response.data : [];
                    vm.cruxPages.total = Number(response && response.totalRows) || rows.length;
                    vm.cruxPages.pageCount = Math.max(1, Math.ceil(vm.cruxPages.total / vm.cruxPages.pageSize));
                    if (vm.cruxPages.pageIndex >= vm.cruxPages.pageCount) {
                        vm.cruxPages.pageIndex = vm.cruxPages.pageCount - 1;
                    }
                    vm.cruxPages.rows = rows.map(function (row) { return row.url; }).filter(Boolean);
                    vm.cruxPages.loadedFor = sessionId + '|' + vm.cruxPages.pageIndex;
                    setCruxPagesRange();
                    loadCruxTable();
                }).catch(function () {
                    if (requestId === vm.cruxPages.requestId) {
                        vm.cruxPages.rows = [];
                        vm.cruxPages.total = 0;
                        vm.cruxPages.pageCount = 0;
                        setCruxPagesRange();
                    }
                }).finally(function () {
                    if (requestId === vm.cruxPages.requestId) vm.cruxPages.loading = false;
                });
        }
        vm.changeCruxPage = function (delta) {
            if (vm.cruxPages.loading) return;
            var next = vm.cruxPages.pageIndex + delta;
            if (next < 0 || next >= vm.cruxPages.pageCount || next === vm.cruxPages.pageIndex) return;
            vm.cruxPages.pageIndex = next;
            vm.cruxPages.loadedFor = null;
            vm.cruxPages.rows = [];
            vm.cruxTable.rows = [];
            setCruxPagesRange();
            loadCruxPages(true);
        };
        vm.reloadCrux = function () { vm.crux.loadedFor = null; loadCrux(); };
        vm.reloadCruxAll = function () {
            vm.crux.loadedFor = null;
            vm.cruxTable.loadedFor = null;
            vm.cruxHistory.loadedFor = null;
            loadCrux();
            loadCruxPages(true);
            loadCruxTable();
            loadCruxHistory();
        };
        vm.cruxCurrent = function () { return (vm.crux.data && vm.crux.data[vm.crux.strategy]) || []; };
        vm.cruxHasData = function () {
            return vm.cruxCurrent().some(function (metric) { return metric.value !== null; });
        };
        vm.cruxCategoryKey = function (category) {
            if (category === 'FAST') return 'workspace.cruxFast';
            if (category === 'AVERAGE') return 'workspace.cruxAverage';
            return 'workspace.cruxSlow';
        };
        vm.cruxCategoryClass = function (category) {
            if (category === 'FAST') return 'is-pass';
            if (category === 'AVERAGE') return 'is-warn';
            return 'is-fail';
        };
        function cruxRawMetric(key) {
            var raw = vm.crux.raw && vm.crux.raw[vm.crux.strategy];
            return raw && raw[key] ? raw[key] : null;
        }
        function cruxExtraValue(key, unit, digits, divisor, fastMax, slowMin, name) {
            var source = cruxRawMetric(key);
            var value = source && typeof source.percentile === 'number' ? source.percentile / divisor : null;
            return cruxMetric(key.toUpperCase(), name, value, unit, digits,
                cruxCategory(source && source.category, value, fastMax, slowMin), fastMax + unit, slowMin + unit);
        }
        /* Metriche aggiuntive CrUX: FCP, TTFB e RTT (liste precalcolate). */
        function rebuildCruxPanels() {
            var raw = vm.crux.raw && vm.crux.raw[vm.crux.strategy];
            vm.crux.extra = raw ? [
                cruxExtraValue('fcp', 's', 1, 1000, 1.8, 3, $translate.instant('workspace.cruxMetricFcp')),
                cruxExtraValue('ttfb', 's', 1, 1000, 0.8, 1.8, $translate.instant('workspace.cruxMetricTtfb')),
                cruxExtraValue('rtt', 'ms', 0, 1, 75, 275, $translate.instant('workspace.cruxMetricRtt'))
            ].filter(function (metric) { return metric.value !== null; }) : [];
            vm.crux.resourceType = raw && raw.lcpResourceType ? raw.lcpResourceType : null;
            /* Sotto-parti dell'immagine LCP (presenti solo quando LCP è un'immagine). */
            vm.crux.lcpParts = raw ? [
                {key: 'lcpImageTtfb', tkey: 'workspace.cruxImageTtfb'},
                {key: 'lcpImageLoadDelay', tkey: 'workspace.cruxImageLoadDelay'},
                {key: 'lcpImageLoadDuration', tkey: 'workspace.cruxImageLoadDuration'},
                {key: 'lcpImageRenderDelay', tkey: 'workspace.cruxImageRenderDelay'}
            ].map(function (part) {
                var source = cruxRawMetric(part.key);
                return {
                    tkey: part.tkey,
                    value: source && typeof source.percentile === 'number' ? source.percentile : null
                };
            }).filter(function (part) { return part.value !== null; }) : [];
        }
        vm.cruxResourceLabel = function (type) {
            var labels = {
                image: 'workspace.cruxImage',
                text: 'workspace.cruxText',
                video: 'workspace.cruxVideo'
            };
            return labels[type] ? $translate.instant(labels[type]) : type;
        };
        /* Tabella CrUX delle pagine del crawl. */
        function cruxPageLabel(pageUrl) {
            /* Host + path: distingue www e non-www che condividono lo stesso path. */
            return String(pageUrl || '').replace(/^https?:\/\//i, '');
        }
        function cruxWorstCategory(metrics) {
            var order = {FAST: 0, AVERAGE: 1, SLOW: 2};
            var worst = null;
            metrics.forEach(function (metric) {
                if (metric.value === null || !metric.category) return;
                if (!worst || order[metric.category] > order[worst]) worst = metric.category;
            });
            return worst;
        }
        vm.cruxRowMetrics = function (row) {
            return (row && row.metrics && row.metrics[vm.crux.strategy]) || [];
        };
        vm.cruxRowStatus = function (row) {
            return cruxWorstCategory(vm.cruxRowMetrics(row));
        };
        function loadCruxTable() {
            var pages = vm.cruxPages.rows || [];
            var cruxUrl = vm.url || (vm.project && vm.project.url) || '';
            if (!cruxUrl || !pages.length) return;
            var cacheKey = cruxUrl + '|' + vm.cruxPages.pageIndex + '|' + pages.join(',');
            if (vm.cruxTable.loadedFor === cacheKey && vm.cruxTable.rows.length) return;
            var requestId = ++vm.cruxTable.requestId;
            vm.cruxTable.loading = true;
            vm.cruxTable.error = false;
            vm.cruxTable.rows = [];
            SeocheckerService.cruxPages(cruxUrl, pages, vm.crux.strategy).then(function (rows) {
                if (requestId !== vm.cruxTable.requestId) return;
                vm.cruxTable.rows = (rows || []).map(function (row) {
                    return {
                        url: row && row.url,
                        label: cruxPageLabel(row && row.url),
                        period: row && row.period,
                        metrics: buildCrux({mobile: row && row.mobile, desktop: row && row.desktop})
                    };
                });
                vm.cruxTable.loadedFor = cacheKey;
            }).catch(function () {
                if (requestId === vm.cruxTable.requestId) vm.cruxTable.error = true;
            }).finally(function () {
                if (requestId === vm.cruxTable.requestId) vm.cruxTable.loading = false;
            });
        }
        /* Storico CrUX (History API) e grafico dell'andamento. */
        vm.cruxHistoryMetrics = [
            {id: 'lcp', label: 'LCP'},
            {id: 'inp', label: 'INP'},
            {id: 'cls', label: 'CLS'},
            {id: 'fcp', label: 'FCP'},
            {id: 'ttfb', label: 'TTFB'},
            {id: 'rtt', label: 'RTT'}
        ];
        var cruxHistoryThresholds = {
            lcp: {good: 2.5, poor: 4, unit: 's', decimals: 1},
            inp: {good: 200, poor: 500, unit: 'ms', decimals: 0},
            cls: {good: .1, poor: .25, unit: '', decimals: 2},
            fcp: {good: 1.8, poor: 3, unit: 's', decimals: 1},
            ttfb: {good: .8, poor: 1.8, unit: 's', decimals: 1},
            rtt: {good: 75, poor: 275, unit: 'ms', decimals: 0}
        };
        vm.cruxHistory = {loading: false, error: false, data: null, metric: 'lcp', labels: [], chartData: null, chartSeries: [], bandLegend: []};
        vm.cruxChartColors = [suiteThemeToken('--sto-color-text', '#18181b')];
        vm.cruxChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {display: false},
            elements: {line: {tension: 0, fill: false, borderWidth: 0}, point: {radius: 0, hitRadius: 8, hoverRadius: 4}},
            scales: {
                xAxes: [{
                    gridLines: {display: false},
                    ticks: {
                        maxTicksLimit: 8,
                        fontColor: suiteThemeToken('--sto-color-text-subtle', '#a1a1aa')
                    }
                }],
                yAxes: [{
                    gridLines: {color: suiteThemeToken('--sto-color-border', '#e4e4e7')},
                    ticks: {
                        beginAtZero: true,
                        fontColor: suiteThemeToken('--sto-color-text-subtle', '#a1a1aa')
                    }
                }]
            },
            tooltips: {mode: 'index', intersect: false}
        };
        vm.setCruxHistoryMetric = function (id) {
            vm.cruxHistory.metric = id;
            buildCruxChart();
        };
        function buildCruxChart() {
            var strategyData = vm.cruxHistory.data && vm.cruxHistory.data[vm.crux.strategy];
            if (!strategyData || !strategyData.series) {
                vm.cruxHistory.chartData = null;
                vm.cruxHistory.labels = [];
                return;
            }
            var metric = vm.cruxHistory.metric;
            var raw = strategyData.series[metric] || (metric === 'inp' ? strategyData.series.fid : null);
            if (!raw) {
                vm.cruxHistory.chartData = null;
                return;
            }
            var values = raw.map(function (value) {
                if (value === null || value === undefined) return null;
                if (metric === 'lcp' || metric === 'fcp' || metric === 'ttfb') return value / 1000;
                if (metric === 'cls') return value > 1 ? value / 100 : value;
                return value;
            });
            var thresholds = cruxHistoryThresholds[metric];
            var formatThreshold = function (value) {
                var formatted = $filter('number')(value, thresholds.decimals);
                return formatted + (thresholds.unit ? ' ' + thresholds.unit : '');
            };
            var maxValue = values.reduce(function (max, value) {
                return value === null ? max : Math.max(max, value);
            }, 0);
            vm.cruxChartOptions.cruxBands = thresholds;
            vm.cruxChartOptions.scales.yAxes[0].ticks.suggestedMax = Math.max(maxValue * 1.08, thresholds.poor * 1.15);
            vm.cruxHistory.bandLegend = [
                {className: 'is-pass', tkey: 'workspace.cruxBandGood', params: {value: formatThreshold(thresholds.good)}},
                {className: 'is-warn', tkey: 'workspace.cruxBandImprovement', params: {
                    good: formatThreshold(thresholds.good),
                    poor: formatThreshold(thresholds.poor)
                }},
                {className: 'is-fail', tkey: 'workspace.cruxBandPoor', params: {value: formatThreshold(thresholds.poor)}}
            ];
            vm.cruxHistory.labels = (strategyData.periods || []).map(function (date) {
                return $filter('date')(date, 'dd MMM');
            });
            vm.cruxHistory.chartData = [values];
            vm.cruxHistory.chartSeries = [metric.toUpperCase()];
        }
        function loadCruxHistory() {
            var cruxUrl = vm.url || (vm.project && vm.project.url) || '';
            if (!cruxUrl) return;
            var page = vm.crux.page || '';
            var cacheKey = cruxUrl + '|' + page;
            if (vm.cruxHistory.loadedFor === cacheKey && vm.cruxHistory.data) {
                buildCruxChart();
                return;
            }
            vm.cruxHistory.loading = true;
            vm.cruxHistory.error = false;
            SeocheckerService.cruxHistory(cruxUrl, page).then(function (data) {
                vm.cruxHistory.data = data;
                vm.cruxHistory.loadedFor = cacheKey;
                buildCruxChart();
            }).catch(function () {
                vm.cruxHistory.error = true;
                vm.cruxHistory.chartData = null;
            }).finally(function () {
                vm.cruxHistory.loading = false;
            });
        }
        vm.form = {trackerSearch: '', trackerSort: 'position', spiderSearch: '', newKeyword: '', sessionId: null,
            newKeywordDevice: 1, newKeywordCountry: 'IT', newKeywordSearchEngine: 1, gscSearch: ''};
        vm.trackerSaving = false;
        vm.trackerAddingKeyword = false;
        vm.spiderOffset = 0;
        vm.spiderLimit = 25;
        vm.gscOffset = 0;
        vm.isLoading = true;
        vm.spiderData = {loading: false, rows: [], total: 0, error: false};
        vm.gsc = {checked: false, checking: false, loading: false, rows: [], error: false};
        vm.overviewTraffic = {checked: false, loading: false, error: false, data: null};
        vm.overviewTrafficChart = false;
        vm.overviewTracker = {checked: false, loading: false, error: false};
        vm.overviewGsc = {
            checked: false,
            loading: false,
            connected: false,
            error: false,
            property: null,
            summary: null
        };
        vm.gscInitialLoading = function () {
            return !vm.gsc.checked || !!vm.gsc.checking ||
                (!!vm.gsc.property && !!vm.gsc.loading && !vm.gsc.summary);
        };
        var GSC_PAGE_SIZES = [25, 50, 100, 250];
        var savedGscPageSize = Number($localStorage.searchConsolePageSize);
        vm.gscPageSizes = GSC_PAGE_SIZES;
        vm.gscPageSize = GSC_PAGE_SIZES.indexOf(savedGscPageSize) !== -1 ? savedGscPageSize : 25;
        vm.gscSort = {field: 'clicks', direction: 'desc'};
        vm.gscTotalRows = 0;
        vm.gscTotalRowsKnown = true;
        vm.gscHasMoreRows = false;
        vm.gscTruncated = false;
        vm.sitemaps = {loading: false, error: false, notConnected: false, items: [], propertyUrl: null, loaded: false};
        vm.sitemapForm = {url: '', submitting: false, error: null, success: false, scopeRequired: false, authorizing: false};
        vm.sitemapExpanded = {};
        vm.gscFilters = {startDate: null, endDate: null, country: '', device: '', query: '', page: '', searchAppearance: '', searchType: 'web'};
        vm.gscActiveFilters = [];
        vm.gscFilterTypes = [
            {id: 'query', label: 'Query', tkey: 'workspace.gscFilterQuery', kind: 'text'},
            {id: 'page', label: 'Page', tkey: 'workspace.gscFilterPage', kind: 'text'},
            {id: 'country', label: 'Country', tkey: 'workspace.gscFilterCountry', kind: 'country'},
            {id: 'device', label: 'Device', tkey: 'workspace.gscFilterDevice', kind: 'device'},
            {id: 'searchAppearance', label: 'Search appearance', tkey: 'workspace.gscFilterSearchAppearance', kind: 'appearance'}
        ];
        vm.gscAppearanceOptions = [
            {code: 'VIDEO', label: 'Video', tkey: 'workspace.gscAppearanceVideo'},
            {code: 'RICH_RESULT', label: 'Rich result', tkey: 'workspace.gscAppearanceRichResult'},
            {code: 'REVIEW_SNIPPET', label: 'Review snippet', tkey: 'workspace.gscAppearanceReviewSnippet'},
            {code: 'AMP_BLUE_LINK', label: 'AMP blue link', tkey: 'workspace.gscAppearanceAmpBlueLink'},
            {code: 'AMP_TOP_STORIES', label: 'AMP top stories', tkey: 'workspace.gscAppearanceAmpTopStories'},
            {code: 'AMP_IMAGE_PACK', label: 'AMP image pack', tkey: 'workspace.gscAppearanceAmpImagePack'},
            {code: 'AMP_IMAGE_RESULTS', label: 'AMP image results', tkey: 'workspace.gscAppearanceAmpImageResults'},
            {code: 'WEB_STORIES', label: 'Web stories', tkey: 'workspace.gscAppearanceWebStories'},
            {code: 'SHOPPING', label: 'Shopping', tkey: 'workspace.gscAppearanceShopping'}
        ];
        vm.gscFilterMenuOpen = false;
        vm.gscMoreOpen = false;
        vm.gscPreset = 'months3';
        vm.gscSearchType = 'web';
        vm.gscChartGranularity = 'daily';
        vm.gscChart = null;
        vm.gscMetricVisibility = {clicks: true, impressions: true, ctr: true, position: true};
        var gscMetricColors = {
            clicks: '#4387f6',
            impressions: '#5f35b1',
            ctr: '#03897b',
            position: '#e87109'
        };
        vm.gscChartLegend = [
            {id: 'clicks', label: 'Clicks', tkey: 'workspace.gscClicks', color: gscMetricColors.clicks},
            {id: 'impressions', label: 'Impressions', tkey: 'workspace.gscImpressions', color: gscMetricColors.impressions},
            {id: 'ctr', label: 'CTR', tkey: 'workspace.gscCtr', color: gscMetricColors.ctr},
            {id: 'position', label: 'Position', tkey: 'workspace.gscPosition', color: gscMetricColors.position}
        ];
        vm.gscRange = null;
        vm.gscMaxDate = new Date();
        vm.gscMaxDate.setDate(vm.gscMaxDate.getDate() - 3);
        vm.gscMinDate = new Date();
        vm.gscMinDate.setMonth(vm.gscMinDate.getMonth() - 16);
        function gscDateKey(value) {
            var date = value instanceof Date ? value : new Date(value);
            if (isNaN(date.getTime())) return null;
            return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                ('0' + date.getDate()).slice(-2);
        }
        function ensureGscRange() {
            if (vm.gscFilters.startDate && vm.gscFilters.endDate) return;
            setGscPresetDates(90);
        }
        function setGscPresetDates(days) {
            var end = new Date(vm.gscMaxDate.getTime());
            var start = new Date(end.getTime());
            start.setDate(start.getDate() - Math.max(0, days - 1));
            vm.gscRange = {startDate: start, endDate: end};
            vm.gscFilters.startDate = gscDateKey(start);
            vm.gscFilters.endDate = gscDateKey(end);
        }
        ensureGscRange();
        vm.setGscPreset = function (preset) {
            var days = {hours: 1, days7: 7, days28: 28, months3: 90, months6: 182, months12: 365, months16: 480}[preset];
            vm.gscPreset = preset;
            vm.gscMoreOpen = false;
            if (!days) return;
            setGscPresetDates(days);
            vm.gscOffset = 0;
            loadGscSummary();
        };
        vm.applyGscRange = function (range) {
            if (!range || !range.startDate || !range.endDate) return;
            vm.gscRange = {startDate: new Date(range.startDate), endDate: new Date(range.endDate)};
            vm.gscFilters.startDate = range.startDate;
            vm.gscFilters.endDate = range.endDate;
            vm.gscPreset = 'custom';
            vm.gscMoreOpen = false;
            vm.gscOffset = 0;
            loadGscSummary();
        };
        vm.addGscFilter = function (type) {
            var definition = vm.gscFilterTypes.filter(function (item) { return item.id === type; })[0];
            if (!definition) return;
            if (!vm.gscActiveFilters.some(function (item) { return item.type === type; })) {
                vm.gscActiveFilters.push({type: type, label: definition.label, tkey: definition.tkey, kind: definition.kind, value: ''});
            }
            vm.gscFilterMenuOpen = false;
        };
        vm.removeGscFilter = function (filter) {
            vm.gscActiveFilters = vm.gscActiveFilters.filter(function (item) { return item !== filter; });
            vm.applyGscFilters();
        };
        vm.toggleGscFilterMenu = function () {
            vm.gscFilterMenuOpen = !vm.gscFilterMenuOpen;
            vm.gscMoreOpen = false;
        };
        vm.toggleGscMore = function () {
            vm.gscMoreOpen = !vm.gscMoreOpen;
            vm.gscFilterMenuOpen = false;
        };
        vm.applyGscFilters = function () {
            vm.gscFilters.country = '';
            vm.gscFilters.device = '';
            vm.gscFilters.query = '';
            vm.gscFilters.page = '';
            vm.gscFilters.searchAppearance = '';
            vm.gscActiveFilters.forEach(function (filter) {
                if (filter.value) vm.gscFilters[filter.type] = filter.value;
            });
            vm.gscOffset = 0;
            loadGscSummary();
        };
        vm.resetGscFilters = function () {
            vm.gscActiveFilters = [];
            vm.gscFilters.country = '';
            vm.gscFilters.device = '';
            vm.gscFilters.query = '';
            vm.gscFilters.page = '';
            vm.gscFilters.searchAppearance = '';
            vm.gscOffset = 0;
            loadGscSummary();
        };
        vm.gscHasFilters = function () {
            return vm.gscActiveFilters.length > 0;
        };
        vm.gscCountryOptions = function () { return vm.gsc.countries || []; };
        vm.gscDeviceOptions = function () {
            return (vm.gsc.devices || []).length ? vm.gsc.devices : [
                {code: 'DESKTOP', label: 'Desktop', tkey: 'workspace.deviceDesktop'},
                {code: 'MOBILE', label: 'Mobile', tkey: 'workspace.deviceMobile'},
                {code: 'TABLET', label: 'Tablet', tkey: 'workspace.deviceTablet'}
            ];
        };
        vm.gscDeviceIcon = function (code) {
            var device = String(code || '').toUpperCase();
            if (device === 'MOBILE') return 'ti-device-mobile';
            if (device === 'TABLET') return 'ti-device-tablet';
            return 'ti-device-desktop';
        };
        vm.setGscGranularity = function (value) {
            vm.gscChartGranularity = value;
            buildGscChart(vm.gsc.summary);
        };
        vm.changeGscSearchType = function () {
            vm.gscFilters.searchType = vm.gscSearchType;
            loadGscFilterOptions();
            vm.applyGscFilters();
        };
        vm.toggleGscMetric = function (metric) {
            vm.gscMetricVisibility[metric] = !vm.gscMetricVisibility[metric];
            buildGscChart(vm.gsc.summary);
        };
        vm.refreshGscChart = function () {
            buildGscChart(vm.gsc.summary);
        };
        vm.gscCountryLabel = function (code, alpha2) {
            var country = (vm.gsc.countries || []).filter(function (item) { return item.code === code; })[0];
            if (country && country.label) return country.label;
            var region = alpha2 || (String(code || '').length === 2 ? String(code).toUpperCase() : null);
            if (region && $window.Intl && $window.Intl.DisplayNames) {
                try {
                    return new $window.Intl.DisplayNames([$translate.use() || 'en'], {type: 'region'})
                        .of(region.toUpperCase()) || String(code || '').toUpperCase();
                } catch (e) {}
            }
            return String(code || '').toUpperCase();
        };
        vm.gscRowLabel = function (row) {
            if (vm.gscView === 'country') return vm.gscCountryLabel(row && row.key, row && row.alpha2);
            if (vm.gscView === 'device') {
                var value = String(row && row.key || '');
                var keys = {
                    DESKTOP: 'workspace.deviceDesktop',
                    MOBILE: 'workspace.deviceMobile',
                    TABLET: 'workspace.deviceTablet'
                };
                return keys[value.toUpperCase()] ? $translate.instant(keys[value.toUpperCase()])
                    : (value ? value.charAt(0) + value.slice(1).toLowerCase() : '');
            }
            if (vm.gscView === 'searchAppearance') {
                var appearance = String(row && row.key || '').toUpperCase();
                var appearanceKeys = {
                    VIDEO: 'workspace.gscAppearanceVideo',
                    RICH_RESULT: 'workspace.gscAppearanceRichResult',
                    REVIEW_SNIPPET: 'workspace.gscAppearanceReviewSnippet',
                    AMP_BLUE_LINK: 'workspace.gscAppearanceAmpBlueLink',
                    AMP_TOP_STORIES: 'workspace.gscAppearanceAmpTopStories',
                    AMP_IMAGE_PACK: 'workspace.gscAppearanceAmpImagePack',
                    AMP_IMAGE_RESULTS: 'workspace.gscAppearanceAmpImageResults',
                    WEB_STORIES: 'workspace.gscAppearanceWebStories',
                    SHOPPING: 'workspace.gscAppearanceShopping'
                };
                if (appearanceKeys[appearance]) return $translate.instant(appearanceKeys[appearance]);
            }
            return row && row.key;
        };
        vm.selectSection = function (section) {
            vm.section = section;
            syncSubOptions();
            if ((section === 'spider' || section === 'explorer' || section === 'links') && vm.spiderProjectId && !vm.sessionsLoaded) loadSessions();
            if (section === 'structure' && vm.spiderProjectId && !vm.sessionsLoaded) loadSessions();
            if (section === 'search-console' && !vm.gsc.checked) loadSearchConsole();
            if (section === 'overview') { loadCrawlSession(); loadReport(); loadOverviewInsights(); }
            if (section === 'links') loadCrawlSession();
            if (section === 'tracker' && vm.tracker) reloadTracker();
            if (section === 'log') loadCrawlSession();
            if (section === 'report') { syncReportSection(); loadReport(); }
            if (section === 'issues') { loadReport(); loadCrawlSession(); }
            if (section === 'export') { loadCrawlSession(); loadReport(); }
            if (section === 'crux') { loadCruxPages(); loadCrux(); loadCruxTable(); loadCruxHistory(); }
            if (section === 'sitemaps') loadSitemaps();
        };
        vm.isSectionActive = function (sectionId) {
            var stateSection = sectionId === 'search-console' ? 'searchConsole' : sectionId;
            var name = $state.current && $state.current.name || '';
            var target = 'app.project.detail.' + stateSection;
            return name === target || name.indexOf(target + '.') === 0;
        };
        vm.goToSection = function (id) {
            if (!id || !vm.project) return;
            var option = vm.sectionOptions.filter(function (item) { return item.id === id; })[0];
            if (!option) return;
            if ($state.current && $state.current.name === option.state) return;
            var params = {projectId: vm.project.id};
            if (id === 'report') params.section = vm.reportSection || 'overview';
            if (id === 'spider') { params.category = vm.spiderView || 'pages'; params.variant = null; }
            if (id === 'explorer') params.filter = null;
            if (id === 'links') params.filter = null;
            if (id === 'search-console') params.view = vm.gscView || 'query';
            vm.$root.projectSectionLoading = true;
            $state.go(option.state, params);
        };
        vm.openTrafficSection = function (event) {
            if (event) event.preventDefault();
            if (!vm.project || vm.isSectionActive('traffic')) return;
            vm.$root.projectSectionLoading = true;
            $state.go('app.project.detail.traffic', {projectId: vm.project.id});
        };
        vm.goToSpiderVariant = function (id) {
            if (!vm.project) return;
            var params = {projectId: vm.project.id, category: vm.spiderView || 'pages'};
            if (id) params.variant = id;
            $state.go('app.project.detail.spider', params);
        };
        vm.goToSubSection = function (id) {
            if (!id || !vm.project) return;
            if (vm.section === 'report') { vm.selectReportSection(id); return; }
            if (vm.section === 'spider') { $state.go('app.project.detail.spider', {projectId: vm.project.id, category: id, variant: null}); return; }
            if (vm.section === 'search-console') { $state.go('app.project.detail.searchConsole', {projectId: vm.project.id, view: id}); }
        };
        function syncSubOptions() {
            if (vm.section === 'report') {
                vm.sectionSubOptions = vm.reportSections.map(function (item) { return {id: item.id, label: item.label, tkey: item.tkey}; });
                vm.subSection = vm.reportSection;
                return;
            }
            if (vm.section === 'spider') {
                vm.sectionSubOptions = vm.spiderViews;
                vm.subSection = vm.spiderView;
                vm.variantOptions = vm.spiderVariants();
                vm.variantValue = vm.spiderVariant || (vm.variantOptions.length ? vm.variantOptions[0].id : null);
                return;
            }
            if (vm.section === 'search-console') { vm.sectionSubOptions = vm.gscViews; vm.subSection = vm.gscView; return; }
            vm.sectionSubOptions = [];
            vm.subSection = null;
            vm.variantOptions = [];
            vm.variantValue = null;
        }
        vm.selectReportSection = function (view) {
            if (!view || !vm.reportSections.some(function (item) { return item.id === view; })) { loadReport(); return; }
            vm.reportSection = view;
            syncSubOptions();
            syncReportSection();
            if (view === 'overview') loadPreviews();
            if (vm.project && vm.section === 'report' && $stateParams.section !== view) {
                $state.go('app.project.detail.report', {projectId: vm.project.id, section: view});
                return;
            }
            loadReport();
        };
        vm.selectSpiderView = function (view) { vm.applySpiderRoute(view, vm.spiderVariant); };
        vm.selectSession = function () {
            /* The picker lives in the project navbar, so every section follows it. */
            vm.spiderOffset = 0;
            vm.spiderData = {loading: false, rows: [], total: 0, error: false};
            vm.reportLoadedFor = null;
            vm.sessionLoadedFor = null;
            vm.structureLoadedFor = null;
            vm.report = null;
            vm.reportScores = null;
            vm.reportConfiguration = null;
            vm.crawlSession = null;
            vm.previews = {desktop: null, mobile: null, loading: false};
            buildExplorerCounts();
            buildIssueRows();
            if (vm.section === 'spider' || vm.section === 'explorer' || vm.section === 'links') loadSpiderRows();
            if (vm.section === 'structure') loadStructure();
            if (vm.section === 'overview') { loadCrawlSession(); loadReport(); }
            if (vm.section === 'links') loadCrawlSession();
            if (vm.section === 'log') loadCrawlSession();
            if (vm.section === 'report') loadReport();
            if (vm.section === 'issues') { loadReport(); loadCrawlSession(); }
            if (vm.section !== 'overview' && vm.section !== 'report' && vm.section !== 'issues') loadReport();
            syncCrawlPolling();
        };
        vm.searchSpider = function () { vm.spiderOffset = 0; loadSpiderRows(); };
        vm.pageSpider = function (direction) { vm.spiderOffset += direction * vm.spiderLimit; loadSpiderRows(); };
        vm.selectGscView = function (view) {
            vm.gscView = view;
            syncSubOptions();
            vm.gscOffset = 0;
            if (view === 'settings') return;
            if (!vm.gsc.checked || !vm.gsc.summary) {
                loadSearchConsole();
                return;
            }
            loadGscRows();
        };
        vm.pageGsc = function (direction) {
            var next = (Number(vm.gscOffset) || 0) + direction * (Number(vm.gscPageSize) || 25);
            vm.gscOffset = Math.max(0, next);
            loadGscRows();
        };
        vm.connectSearchConsole = function () {
            vm.gsc.connecting = true;
            SearchConsoleService.connectProject({id: vm.project.id, workspaceId: workspaceId, name: vm.project.name, url: vm.url})
                .catch(function (error) {
                    console.error('Search Console connection failed', error);
                    vm.gsc.error = true;
                    vm.gsc.connecting = false;
                });
        };
        vm.connectSitemapsSearchConsole = function () {
            vm.gsc.connecting = true;
            SearchConsoleService.connectProject({
                id: vm.project.id,
                workspaceId: workspaceId,
                name: vm.project.name,
                url: vm.url
            }, {
                returnState: 'app.project.detail.sitemaps',
                returnParams: {projectId: vm.project.id}
            }).catch(function (error) {
                console.error('Search Console connection failed', error);
                vm.gsc.error = true;
                vm.gsc.connecting = false;
            });
        };
        vm.reloadSitemaps = loadSitemaps;
        vm.submitSitemap = function () {
            var url = (vm.sitemapForm.url || '').trim();
            vm.sitemapForm.success = false;
            vm.sitemapForm.error = null;
            vm.sitemapForm.scopeRequired = false;
            if (!/^https?:\/\/[^\s]+$/i.test(url)) {
                vm.sitemapForm.error = $translate.instant('workspace.sitemapInvalidUrl');
                return;
            }
            vm.sitemapForm.submitting = true;
            SearchConsoleService.submitProjectSitemap(vm.project.id, url).then(function () {
                if (destroyed) return;
                vm.sitemapForm.success = true;
                loadSitemaps();
            }).catch(function (error) {
                if (destroyed) return;
                var body = error && error.data && error.data.error;
                var code = body && body.code;
                vm.sitemapForm.scopeRequired = code === 'SEARCH_CONSOLE_WRITE_SCOPE_REQUIRED'
                    || /write permission is required/i.test(body && body.message || '');
                vm.sitemapForm.error = vm.sitemapForm.scopeRequired
                    ? $translate.instant('workspace.sitemapWriteScopeRequired')
                    : $translate.instant('workspace.sitemapSubmitFailed');
            }).finally(function () {
                if (!destroyed) vm.sitemapForm.submitting = false;
            });
        };
        vm.authorizeSitemapSubmit = function () {
            vm.sitemapForm.authorizing = true;
            SearchConsoleService.connectProject({
                id: vm.project.id,
                workspaceId: workspaceId,
                name: vm.project.name,
                url: vm.url
            }, {
                write: true,
                returnState: 'app.project.detail.sitemaps',
                returnParams: {projectId: vm.project.id}
            }).catch(function (error) {
                console.error('Search Console write authorization failed', error);
                vm.sitemapForm.authorizing = false;
                vm.sitemapForm.error = $translate.instant('workspace.sitemapAuthorizationError');
            });
        };
        vm.sitemapDate = function (value) {
            if (!value) return '—';
            var date = new Date(value);
            return isNaN(date.getTime()) ? value : $filter('date')(date, 'dd/MM/yyyy HH:mm');
        };
        vm.sitemapDateOnly = function (value) {
            if (!value) return '—';
            var date = new Date(value);
            return isNaN(date.getTime()) ? value : $filter('date')(date, 'dd/MM/yyyy');
        };
        vm.sitemapTimeOnly = function (value) {
            if (!value) return '';
            var date = new Date(value);
            return isNaN(date.getTime()) ? '' : $filter('date')(date, 'HH:mm');
        };
        vm.sitemapDisplayPath = function (path) {
            return String(path || '').replace(/^https?:\/\//i, '');
        };
        vm.sitemapType = function (item) {
            if (item.isSitemapsIndex) return $translate.instant('workspace.sitemapIndexType');
            return item.type || $translate.instant('workspace.sitemap');
        };
        vm.sitemapStatus = function (item) {
            if (Number(item.errors) > 0) return 'error';
            if (item.isPending) return 'pending';
            if (!item.lastDownloaded) return 'unread';
            if (Number(item.warnings) > 0) return 'warning';
            return 'ok';
        };
        vm.sitemapStatusLabel = function (item) {
            var keys = {
                error: 'workspace.sitemapStatusError',
                pending: 'workspace.sitemapStatusPending',
                unread: 'workspace.sitemapStatusUnread',
                warning: 'workspace.sitemapStatusWarning',
                ok: 'workspace.sitemapStatusOk'
            };
            return $translate.instant(keys[vm.sitemapStatus(item)]);
        };
        vm.toggleSitemapDetail = function (item) {
            if (!item || !item.path) return;
            vm.sitemapExpanded[item.path] = !vm.sitemapExpanded[item.path];
        };
        vm.sitemapContentType = function (type) {
            var keys = {
                WEB: 'workspace.sitemapTypeWeb',
                IMAGE: 'workspace.sitemapTypeImages',
                IMAGES: 'workspace.sitemapTypeImages',
                VIDEO: 'workspace.sitemapTypeVideo',
                NEWS: 'workspace.sitemapTypeNews',
                MOBILE: 'workspace.sitemapTypeMobile'
            };
            var key = keys[String(type || '').toUpperCase()];
            return key ? $translate.instant(key) : (type || $translate.instant('workspace.sitemapTypeOther'));
        };
        vm.sitemapTotalSubmitted = function (item) {
            return (item && item.contents || []).reduce(function (total, content) {
                return total + (Number(content.submitted) || 0);
            }, 0);
        };
        vm.sitemapTotalIndexed = function (item) {
            return (item && item.contents || []).reduce(function (total, content) {
                return total + (Number(content.indexed) || 0);
            }, 0);
        };
        vm.sitemapTotalSubmittedAll = function () {
            return (vm.sitemaps.items || []).reduce(function (total, item) {
                return total + vm.sitemapTotalSubmitted(item);
            }, 0);
        };
        vm.sitemapTotalIndexedAll = function () {
            return (vm.sitemaps.items || []).reduce(function (total, item) {
                return total + vm.sitemapTotalIndexed(item);
            }, 0);
        };
        vm.sitemapIndexScore = function () {
            var submitted = vm.sitemapTotalSubmittedAll();
            return submitted ? vm.sitemapTotalIndexedAll() / submitted * 100 : null;
        };
        vm.sitemapIndexScoreLabel = function () {
            var score = vm.sitemapIndexScore();
            return score === null ? '—' : score.toFixed(1);
        };
        vm.sitemapIndexScoreFor = function (item) {
            var submitted = vm.sitemapTotalSubmitted(item);
            return submitted ? vm.sitemapTotalIndexed(item) / submitted * 100 : null;
        };
        vm.sitemapIndexScoreForLabel = function (item) {
            var score = vm.sitemapIndexScoreFor(item);
            return score === null ? '—' : score.toFixed(1);
        };
        vm.sitemapIndexScoreBand = function (item) {
            return vm.sitemapScoreBand(vm.sitemapIndexScoreFor(item));
        };
        vm.sitemapScoreBand = function (score) {
            if (score === null || score === undefined || isNaN(score)) return 'empty';
            if (score < 25) return 'low';
            if (score < 60) return 'mid';
            return 'high';
        };
        vm.sitemapContentScore = function (content) {
            var submitted = Number(content && content.submitted) || 0;
            return submitted ? (Number(content.indexed) || 0) / submitted * 100 : null;
        };
        vm.sitemapContentScoreLabel = function (content) {
            var score = vm.sitemapContentScore(content);
            return score === null ? '—' : score.toFixed(1);
        };
        function loadSitemaps() {
            if (!vm.project) return;
            var id = ++sitemapsRequestId;
            vm.sitemaps.loading = true;
            vm.sitemaps.error = false;
            vm.sitemaps.notConnected = false;
            if (!vm.sitemapForm.url) vm.sitemapForm.url = defaultSitemapUrl();
            SearchConsoleService.getProjectSitemaps(vm.project.id).then(function (data) {
                if (destroyed || id !== sitemapsRequestId) return;
                vm.sitemaps.items = data && data.items || [];
                vm.sitemaps.propertyUrl = data && data.propertyUrl || null;
                vm.sitemaps.loaded = true;
                vm.sitemapExpanded = {};
                if (!vm.sitemapForm.url) vm.sitemapForm.url = defaultSitemapUrl();
            }).catch(function (error) {
                if (destroyed || id !== sitemapsRequestId) return;
                var message = error && (error.message
                    || (error.data && error.data.error && error.data.error.message)) || '';
                vm.sitemaps.notConnected = /not connected|not authorized/i.test(message);
                vm.sitemaps.error = !vm.sitemaps.notConnected;
            }).finally(function () {
                if (!destroyed && id === sitemapsRequestId) vm.sitemaps.loading = false;
            });
        }
        function defaultSitemapUrl() {
            var property = vm.sitemaps.propertyUrl || vm.gsc.property || '';
            var site = vm.url || '';
            var domain = property.indexOf('sc-domain:') === 0
                ? property.slice('sc-domain:'.length)
                : '';
            if (domain) return 'https://' + domain.replace(/^\/+|\/+$/g, '') + '/sitemap.xml';
            var source = property || site;
            if (source && !/^https?:\/\//i.test(source)) source = 'https://' + source;
            try {
                return new URL(source, $window.location.href).origin + '/sitemap.xml';
            } catch (e) {
                return '';
            }
        }
        vm.disconnectSearchConsole = function () {
            SearchConsoleService.disconnectProject(vm.project.id).then(function () {
                vm.gsc = {
                    checked: true, checking: false, loading: false, rows: [], error: false,
                    property: null, properties: [], propertyChanging: false
                };
            }).catch(function () { vm.gsc.error = true; });
        };
        vm.changeSearchConsoleProperty = function (propertyUrl) {
            if (!propertyUrl || propertyUrl === vm.gsc.property || vm.gsc.propertyChanging) return;
            vm.gsc.propertyChanging = true;
            SearchConsoleService.connectProjectProperty(vm.project.id, propertyUrl)
                .then(function () {
                    loadSearchConsole();
                })
                .catch(function () {
                    vm.gsc.error = true;
                })
                .finally(function () {
                    vm.gsc.propertyChanging = false;
                });
        };
        /* New keywords go to the location chosen in the form (first one by default). */
        function trackerLocationKey(location) {
            return String(location.deviceId) + '-' + location.countryCode + '-' + location.searchEngineId;
        }
        vm.trackerAddDevices = [
            {id: 1, label: 'Desktop', tkey: 'workspace.deviceDesktop', icon: 'ti-device-desktop'},
            {id: 2, label: 'Mobile', tkey: 'workspace.deviceMobile', icon: 'ti-device-mobile'}
        ];
        vm.trackerAddEngines = [
            {id: 1, label: 'Google'},
            {id: 2, label: 'Yahoo'},
            {id: 4, label: 'Bing'}
        ];
        var trackerCountryReference = [];
        var trackerCountryReferenceLoading = false;
        var trackerAddCountriesCache = null;
        var trackerCountryPickerCache = null;
        function loadTrackerCountryReference() {
            if (trackerCountryReference.length || trackerCountryReferenceLoading) return;
            trackerCountryReferenceLoading = true;
            KeywordTrackerService.getCountryCodes().then(function (countries) {
                trackerCountryReference = (countries || []).filter(function (country) {
                    return country && country.code && country.code !== 'GBL';
                });
                trackerAddCountriesCache = null;
                trackerCountryPickerCache = null;
                ensureTrackerFormLocation();
            }).catch(function () {
                trackerCountryReference = [];
            }).finally(function () {
                trackerCountryReferenceLoading = false;
            });
        }
        vm.trackerAddCountries = function () {
            if (trackerAddCountriesCache) return trackerAddCountriesCache;
            if (trackerCountryReference.length) {
                trackerAddCountriesCache = trackerCountryReference.map(function (country) {
                    return {code: String(country.code).toUpperCase(), label: country.name};
                });
                return trackerAddCountriesCache;
            }
            var seen = {};
            var displayNames = null;
            try {
                displayNames = new Intl.DisplayNames(['it'], {type: 'region'});
            } catch (e) {
                displayNames = null;
            }
            trackerAddCountriesCache = (vm.tracker && Array.isArray(vm.tracker.locations) ? vm.tracker.locations : [])
                .map(function (location) { return String(location.countryCode || '').toUpperCase(); })
                .filter(function (code) {
                    if (!code || seen[code]) return false;
                    seen[code] = true;
                    return true;
                })
                .map(function (code) {
                    var label = code;
                    try {
                        label = displayNames ? displayNames.of(code) : code;
                    } catch (e) {
                        label = code;
                    }
                    return {code: code, label: label};
                });
            return trackerAddCountriesCache;
        };
        vm.trackerCountryPickerItems = function () {
            if (trackerCountryPickerCache) return trackerCountryPickerCache;
            trackerCountryPickerCache = vm.trackerAddCountries().map(function (country) {
                return {
                    value: country.code,
                    label: country.label,
                    image: 'assets/img/modules/flags/' + String(country.code).toLowerCase() + '.png'
                };
            });
            return trackerCountryPickerCache;
        };
        vm.selectTrackerCountry = function (country) {
            if (!country) return;
            vm.form.newKeywordCountry = country.value;
        };
        function ensureTrackerFormLocation() {
            var locations = vm.tracker && Array.isArray(vm.tracker.locations) ? vm.tracker.locations : [];
            var countries = vm.trackerAddCountries();
            if (!locations.length || !countries.length) return;
            if (!vm.trackerAddDevices.some(function (device) { return device.id === Number(vm.form.newKeywordDevice); })) {
                vm.form.newKeywordDevice = Number(locations[0].deviceId) || 1;
            }
            if (!countries.some(function (country) { return country.code === vm.form.newKeywordCountry; })) {
                vm.form.newKeywordCountry = countries[0].code;
            }
            if (!vm.trackerAddEngines.some(function (engine) { return engine.id === Number(vm.form.newKeywordSearchEngine); })) {
                vm.form.newKeywordSearchEngine = Number(locations[0].searchEngineId) || 1;
            }
        }
        vm.addKeyword = function () {
            var keyword = (vm.form.newKeyword || '').trim();
            if (!keyword || vm.trackerAddingKeyword || !vm.tracker || !Array.isArray(vm.tracker.locations) || !vm.tracker.locations.length) return;
            var locations = [{
                searchEngineId: Number(vm.form.newKeywordSearchEngine),
                countryCode: vm.form.newKeywordCountry,
                deviceId: Number(vm.form.newKeywordDevice)
            }];
            if (!locations.length) return;
            var location = locations[0];
            var optimisticId = 'optimistic-' + Date.now();
            var optimisticKeyword = {
                id: optimisticId,
                uniqueField: optimisticId,
                keyword: keyword,
                deviceId: location.deviceId,
                countryCode: location.countryCode,
                searchEngineId: location.searchEngineId,
                avgVolume: null,
                status: 'inProgress',
                optimistic: true,
                searches: [{
                    createdAt: gscDateKey(new Date()),
                    deviceId: location.deviceId,
                    pending: true,
                    position: 101,
                    rankPosition: 101,
                    pages: []
                }]
            };
            vm.tracker.keywords = Array.isArray(vm.tracker.keywords) ? vm.tracker.keywords : [];
            vm.tracker.keywords.unshift(optimisticKeyword);
            vm.form.newKeyword = '';
            vm.trackerAddingKeyword = true;
            vm.trackerError = false;
            resetTrackerKeywordCaches();
            trackerLocationOptionsCache = null;
            trackerAverageCache = null;
            trackerAverageCacheKey = null;
            trackerDistributionCache = null;
            vm.trackerAverageHover = null;
            KeywordTrackerService.addKeywords(vm.tracker.id, [keyword], locations)
                .then(function () {
                    return reloadTracker(null, {silent: true})
                        .then(loadTrackerKeywordUsage)
                        .catch(function () { return null; });
                })
                .catch(function () {
                    vm.tracker.keywords = vm.tracker.keywords.filter(function (item) {
                        return item.id !== optimisticId;
                    });
                    resetTrackerKeywordCaches();
                    trackerAverageCache = null;
                    trackerAverageCacheKey = null;
                    trackerDistributionCache = null;
                    vm.trackerError = true;
                })
                .finally(function () {
                    vm.trackerAddingKeyword = false;
                });
        };
        vm.removeKeyword = function (keyword) {
            if (!keyword || !vm.tracker || !$window.confirm($translate.instant('workspace.trackerRemoveConfirm'))) return;
            vm.trackerSaving = true;
            vm.trackerError = false;
            KeywordTrackerService.deleteKeywords(vm.tracker.id, [{id: keyword.id, deviceId: keyword.deviceId}])
                .then(function () { return reloadTracker(); })
                .then(loadTrackerKeywordUsage)
                .catch(function () { vm.trackerError = true; })
                .finally(function () { vm.trackerSaving = false; });
        };
        vm.keywordMatches = function (item) {
            return !vm.form.trackerSearch || String(item.keyword || item.query || '').toLowerCase().indexOf(vm.form.trackerSearch.toLowerCase()) >= 0;
        };
        /* ---- Rank Tracker: extra columns (volume, indexed, top ranked, diff.)
           and the inline keyword detail, from the same payload the old tool used. */
        vm.trackerLocationKey = null;
        vm.trackerDeviceId = 1;
        vm.trackerDeviceCounts = function () {
            var counts = {desktop: 0, mobile: 0};
            var keywords = vm.tracker && Array.isArray(vm.tracker.keywords) ? vm.tracker.keywords : [];
            keywords.forEach(function (keyword) {
                if (Number(keyword.deviceId) === 2) counts.mobile += 1;
                else counts.desktop += 1;
            });
            return counts;
        };
        vm.setTrackerDevice = function (deviceId) {
            var nextDevice = Number(deviceId) === 2 ? 2 : 1;
            if (vm.trackerDeviceId === nextDevice) return;
            vm.trackerDeviceId = nextDevice;
            trackerAverageCache = null;
            trackerAverageCacheKey = null;
            trackerDistributionCache = null;
            trackerRowsCacheKey = null;
            trackerRowsRevision++;
        };
        vm.trackerPositionTone = function (position) {
            var value = Number(position);
            if (!value || value < 1 || value > 50) return 'is-rank-51-plus';
            if (value <= 3) return 'is-rank-top3';
            if (value <= 10) return 'is-rank-4-10';
            if (value <= 20) return 'is-rank-11-20';
            return 'is-rank-21-50';
        };
        function trackerDeviceMatches(keyword) {
            return !vm.trackerDeviceId ||
                Number(keyword && keyword.deviceId || 1) === Number(vm.trackerDeviceId);
        }
        function ensureTrackerDeviceSelection() {
            var counts = vm.trackerDeviceCounts();
            if (vm.trackerDeviceId === 1 && counts.desktop === 0 && counts.mobile > 0) {
                vm.trackerDeviceId = 2;
            } else if (vm.trackerDeviceId === 2 && counts.mobile === 0 && counts.desktop > 0) {
                vm.trackerDeviceId = 1;
            }
        }
        /* Date range: the API filters the results (startDate/endDate), like the old tool. */
        vm.trackerRange = null;
        vm.trackerFilters = {};
        vm.trackerCalendarMinDate = (function () {
            var date = new Date();
            date.setMonth(date.getMonth() - 16);
            return date;
        })();
        /* While a range reload is in flight the table and the two charts show skeletons. */
        vm.trackerLoading = false;
        vm.trackerGsc = {checked: false, checking: false, connected: false, property: null, error: false};
        var TRACKER_GSC_NOTICE_STORAGE_KEY = 'rankTrackerGscNoticeDismissed';
        function trackerNoticeProjectKey() {
            return String(($stateParams && $stateParams.projectId) || (vm.project && vm.project.id) || '');
        }
        function trackerGscNoticeDismissed() {
            var dismissed = $localStorage[TRACKER_GSC_NOTICE_STORAGE_KEY] || {};
            return !!dismissed[trackerNoticeProjectKey()];
        }
        vm.trackerGscNoticeVisible = function () {
            return !!(vm.tracker && vm.trackerGsc.checked && !vm.trackerGsc.connected &&
                !vm.trackerGsc.error && !trackerGscNoticeDismissed());
        };
        vm.dismissTrackerGscNotice = function () {
            var dismissed = $localStorage[TRACKER_GSC_NOTICE_STORAGE_KEY] || {};
            dismissed[trackerNoticeProjectKey()] = true;
            $localStorage[TRACKER_GSC_NOTICE_STORAGE_KEY] = dismissed;
        };
        var trackerColumnDefaultState = {
            position: true,
            difference: true,
            lastCheck: true,
            volume: true,
            indexed: true,
            topRanked: false,
            location: true
        };
        var trackerColumnDefaults = Object.assign({}, trackerColumnDefaultState);
        var savedTrackerColumns = $localStorage.rankTrackerColumns || {};
        Object.keys(trackerColumnDefaults).forEach(function (id) {
            if (typeof savedTrackerColumns[id] === 'boolean') {
                trackerColumnDefaults[id] = savedTrackerColumns[id];
            }
        });
        vm.trackerColumnVisibility = trackerColumnDefaults;
        vm.trackerColumnOptions = [
            {id: 'position', tkey: 'workspace.trackerPosition'},
            {id: 'difference', tkey: 'workspace.trackerDifference'},
            {id: 'lastCheck', tkey: 'workspace.trackerLastCheck'},
            {id: 'volume', tkey: 'workspace.trackerVolumeFull', hideWithCompetitors: true},
            {id: 'indexed', tkey: 'workspace.trackerIndexed', hideWithCompetitors: true},
            {id: 'topRanked', tkey: 'workspace.trackerTopRanked', hideWithCompetitors: true},
            {id: 'location', tkey: 'workspace.trackerLocation'}
        ];
        vm.trackerColumnsOpen = false;
        vm.toggleTrackerColumns = function () {
            vm.trackerColumnsOpen = !vm.trackerColumnsOpen;
        };
        vm.saveTrackerColumns = function () {
            $localStorage.rankTrackerColumns = Object.assign({}, vm.trackerColumnVisibility);
        };
        vm.resetTrackerColumns = function () {
            vm.trackerColumnVisibility = Object.assign({}, trackerColumnDefaultState);
            vm.saveTrackerColumns();
        };
        vm.trackerColumnVisible = function (id) {
            return !!vm.trackerColumnVisibility[id];
        };
        vm.trackerTableColumnCount = function () {
            var competitors = vm.trackerSelectedList() || [];
            var count = 2;
            ['position', 'difference', 'lastCheck', 'volume', 'indexed', 'topRanked', 'location'].forEach(function (id) {
                if (!vm.trackerColumnVisible(id)) return;
                if (competitors.length && (id === 'volume' || id === 'indexed' || id === 'topRanked')) return;
                count += 1;
            });
            return count + competitors.length;
        };
        vm.trackerPageFavicon = function (url) {
            return url
                ? 'https://www.google.com/s2/favicons?sz=64&domain_url=' + encodeURIComponent(url)
                : null;
        };
        var trackerReloadId = 0;
        vm.applyTrackerRange = function (range) {
            if (!range || !range.startDate || !range.endDate) return;
            vm.trackerRange = {startDate: new Date(range.startDate), endDate: new Date(range.endDate)};
            vm.trackerFilters = {startDate: range.startDate, endDate: range.endDate};
            return reloadTracker();
        };
        function ensureTrackerRange() {
            if (!vm.tracker) return;
            var end = new Date();
            var historyStart = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000);
            var created = vm.tracker.createdAt ? new Date(vm.tracker.createdAt) : historyStart;
            var start = created < historyStart ? created : historyStart;
            if (start > end) start = end;
            if (!vm.trackerRange) {
                vm.trackerRange = {startDate: start, endDate: end};
            }
            vm.trackerFilters.startDate = vm.trackerFilters.startDate || gscDateKey(vm.trackerRange.startDate);
            vm.trackerFilters.endDate = vm.trackerFilters.endDate || gscDateKey(vm.trackerRange.endDate);
        }
        var trackerSearchEngines = {1: 'Google', 2: 'Yahoo', 4: 'Bing'};
        /* These two lists are watched by ng-repeat: cache them, or every digest
           would get a brand new array and Angular would loop forever. */
        var trackerLocationOptionsCache = null;
        var trackerCompetitorsCache = null;
        /* Distinct chart/legend colours for competitors without one stored. */
        var TRACKER_COMPETITOR_COLORS = ['#2296f3', '#7c4dff', '#00a878', '#d81b60', '#00838f'];
        vm.trackerLocationOptions = function () {
            if (trackerLocationOptionsCache) return trackerLocationOptionsCache;
            var locations = vm.tracker && Array.isArray(vm.tracker.locations) ? vm.tracker.locations : [];
            trackerLocationOptionsCache = locations.map(function (location) {
                var device = Number(location.deviceId) === 2 ? 'mobile' : 'desktop';
                var engine = trackerSearchEngines[Number(location.searchEngineId)] || 'Google';
                return {id: trackerLocationKey(location),
                    label: engine + ' (' + location.countryCode + '), ' + device};
            });
            return trackerLocationOptionsCache;
        };
        vm.trackerKeywordMatches = function (item) {
            if (!trackerDeviceMatches(item) || !vm.keywordMatches(item)) return false;
            if (!vm.trackerLocationKey) return true;
            return String(item.deviceId) + '-' + item.countryCode + '-' + item.searchEngineId === vm.trackerLocationKey;
        };
        /* ---- Advanced filters (volume/position ranges, include/exclude terms),
           the same settings as the old Rank Tracker panel, applied with "Apply". */
        function emptyTrackerAdvancedFilters() {
            return {volumeMin: null, volumeMax: null, positionMin: null, positionMax: null, include: '', exclude: ''};
        }
        vm.trackerAdvancedOpen = false;
        vm.trackerAdvancedApplied = emptyTrackerAdvancedFilters();
        vm.trackerAdvancedDraft = emptyTrackerAdvancedFilters();
        vm.toggleTrackerAdvanced = function () {
            vm.trackerAdvancedOpen = !vm.trackerAdvancedOpen;
            if (!vm.trackerAdvancedOpen) return;
            vm.trackerBenchmarksOpen = false;
            var applied = vm.trackerAdvancedApplied;
            vm.trackerAdvancedDraft = {
                volumeMin: applied.volumeMin, volumeMax: applied.volumeMax,
                positionMin: applied.positionMin, positionMax: applied.positionMax,
                include: applied.include, exclude: applied.exclude
            };
        };
        vm.closeTrackerAdvanced = function () {
            vm.trackerAdvancedOpen = false;
        };
        vm.trackerAdvancedKeydown = function (event) {
            if (event && (event.key === 'Escape' || event.keyCode === 27)) {
                vm.closeTrackerAdvanced();
            }
        };
        vm.applyTrackerAdvanced = function () {
            var draft = vm.trackerAdvancedDraft;
            vm.trackerAdvancedApplied = {
                volumeMin: draft.volumeMin, volumeMax: draft.volumeMax,
                positionMin: draft.positionMin, positionMax: draft.positionMax,
                include: draft.include, exclude: draft.exclude
            };
            vm.trackerAdvancedOpen = false;
            return reloadTracker();
        };
        vm.resetTrackerAdvanced = function () {
            vm.trackerAdvancedApplied = emptyTrackerAdvancedFilters();
            vm.trackerAdvancedDraft = emptyTrackerAdvancedFilters();
            vm.trackerAdvancedOpen = false;
            return reloadTracker();
        };
        vm.trackerAdvancedCount = function () {
            var filters = vm.trackerAdvancedApplied;
            return ['volumeMin', 'volumeMax', 'positionMin', 'positionMax', 'include', 'exclude'].filter(function (field) {
                return filters[field] !== null && filters[field] !== undefined && String(filters[field]).trim() !== '';
            }).length;
        };
        function trackerAdvancedTerms(value) {
            return String(value || '').toLowerCase().split(',').map(function (term) {
                return term.trim();
            }).filter(function (term) { return term.length; });
        }
        /* The advanced panel filters the payload server-side, like the old tool:
           volume/position ranges and include/exclude words (values as strings,
           which is what the API filter DTO accepts). */
        function trackerFilterValue(value) {
            var raw = value === null || value === undefined ? '' : String(value).trim();
            return raw === '' ? null : raw;
        }
        function trackerApiFilters() {
            var filters = {};
            if (vm.trackerFilters.startDate) filters.startDate = vm.trackerFilters.startDate;
            if (vm.trackerFilters.endDate) filters.endDate = vm.trackerFilters.endDate;
            var volumeMin = trackerFilterValue(vm.trackerAdvancedApplied.volumeMin);
            var volumeMax = trackerFilterValue(vm.trackerAdvancedApplied.volumeMax);
            if (volumeMin !== null || volumeMax !== null) filters.volume = {min: volumeMin, max: volumeMax};
            var positionMin = trackerFilterValue(vm.trackerAdvancedApplied.positionMin);
            var positionMax = trackerFilterValue(vm.trackerAdvancedApplied.positionMax);
            if (positionMin !== null || positionMax !== null) filters.position = {min: positionMin, max: positionMax};
            var include = trackerAdvancedTerms(vm.trackerAdvancedApplied.include);
            if (include.length) filters.includedWords = include;
            var exclude = trackerAdvancedTerms(vm.trackerAdvancedApplied.exclude);
            if (exclude.length) filters.excludedWords = exclude;
            filters.sortBy = vm.trackerSort && vm.trackerSort.field || 'position';
            filters.sortDirection = vm.trackerSort && vm.trackerSort.dir < 0 ? 'DESC' : 'ASC';
            return filters;
        }
        /* Benchmarks: compare against the competitors added during onboarding.
           The filter only selects/deselects them, it never edits the project. */
        vm.trackerBenchmarksOpen = false;
        vm.trackerSelectedCompetitors = {};
        vm.toggleTrackerBenchmarks = function () {
            vm.trackerBenchmarksOpen = !vm.trackerBenchmarksOpen;
            if (vm.trackerBenchmarksOpen) vm.trackerAdvancedOpen = false;
        };
        vm.toggleTrackerCompetitor = function (id) {
            vm.trackerSelectedCompetitors[id] = !vm.trackerSelectedCompetitors[id];
        };
        vm.trackerCompetitors = function () {
            if (trackerCompetitorsCache) return trackerCompetitorsCache;
            var list = vm.tracker && Array.isArray(vm.tracker.competitors) ? vm.tracker.competitors : [];
            var seenColors = [];
            trackerCompetitorsCache = list.map(function (competitor, index) {
                var url = competitor.linkUrl || competitor.url || '';
                /* Every competitor gets its own colour: keep the stored one,
                   otherwise fall back to the palette without reusing a colour. */
                var color = competitor.color && seenColors.indexOf(String(competitor.color).toLowerCase()) < 0
                    ? competitor.color
                    : TRACKER_COMPETITOR_COLORS[index % TRACKER_COMPETITOR_COLORS.length];
                seenColors.push(String(color).toLowerCase());
                return {id: competitor.id, color: color,
                    favicon: url ? FavIconService.get(url) : null,
                    label: String(url).replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/$/, '')};
            });
            return trackerCompetitorsCache;
        };
        /* Stable array for ng-repeat: recomputed only when the selection changes. */
        var trackerSelectedCacheKey = null;
        var trackerSelectedCache = [];
        vm.trackerSelectedList = function () {
            var key = Object.keys(vm.trackerSelectedCompetitors).filter(function (id) {
                return vm.trackerSelectedCompetitors[id];
            }).join(',');
            if (key === trackerSelectedCacheKey) return trackerSelectedCache;
            trackerSelectedCacheKey = key;
            trackerSelectedCache = vm.trackerCompetitors().filter(function (competitor) {
                return vm.trackerSelectedCompetitors[competitor.id];
            });
            return trackerSelectedCache;
        };
        /* Primitive result: safe inside watched expressions (no digest loops). */
        vm.trackerCompetitorPosition = function (keyword, competitor) {
            var list = keyword && keyword.competitorSearches ? keyword.competitorSearches[competitor.id] : null;
            if (!Array.isArray(list)) return null;
            list = list.slice().sort(function (a, b) {
                return new Date((a && a.createdAt) || 0) - new Date((b && b.createdAt) || 0);
            });
            var latest = list.length ? list[list.length - 1] : null;
            return latest && latest.position ? trackerRounded(latest.position) : null;
        };
        vm.trackerOpenKeyword = null;
        vm.trackerKeywordCount = function () {
            if (!vm.tracker) return null;
            if (Array.isArray(vm.tracker.keywords)) {
                return vm.tracker.keywords.filter(trackerDeviceMatches).length;
            }
            return Number(vm.tracker.numberOfKeywords) || 0;
        };
        vm.trackerKeywordUsage = {used: null, limit: null, loading: false};
        vm.openTrackerSettingsKeywords = function () {
            $window.localStorage.setItem('openTrackerKeywordBuilder:' + vm.project.id, '1');
            $state.go('app.project.settings', {
                projectId: vm.project.id,
                activeTab: 'tracker',
                addKeyword: '1'
            });
        };
        var trackerKeywordUsageRequestId = 0;

        function trackerKeywordUsageFallback() {
            if (!vm.tracker) return 0;
            if (Array.isArray(vm.tracker.keywords)) return vm.tracker.keywords.length;
            return Number(vm.tracker.numberOfKeywords) || 0;
        }

        function trackerKeywordLimitFrom(accountInfo) {
            var limits = accountInfo && Array.isArray(accountInfo.limits)
                ? accountInfo.limits
                : [];
            var keywordLimit = limits.filter(function (service) {
                return service && service.alias === 'rank-tracker-keywords';
            })[0];
            if (!keywordLimit || keywordLimit.qtyAllowed === null || keywordLimit.qtyAllowed === undefined) {
                return null;
            }
            return Math.max(0, Number(keywordLimit.qtyAllowed) || 0);
        }

        function cachedTrackerAccountInfo() {
            try {
                return JSON.parse($window.localStorage.getItem('userInfo')) || null;
            } catch (error) {
                return null;
            }
        }

        function loadTrackerKeywordUsage() {
            var requestId = ++trackerKeywordUsageRequestId;
            var countSettled = false;
            var limitSettled = false;
            var loadingFinished = false;
            var fallbackUsed = trackerKeywordUsageFallback();
            var cachedInfo = cachedTrackerAccountInfo();
            var cachedLimit = trackerKeywordLimitFrom(cachedInfo);

            if (cachedLimit !== null) {
                vm.trackerKeywordUsage.limit = cachedLimit;
            }
            vm.trackerKeywordUsage.loading = true;

            var fallbackTimer = $timeout(function () {
                if (destroyed || requestId !== trackerKeywordUsageRequestId) return;
                loadingFinished = true;
                vm.trackerKeywordUsage.loading = false;
            }, 1200);

            function finishLoadingIfComplete() {
                if (loadingFinished || !countSettled || !limitSettled ||
                    destroyed || requestId !== trackerKeywordUsageRequestId) return;
                loadingFinished = true;
                $timeout.cancel(fallbackTimer);
                vm.trackerKeywordUsage.loading = false;
            }

            KeywordTrackerService.keywordCountTracker()
                .then(function (response) {
                    if (destroyed || requestId !== trackerKeywordUsageRequestId) return;
                    var keywords = response && response.data && response.data.keywords;
                    vm.trackerKeywordUsage.used = keywords === null || keywords === undefined
                        ? fallbackUsed
                        : Math.max(0, Number(keywords) || 0);
                })
                .catch(function () {
                    if (destroyed || requestId !== trackerKeywordUsageRequestId) return;
                    vm.trackerKeywordUsage.used = fallbackUsed;
                })
                .finally(function () {
                    countSettled = true;
                    finishLoadingIfComplete();
                });

            UserService.limits(true)
                .then(function (response) {
                    if (destroyed || requestId !== trackerKeywordUsageRequestId) return;
                    var limit = trackerKeywordLimitFrom(response && response.data);
                    if (limit !== null) vm.trackerKeywordUsage.limit = limit;
                })
                .catch(function () {
                    if (destroyed || requestId !== trackerKeywordUsageRequestId) return;
                    vm.trackerKeywordUsage.limit = cachedLimit;
                })
                .finally(function () {
                    limitSettled = true;
                    finishLoadingIfComplete();
                });
        }
        /* Column sorting: click a header to sort, click again to reverse. */
        vm.trackerSort = {field: 'position', dir: 1};
        vm.trackerRowsAreComplete = function () {
            var loaded = vm.tracker && Array.isArray(vm.tracker.keywords)
                ? vm.tracker.keywords.length : 0;
            var total = vm.tracker ? Number(vm.tracker.numberOfKeywords) : 0;
            return total > 0 && loaded >= total;
        };
        vm.sortTrackerBy = function (field) {
            if (vm.trackerSort.field === field) {
                vm.trackerSort.dir = -vm.trackerSort.dir;
            } else {
                vm.trackerSort = {field: field, dir: 1};
            }
            /* A partial payload must be sorted in SQL. Local sorting would only
               reorder the downloaded slice. */
            if (!vm.trackerRowsAreComplete()) return reloadTracker();
            trackerRowsCacheKey = null;
        };
        vm.trackerSortValue = function (keyword) {
            var end = vm.trackerSort.dir > 0 ? 1e9 : -1e9;
            var state;
            switch (vm.trackerSort.field) {
                case 'keyword':
                    return String(keyword.keyword || keyword.query || '').toLowerCase();
                case 'difference':
                    state = vm.trackerKeywordState(keyword);
                    return state.difference === null || state.difference === undefined ? end : state.difference;
                case 'volume':
                    state = vm.trackerKeywordState(keyword);
                    return state.volume ? Number(state.volume) : end;
                case 'indexed':
                    return vm.trackerKeywordState(keyword).indexed || 0;
                case 'topRanked':
                    state = vm.trackerKeywordState(keyword);
                    return state.topRanked ? String(state.topRanked).toLowerCase() : end;
                case 'location':
                    return String(keyword.deviceId || '') + '-' + String(keyword.countryCode || '');
                default:
                    if (vm.trackerSort.field.indexOf('competitor:') === 0) {
                        var competitor = vm.trackerCompetitors().filter(function (item) {
                            return 'competitor:' + item.id === vm.trackerSort.field;
                        })[0];
                        var position = competitor ? vm.trackerCompetitorPosition(keyword, competitor) : null;
                        return position ? position : end;
                    }
                    state = vm.trackerKeywordState(keyword);
                    return state.position ? state.position : end;
            }
        };
        vm.trackerRows = function () {
            var selected = vm.trackerSelectedList();
            var cacheKey = [
                trackerRowsRevision,
                String(vm.form.trackerSearch || ''),
                String(vm.trackerSort.field || ''),
                String(vm.trackerSort.dir || 1),
                selected.map(function (item) { return item.id; }).join(',')
            ].join('|');
            if (trackerRowsCache !== null && trackerRowsCacheKey === cacheKey) return trackerRowsCache;

            var list = (vm.tracker && Array.isArray(vm.tracker.keywords) ? vm.tracker.keywords : [])
                .filter(vm.trackerKeywordMatches)
                .slice();
            if (vm.trackerRowsAreComplete()) {
                var direction = vm.trackerSort.dir < 0 ? -1 : 1;
                list.sort(function (a, b) {
                    var left = vm.trackerSortValue(a);
                    var right = vm.trackerSortValue(b);
                    if (left === right) return 0;
                    return (left < right ? -1 : 1) * direction;
                });
            }
            trackerRowsCacheKey = cacheKey;
            trackerRowsCache = list;
            return list;
        };
        vm.trackerKey = function (keyword) {
            return keyword ? String(keyword.id) + '-' + String(keyword.deviceId) : null;
        };
        vm.toggleTrackerKeyword = function (keyword) {
            var key = vm.trackerKey(keyword);
            vm.trackerHoverPoint = null;
            if (vm.trackerOpenKeyword === key) {
                vm.trackerOpenKeyword = null;
                vm.trackerOpenState = null;
                vm.trackerOpenChart = null;
                vm.trackerOpenGsc = null;
                vm.trackerOpenKeywordItem = null;
                vm.trackerOpenPages = [];
                return;
            }
            vm.trackerOpenKeyword = key;
            vm.trackerOpenState = vm.trackerKeywordState(keyword);
            vm.trackerOpenChart = vm.trackerChart(keyword);
            vm.trackerOpenGsc = trackerSearchConsoleOverview(keyword);
            vm.trackerOpenKeywordItem = keyword;
            vm.trackerOpenPages = trackerKeywordPageRows(keyword);
            loadTrackerGscConnection();
        };
        vm.trackerOpenState = null;
        vm.trackerOpenChart = null;
        vm.trackerOpenGsc = null;
        vm.trackerOpenKeywordItem = null;
        vm.trackerOpenPages = [];
        var trackerKeywordStateCache = {};
        var trackerChartCache = {};
        var trackerRowsCache = null;
        var trackerRowsCacheKey = null;
        var trackerRowsRevision = 0;
        function resetTrackerKeywordCaches() {
            trackerKeywordStateCache = {};
            trackerChartCache = {};
            trackerRowsCache = null;
            trackerRowsCacheKey = null;
            trackerRowsRevision += 1;
        }
        function trackerSearches(keyword) {
            var list = keyword && Array.isArray(keyword.searches) ? keyword.searches.slice() : [];
            /* Oldest first: the last entry is the current check. */
            list.sort(function (a, b) {
                return new Date((a && a.createdAt) || 0) - new Date((b && b.createdAt) || 0);
            });
            return list;
        }
        function trackerRounded(value) {
            if (value === null || value === undefined || value === '') return null;
            var number = Number(value);
            return isNaN(number) ? null : Math.round(number);
        }
        vm.trackerDisplayPosition = function (value) {
            var position = trackerRounded(value);
            if (position === null) return '—';
            return position > 100 ? $translate.instant('workspace.trackerOver50') : position;
        };
        vm.trackerKeywordState = function (keyword) {
            var key = vm.trackerKey(keyword);
            if (trackerKeywordStateCache[key]) return trackerKeywordStateCache[key];
            var list = trackerSearches(keyword);
            var usable = list.filter(function (search) {
                return search && !search.pending
                    && typeof search.position === 'number' && search.position > 0;
            });
            var latestTracker = null;
            var latestSearchConsole = null;
            var latestGscMetrics = null;
            for (var i = usable.length - 1; i >= 0; i--) {
                var point = usable[i];
                if (!latestTracker && point.source !== 'search-console') latestTracker = point;
                if (!latestSearchConsole && point.source === 'search-console') latestSearchConsole = point;
                if (!latestGscMetrics && (point.source === 'search-console' || point.searchConsole)) {
                    latestGscMetrics = point.source === 'search-console' ? point : point.searchConsole;
                }
                if (latestTracker && latestSearchConsole && latestGscMetrics) break;
            }
            var latest = latestTracker || latestSearchConsole;
            var tracking = !latest;
            var source = tracking ? null : (latest.source || 'dataforseo');
            var selectedPosition = latest ? trackerRounded(latest.position) : null;
            var ranked = !tracking && selectedPosition !== null && selectedPosition < 50;
            var gscPages = latestGscMetrics && Array.isArray(latestGscMetrics.pages)
                ? latestGscMetrics.pages : [];
            var gscTopPage = null;
            gscPages.forEach(function (page) {
                if (!page || !page.url) return;
                if (!gscTopPage || Number(page.position) < Number(gscTopPage.position)) gscTopPage = page;
            });
            var trackerIndexed = ranked && latestTracker && latestTracker.count
                ? Number(latestTracker.count) : 0;
            var gscIndexed = latestGscMetrics
                ? Number(latestGscMetrics.count || latestGscMetrics.indexed) || gscPages.length
                : 0;
            var difference = null;
            if (!tracking) {
                var sameSource = usable.filter(function (search) {
                    return (search.source || 'dataforseo') === source;
                });
                var oldest = sameSource.length > 1 ? sameSource[0] : null;
                var oldestPosition = oldest ? trackerRounded(oldest.position) : null;
                if (oldestPosition !== null && selectedPosition !== null
                    && oldestPosition <= 100 && selectedPosition <= 100) {
                    /* Positive: the keyword gained positions between first and last check. */
                    difference = oldestPosition - selectedPosition;
                }
            }
            trackerKeywordStateCache[key] = {
                list: list,
                tracking: tracking,
                position: tracking ? null : selectedPosition,
                lastCheckAt: tracking ? null : (latest && latest.createdAt) || null,
                source: source,
                metricType: tracking ? null : (latest && latest.metricType || 'exact'),
                searchConsole: latestGscMetrics,
                difference: difference,
                volume: keyword && keyword.avgVolume || null,
                indexed: trackerIndexed || gscIndexed,
                topRanked: (ranked && latestTracker && latestTracker.linkUrl)
                    || (latestGscMetrics && (latestGscMetrics.topRanked || latestGscMetrics.linkUrl))
                    || (gscTopPage && gscTopPage.url)
                    || null,
                pages: latest && Array.isArray(latest.pages) ? latest.pages : []
            };
            return trackerKeywordStateCache[key];
        };
        /* Sparkline of the position history: 1 is the top, 100 the bottom. */
        vm.trackerHoverPoint = null;
        vm.hoverTrackerPoint = function (point) { vm.trackerHoverPoint = point; };
        function nearestTrackerPoint(event, points) {
            if (!points || !points.length || !event || !event.currentTarget) return null;
            var bounds = event.currentTarget.getBoundingClientRect();
            if (!bounds.width) return points[0];
            var x = ((event.clientX - bounds.left) / bounds.width) * 100;
            var nearest = points[0];
            for (var i = 1; i < points.length; i++) {
                if (Math.abs(points[i].x - x) < Math.abs(nearest.x - x)) nearest = points[i];
            }
            return nearest;
        }
        vm.hoverTrackerPointAt = function (event, chart) {
            vm.trackerHoverPoint = nearestTrackerPoint(event, chart && chart.points);
        };
        /* Step chart spanning the selected range: where there is no check the
           last known value carries forward until it changes. Window and scale
           can be shared across series so every line is comparable. */
        function trackerChartWindow(points) {
            var start = vm.trackerRange && vm.trackerRange.startDate ? new Date(vm.trackerRange.startDate) : new Date(points[0].createdAt);
            var end = vm.trackerRange && vm.trackerRange.endDate ? new Date(vm.trackerRange.endDate) : new Date(points[points.length - 1].createdAt);
            if (end <= start) end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
            return {start: start, end: end};
        }
        function trackerDisplayDate(value) {
            var key = trackerDayKey(value);
            return key ? key.slice(8, 10) + '/' + key.slice(5, 7) + '/' + key.slice(0, 4) : '';
        }
        function buildTrackerStepChart(points, window, scale) {
            if (!points.length) return null;
            window = window || trackerChartWindow(points);
            var start = window.start;
            var end = window.end;
            var list = points.filter(function (point) {
                var date = new Date(point.createdAt);
                return date >= start && date <= end;
            });
            if (!list.length) return null;
            var values = list.map(function (point) { return Math.min(point.position, 100); });
            var best = scale ? scale.best : Math.min.apply(null, values);
            var worst = scale ? scale.worst : Math.max.apply(null, values);
            var span = Math.max(worst - best, 1);
            var flat = worst === best;
            var xAt = function (date) {
                return 3 + ((new Date(date).getTime() - start.getTime()) / (end.getTime() - start.getTime())) * 94;
            };
            var yAt = function (position) {
                return flat ? 20 : 3 + ((position - best) / span) * 34;
            };
            var markers = [];
            list.forEach(function (point, index) {
                var px = xAt(point.createdAt);
                var py = yAt(values[index]);
                markers.push({x: px, y: py, position: point.position, day: trackerDayKey(point.createdAt),
                    source: point.source || 'dataforseo',
                    date: trackerDisplayDate(point.createdAt)});
            });
            var curve = [{x: xAt(start), y: markers[0].y}]
                .concat(markers)
                .concat([{x: xAt(end), y: markers[markers.length - 1].y}]);
            function smoothPath(points) {
                if (!points.length) return '';
                /* Dense histories have irregular date gaps. Straight segments stay
                   monotonic on the x axis; spline control points can loop back. */
                var path = 'M' + points[0].x.toFixed(2) + ',' + points[0].y.toFixed(2);
                for (var index = 1; index < points.length; index++) {
                    path += ' L' + points[index].x.toFixed(2) + ',' + points[index].y.toFixed(2);
                }
                return path;
            }
            return {
                path: smoothPath(curve),
                points: markers,
                best: best,
                worst: worst,
                from: trackerDisplayDate(start),
                to: trackerDisplayDate(end)
            };
        }
        vm.trackerChart = function (keyword) {
            var key = vm.trackerKey(keyword);
            if (Object.prototype.hasOwnProperty.call(trackerChartCache, key)) {
                return trackerChartCache[key];
            }
            var list = trackerSearches(keyword).filter(function (search) {
                return search && !search.pending
                    && typeof search.position === 'number'
                    && search.position > 0 && search.position <= 100;
            });
            var history = list.map(function (search) {
                return {createdAt: search.createdAt, position: trackerRounded(search.position)};
            });
            if (history.length === 1) {
                var window = trackerChartWindow(history);
                history = [
                    {createdAt: window.start, position: history[0].position},
                    {createdAt: window.end, position: history[0].position}
                ];
            }
            trackerChartCache[key] = history.length
                ? buildTrackerGscChart(history, 'position', 'workspace.trackerChartTitle', '#ff8a00', true)
                : null;
            return trackerChartCache[key];
        };
        function trackerSearchConsoleHistory(keyword) {
            var history = [];
            trackerSearches(keyword).forEach(function (search) {
                var metrics = search && (search.source === 'search-console'
                    ? search : search.searchConsole);
                if (!metrics || !search.createdAt) return;
                history.push({
                    createdAt: search.createdAt,
                    clicks: Number(metrics.clicks) || 0,
                    impressions: Number(metrics.impressions) || 0,
                    ctr: Number(metrics.ctr) || 0,
                    position: Number(metrics.position)
                });
            });
            return history;
        }
        function trackerPagesFromSearch(search) {
            if (!search) return [];
            var pages = search.pages;
            if (typeof pages === 'string') {
                try { pages = JSON.parse(pages); } catch (err) { pages = []; }
            }
            if (!Array.isArray(pages) || !pages.length) {
                pages = search.linkUrl
                    ? [{url: search.linkUrl, position: search.position}]
                    : [];
            }
            return pages.filter(function (page) { return page && page.url; });
        }
        function trackerKeywordPageRows(keyword) {
            if (!keyword) return [];
            var rows = [];
            var state = vm.trackerKeywordState(keyword);
            var ownPages = state.pages && state.pages.length
                ? state.pages
                : (state.searchConsole && state.searchConsole.pages || []);
            ownPages.forEach(function (page) {
                if (!page || !page.url) return;
                rows.push({
                    owner: vm.project && vm.project.name || vm.url || '',
                    favicon: vm.faviconUrl,
                    url: page.url,
                    position: trackerRounded(page.position),
                    ours: true
                });
            });
            vm.trackerSelectedList().forEach(function (competitor) {
                var searches = keyword.competitorSearches && keyword.competitorSearches[competitor.id];
                if (!Array.isArray(searches) || !searches.length) return;
                searches = searches.slice().sort(function (a, b) {
                    return new Date((a && a.createdAt) || 0) - new Date((b && b.createdAt) || 0);
                });
                var latest = searches[searches.length - 1];
                trackerPagesFromSearch(latest).forEach(function (page) {
                    rows.push({
                        owner: competitor.label,
                        favicon: competitor.favicon,
                        url: page.url,
                        position: trackerRounded(page.position),
                        ours: false
                    });
                });
            });
            return rows.sort(function (left, right) {
                var a = left.position === null ? Infinity : left.position;
                var b = right.position === null ? Infinity : right.position;
                return a - b || String(left.owner).localeCompare(String(right.owner));
            });
        }
        vm.refreshTrackerOpenPages = function () {
            if (vm.trackerOpenKeywordItem) {
                vm.trackerOpenPages = trackerKeywordPageRows(vm.trackerOpenKeywordItem);
            }
        };
        function buildTrackerGscChart(history, metric, tkey, color, reverse) {
            var labels = history.map(function (point) {
                var date = String(point.createdAt || '');
                return date.slice(8, 10) + '/' + date.slice(5, 7);
            });
            var chartWindow = trackerChartWindow(history);
            var values = history.map(function (point) {
                var value = Number(point[metric]);
                return isNaN(value) ? null : value;
            });
            var latest = values.length ? values[values.length - 1] : null;
            var baseOptions = {
                responsive: true,
                maintainAspectRatio: false,
                legend: {display: false},
                layout: {padding: {top: 6, right: 6, bottom: 4, left: 6}},
                tooltips: {mode: 'index', intersect: false, position: 'nearest', caretPadding: 6},
                hover: {mode: 'nearest', intersect: false}
            };
            var yAxis = {
                type: 'linear',
                display: false,
                ticks: reverse ? {reverse: true} : {beginAtZero: true}
            };
            var fill = color === '#ff8a00' ? 'rgba(255, 138, 0, .18)'
                : color === '#2f90de' ? 'rgba(47, 144, 222, .18)'
                    : 'rgba(168, 74, 178, .16)';
            return {
                tkey: tkey,
                display: latest === null ? '—' : (metric === 'position'
                    ? latest.toFixed(1)
                    : $filter('number')(latest, 0)),
                labels: labels,
                data: [values],
                series: [$translate.instant(tkey)],
                datasets: [{
                    borderColor: color,
                    backgroundColor: fill,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    borderWidth: 2,
                    fill: 'start',
                    lineTension: .18,
                    spanGaps: false
                }],
                options: Object.assign({}, baseOptions, {
                    scales: {
                        xAxes: [{display: false}],
                        yAxes: [yAxis]
                    }
                }),
                from: trackerDisplayDate(chartWindow.start),
                to: trackerDisplayDate(chartWindow.end)
            };
        }
        function trackerSearchConsoleOverview(keyword) {
            var history = trackerSearchConsoleHistory(keyword);
            if (!history.length) return null;
            var charts = [
                buildTrackerGscChart(history, 'clicks', 'workspace.trackerClicks', '#ff8a00'),
                buildTrackerGscChart(history, 'impressions', 'workspace.trackerImpressions', '#2f90de'),
                buildTrackerGscChart(history, 'position', 'workspace.trackerGscPosition', '#a84ab2', true)
            ].filter(Boolean);
            return {
                history: history,
                charts: charts,
                latest: history[history.length - 1]
            };
        }
        function loadTrackerGscConnection() {
            if (!vm.project || vm.trackerGsc.checked || vm.trackerGsc.checking) return;
            vm.trackerGsc.checking = true;
            vm.trackerGsc.error = false;
            SearchConsoleService.getProjectConnection(vm.project.id).then(function (connection) {
                if (destroyed) return;
                vm.trackerGsc.connected = !!(connection && connection.propertyUrl);
                vm.trackerGsc.property = connection && connection.propertyUrl || null;
            }).catch(function () {
                if (!destroyed) vm.trackerGsc.error = true;
            }).finally(function () {
                if (!destroyed) {
                    vm.trackerGsc.checking = false;
                    vm.trackerGsc.checked = true;
                }
            });
        }
        /* Top charts: average position over time (ours + selected benchmarks)
           and keyword distribution. */
        var trackerAverageCache = null;
        var trackerAverageCacheKey = null;
        var trackerDistributionCache = null;
        vm.trackerAverageHover = null;
        vm.hoverTrackerAverage = function (point) {
            if (!point || !trackerAverageCache) { vm.trackerAverageHover = null; return; }
            var values = trackerAverageCache.byDay[point.day] || {};
            var rows = [];
            if (values.ours && typeof values.ours.position === 'number') {
                rows.push({
                    color: 'var(--sto-color-primary)',
                    favicon: vm.faviconUrl || null,
                    position: trackerRounded(values.ours.position),
                    source: values.ours.source
                });
            }
            trackerAverageCache.lines.forEach(function (line) {
                if (values[line.id] && typeof values[line.id].position === 'number') {
                    rows.push({
                        color: line.color,
                        favicon: line.favicon || null,
                        position: trackerRounded(values[line.id].position),
                        source: values[line.id].source
                    });
                }
            });
            vm.trackerAverageHover = {x: point.x, y: point.y, date: point.date, rows: rows};
        };
        vm.hoverTrackerAverageAt = function (event, chart) {
            var point = nearestTrackerPoint(event, chart && chart.ours && chart.ours.points);
            if (!point) {
                vm.trackerAverageHover = null;
                return;
            }
            vm.hoverTrackerAverage(point);
        };
        function trackerDayKey(value) {
            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
            var date = value instanceof Date ? value : new Date(value);
            if (isNaN(date.getTime())) return '';
            return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                ('0' + date.getDate()).slice(-2);
        }
        function trackerCurrentPosition(keyword) {
            var list = trackerSearches(keyword);
            for (var i = list.length - 1; i >= 0; i--) {
                if (!list[i].pending
                    && typeof list[i].position === 'number' && list[i].position > 0) {
                    return list[i].position;
                }
            }
            return null;
        }
        function trackerSeriesSearches(list) {
            return (Array.isArray(list) ? list : []).filter(function (search) {
                return search && !search.pending
                    && typeof search.position === 'number'
                    && search.position > 0 && search.position <= 100;
            }).sort(function (a, b) {
                return new Date((a && a.createdAt) || 0) - new Date((b && b.createdAt) || 0);
            });
        }
        vm.trackerAverageChart = function () {
            /* The benchmark selection drives the lines: rebuild when it changes. */
            var selected = vm.trackerSelectedList();
            var cacheKey = selected.map(function (competitor) { return competitor.id; }).join(',');
            if (trackerAverageCache !== null && trackerAverageCacheKey === cacheKey) return trackerAverageCache;
            trackerAverageCacheKey = cacheKey;
            var keywords = (vm.tracker && Array.isArray(vm.tracker.keywords) ? vm.tracker.keywords : [])
                .filter(trackerDeviceMatches);
            /* Our series: one list of checks per keyword, the same the table uses. */
            var ours = keywords.map(function (keyword) {
                return trackerSeriesSearches(trackerSearches(keyword));
            }).filter(function (list) { return list.length; });
            /* Selected competitors: same structure, from competitorSearches. */
            var competitors = selected.map(function (competitor) {
                var series = keywords.map(function (keyword) {
                    var list = keyword && keyword.competitorSearches ? keyword.competitorSearches[competitor.id] : null;
                    return trackerSeriesSearches(list);
                }).filter(function (list) { return list.length; });
                return {id: competitor.id, label: competitor.label, color: competitor.color || '#2296f3',
                    favicon: competitor.favicon || null, series: series};
            }).filter(function (entry) { return entry.series.length; });
            /* Every check day of every series, so all lines share the x axis. */
            var days = {};
            [ours].concat(competitors.map(function (entry) { return entry.series; })).forEach(function (seriesList) {
                seriesList.forEach(function (list) {
                    list.forEach(function (search) { days[trackerDayKey(search.createdAt)] = true; });
                });
            });
            var dayList = Object.keys(days).sort();
            function preparedSeries(seriesList) {
                return seriesList.map(function (list) {
                    return list.map(function (search) {
                        return {
                            day: trackerDayKey(search.createdAt),
                            search: search
                        };
                    });
                });
            }
            function averagePoints(seriesList) {
                var prepared = preparedSeries(seriesList);
                var pointers = prepared.map(function () { return -1; });
                return dayList.map(function (day) {
                    var values = [];
                    prepared.forEach(function (list, index) {
                        while (pointers[index] + 1 < list.length && list[pointers[index] + 1].day <= day) {
                            pointers[index] += 1;
                        }
                        if (pointers[index] >= 0) {
                            var known = list[pointers[index]].search;
                            values.push({
                                position: known.position,
                                source: known.source || 'dataforseo'
                            });
                        }
                    });
                    if (!values.length) return null;
                    var average = values.reduce(function (sum, value) {
                        return sum + value.position;
                    }, 0) / values.length;
                    var sources = values.map(function (value) { return value.source; });
                    var source = sources.every(function (value) { return value === sources[0]; })
                        ? sources[0] : 'mixed';
                    return {createdAt: day, position: Math.round(average * 10) / 10, source: source};
                }).filter(function (point) { return point; });
            }
            var ourPoints = averagePoints(ours);
            if (!ourPoints.length) { trackerAverageCache = null; return null; }
            var lines = competitors.map(function (entry) {
                return {id: entry.id, label: entry.label, color: entry.color, favicon: entry.favicon,
                    points: averagePoints(entry.series)};
            }).filter(function (line) { return line.points.length; });
            /* Shared window and y scale, so competitor lines are comparable with ours. */
            var window = trackerChartWindow(ourPoints);
            var scale = null;
            if (lines.length) {
                var best = Infinity;
                var worst = -Infinity;
                [ourPoints].concat(lines.map(function (line) { return line.points; })).forEach(function (points) {
                    points.forEach(function (point) {
                        var date = new Date(point.createdAt);
                        if (date < window.start || date > window.end) return;
                        var value = Math.min(point.position, 100);
                        best = Math.min(best, value);
                        worst = Math.max(worst, value);
                    });
                });
                if (isFinite(best)) scale = {best: best, worst: worst};
            }
            var chart = buildTrackerStepChart(ourPoints, window, scale);
            if (!chart) { trackerAverageCache = null; return null; }
            /* Values per check day, for the multi-series hover tooltip. */
            var byDay = {};
            ourPoints.forEach(function (point) {
                (byDay[point.createdAt] = byDay[point.createdAt] || {}).ours = {
                    position: point.position,
                    source: point.source || 'dataforseo'
                };
            });
            var lineCharts = [];
            lines.forEach(function (line) {
                var lineChart = buildTrackerStepChart(line.points, window, scale);
                if (!lineChart) return;
                line.points.forEach(function (point) {
                    (byDay[point.createdAt] = byDay[point.createdAt] || {})[line.id] = {
                        position: point.position,
                        source: point.source || 'dataforseo'
                    };
                });
                /* Favicon badge pinned where the line starts, to tell it apart. */
                var first = lineChart.points[0];
                lineCharts.push({id: line.id, label: line.label, color: line.color, favicon: line.favicon,
                    path: lineChart.path, tagX: 3, tagY: first ? first.y * 2.5 : 20});
            });
            trackerAverageCache = {
                ours: chart,
                lines: lineCharts,
                byDay: byDay,
                from: chart.from,
                to: chart.to,
                last: trackerRounded(ourPoints[ourPoints.length - 1].position),
                keywords: ours.length,
                hasSearchConsole: ours.some(function (series) {
                    return series.some(function (search) { return search.source === 'search-console'; });
                })
            };
            return trackerAverageCache;
        };
        vm.trackerDistribution = function () {
            if (trackerDistributionCache !== null) return trackerDistributionCache;
            var buckets = [
                {label: 'workspace.trackerBucket1', color: '#2ed47a', max: 3},
                {label: 'workspace.trackerBucket2', color: '#4fc9d8', max: 10},
                {label: 'workspace.trackerBucket3', color: '#e8c84f', max: 20},
                {label: 'workspace.trackerBucket4', color: '#ff9700', max: 50},
                {label: 'workspace.trackerBucket5', color: '#a855f7', max: Infinity}
            ].map(function (bucket) {
                return {label: bucket.label, color: bucket.color, max: bucket.max, count: 0, percent: 0};
            });
            var pendingCount = 0;
            var keywords = (vm.tracker && Array.isArray(vm.tracker.keywords) ? vm.tracker.keywords : [])
                .filter(trackerDeviceMatches);
            keywords.forEach(function (keyword) {
                if (vm.trackerKeywordState(keyword).tracking) {
                    pendingCount += 1;
                    return;
                }
                var position = trackerCurrentPosition(keyword);
                var value = typeof position === 'number' ? position : 101;
                for (var i = 0; i < buckets.length; i++) {
                    if (value <= buckets[i].max) { buckets[i].count += 1; break; }
                }
            });
            var measuredCount = keywords.length - pendingCount;
            buckets.forEach(function (bucket) {
                bucket.percent = measuredCount ? Math.round((bucket.count / measuredCount) * 100) : 0;
            });
            trackerDistributionCache = {buckets: buckets, total: measuredCount, pending: pendingCount};
            return trackerDistributionCache;
        };
        vm.trackerPendingCount = function () {
            return vm.trackerDistribution().pending;
        };
        vm.gscDimensionLabel = function () {
            if (vm.gscView === 'query') return $translate.instant('workspace.gscFilterQuery');
            if (vm.gscView === 'page') return $translate.instant('workspace.gscFilterPage');
            if (vm.gscView === 'country') return $translate.instant('workspace.gscFilterCountry');
            if (vm.gscView === 'device') return $translate.instant('workspace.gscFilterDevice');
            return $translate.instant('workspace.gscFilterSearchAppearance');
        };
        vm.gscPageCount = function () {
            if (!vm.gscTotalRowsKnown) return '…';
            var size = Number(vm.gscPageSize) || 25;
            return Math.max(1, Math.ceil((Number(vm.gscTotalRows) || 0) / size));
        };
        vm.gscCurrentPage = function () {
            var size = Number(vm.gscPageSize) || 25;
            return Math.floor((Number(vm.gscOffset) || 0) / size) + 1;
        };
        vm.gscRangeLabel = function () {
            var offset = Number(vm.gscOffset) || 0;
            var rowCount = (vm.gsc.rows || []).length;
            if (!vm.gscTotalRowsKnown) {
                if (!rowCount) return '0';
                return (offset + 1) + '–' + (offset + rowCount);
            }
            var total = Number(vm.gscTotalRows) || 0;
            if (!total) return '0';
            var start = Math.min(offset + 1, total);
            var end = Math.min(offset + rowCount, total);
            return start + '–' + end;
        };
        vm.gscTotalLabel = function () {
            if (!vm.gscTotalRowsKnown) return '…';
            var total = $filter('number')(Number(vm.gscTotalRows) || 0, 0);
            return vm.gscTruncated ? total + '+' : total;
        };
        vm.gscHasNext = function () {
            if (!vm.gscTotalRowsKnown) return !!vm.gscHasMoreRows;
            return (Number(vm.gscOffset) || 0) + (vm.gsc.rows || []).length < (Number(vm.gscTotalRows) || 0);
        };
        vm.changeGscPageSize = function () {
            $localStorage.searchConsolePageSize = vm.gscPageSize;
            vm.gscOffset = 0;
            loadGscRows();
        };
        vm.sortGscBy = function (field) {
            if (vm.gscSort.field === field) {
                vm.gscSort.direction = vm.gscSort.direction === 'asc' ? 'desc' : 'asc';
            } else {
                vm.gscSort = {
                    field: field,
                    direction: field === 'key' ? 'asc' : 'desc'
                };
            }
            vm.gscOffset = 0;
            loadGscRows();
        };
        vm.gscAriaSort = function (field) {
            if (vm.gscSort.field !== field) return 'none';
            return vm.gscSort.direction === 'asc' ? 'ascending' : 'descending';
        };
        vm.applyGscSearch = function () {
            vm.gscOffset = 0;
            loadGscRows();
        };
        function loadOverviewTraffic() {
            if (!vm.project || vm.overviewTraffic.checked || vm.overviewTraffic.loading) return;
            vm.overviewTraffic.loading = true;
            vm.overviewTraffic.error = false;
            vm.overviewTraffic.checked = true;
            TrafficInsightsService.getProject(vm.project.id, null, 5)
                .then(function (data) {
                    if (destroyed) return;
                    vm.overviewTraffic.data = data;
                    buildOverviewTrafficChart(data);
                })
                .catch(function () {
                    if (!destroyed) {
                        vm.overviewTraffic.error = true;
                        vm.overviewTraffic.checked = false;
                    }
                })
                .finally(function () {
                    if (!destroyed) vm.overviewTraffic.loading = false;
                });
        }
        function loadOverviewSearchConsole() {
            if (!vm.project || vm.overviewGsc.checked) return;
            vm.overviewGsc.checked = true;
            vm.overviewGsc.loading = true;
            ensureGscRange();
            SearchConsoleService.getProjectConnection(vm.project.id)
                .then(function (connection) {
                    if (destroyed) return;
                    vm.overviewGsc.connected = !!(connection && connection.propertyUrl);
                    vm.overviewGsc.property = connection && connection.propertyUrl || null;
                    if (!vm.overviewGsc.connected) return null;
                    return SearchConsoleService.getProjectSummary(vm.project.id, vm.gscFilters)
                        .then(function (summary) {
                            if (!destroyed) vm.overviewGsc.summary = summary;
                        });
                })
                .catch(function () {
                    if (!destroyed) {
                        vm.overviewGsc.error = true;
                        vm.overviewGsc.checked = false;
                    }
                })
                .finally(function () {
                    if (!destroyed) vm.overviewGsc.loading = false;
                });
        }
        function loadOverviewRankTracker() {
            if (!vm.tracker || vm.overviewTracker.checked || vm.overviewTracker.loading) return;
            vm.overviewTracker.checked = true;
            vm.overviewTracker.loading = true;
            vm.overviewTracker.error = false;
            reloadTracker(null, {silent: true})
                .catch(function () {
                    if (!destroyed) {
                        vm.overviewTracker.error = true;
                        vm.overviewTracker.checked = false;
                    }
                })
                .finally(function () {
                    if (!destroyed) vm.overviewTracker.loading = false;
                });
        }
        function loadOverviewInsights() {
            if (vm.overviewTraffic.data) {
                buildOverviewTrafficChart(vm.overviewTraffic.data);
            } else {
                loadOverviewTraffic();
            }
            loadOverviewRankTracker();
            loadOverviewSearchConsole();
        }
        vm.overviewTrafficChange = function () {
            var trend = vm.overviewTraffic.data && vm.overviewTraffic.data.trend;
            if (!trend || trend.length < 2) return null;
            var complete = trend.slice(-12);
            var first = Number(complete[0] && complete[0].traffic);
            var last = Number(complete[complete.length - 1] && complete[complete.length - 1].traffic);
            if (!first) return last ? 100 : 0;
            return ((last - first) / first) * 100;
        };
        function overviewTrafficMonthLabel(item) {
            var date = new Date(Date.UTC(item.year, item.month - 1, 1));
            var label = date.toLocaleDateString($translate.use() || 'en-US', {
                month: 'short',
                timeZone: 'UTC'
            }).replace('.', '');
            return label.charAt(0).toUpperCase() + label.slice(1);
        }
        function buildOverviewTrafficChart(data) {
            var trend = data && Array.isArray(data.trend) ? data.trend.slice(-12) : [];
            vm.overviewTrafficChart = trend.length > 0;
            if (!trend.length) return;
            $timeout(function () {
                var canvas = document.getElementById('overviewTrafficTrendChart');
                if (!canvas || destroyed) return;
                var context = canvas.getContext('2d');
                var trafficFill = context.createLinearGradient(0, 0, 0, canvas.height || 150);
                trafficFill.addColorStop(0, 'rgba(168, 85, 247, .24)');
                trafficFill.addColorStop(.58, 'rgba(192, 132, 252, .11)');
                trafficFill.addColorStop(1, suiteThemeToken('--sto-color-surface', '#fff'));
                var darkMode = document.documentElement.getAttribute('data-theme') === 'dark';
                var chartSurface = suiteThemeToken('--sto-color-surface', '#fff');
                var chartText = suiteThemeToken('--sto-color-text', '#18181b');
                var chartMuted = darkMode
                    ? '#b4b4bd'
                    : suiteThemeToken('--sto-color-text-subtle', '#a1a1aa');
                var chartTooltip = suiteThemeToken('--sto-color-surface-hover', '#18181b');
                var organicLabel = $translate.instant('workspace.trafficOrganic');
                var locale = $translate.use() || 'en-US';
                var definitions = [
                    {
                        label: organicLabel,
                        values: trend.map(function (item) { return Number(item.traffic) || 0; }),
                        color: '#a855f7',
                        background: trafficFill,
                        dash: [],
                        fill: true
                    }
                ];
                if (overviewTrafficChartInstance) overviewTrafficChartInstance.destroy();
                overviewTrafficChartInstance = new Chart(context, {
                    type: 'line',
                    data: {
                        labels: trend.map(overviewTrafficMonthLabel),
                        datasets: definitions.map(function (series) {
                            return {
                                label: series.label,
                                data: series.values,
                                borderColor: series.color,
                                backgroundColor: series.background,
                                borderWidth: 2.5,
                                borderDash: series.dash,
                                fill: series.fill,
                                lineTension: .35,
                                pointRadius: 3,
                                pointHoverRadius: 5,
                                pointBorderWidth: 2,
                                pointBorderColor: series.color,
                                pointBackgroundColor: chartSurface,
                                pointHoverBorderColor: series.color,
                                pointHoverBackgroundColor: chartSurface
                            };
                        })
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: {duration: 520, easing: 'easeOutQuart'},
                        layout: {padding: {top: 8, right: 8, bottom: 0, left: 8}},
                        legend: {display: false},
                        hover: {mode: 'index', intersect: false},
                        tooltips: {
                            mode: 'index',
                            intersect: false,
                            displayColors: false,
                            backgroundColor: chartTooltip,
                            titleFontColor: chartText,
                            bodyFontColor: chartText,
                            callbacks: {
                                label: function (item) {
                                    var series = definitions[item.datasetIndex];
                                    return $translate.instant('workspace.trafficTooltip', {
                                        label: series ? series.label : $translate.instant('workspace.trafficInsights'),
                                        value: Number(item.yLabel || 0).toLocaleString(locale)
                                    });
                                }
                            }
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {display: false, drawBorder: false},
                                ticks: {maxTicksLimit: 7, fontColor: chartMuted, fontSize: 10, padding: 7}
                            }],
                            yAxes: [{
                                display: false,
                                ticks: {beginAtZero: false},
                                gridLines: {display: false, drawBorder: false}
                            }]
                        }
                    }
                });
                overviewTrafficChartInstance.data.datasets[0].label = organicLabel;
            }, 0);
        }
        vm.trackerOverviewMetrics = function () {
            var keywords = (vm.tracker && Array.isArray(vm.tracker.keywords)
                ? vm.tracker.keywords : []).filter(trackerDeviceMatches);
            var positions = [];
            var top10 = 0;
            var improved = 0;
            keywords.forEach(function (keyword) {
                var state = vm.trackerKeywordState(keyword);
                if (state && state.position !== null) {
                    positions.push(Number(state.position));
                    if (Number(state.position) <= 10) top10 += 1;
                }
                if (state && Number(state.difference) > 0) improved += 1;
            });
            var posAverage = positions.length
                ? positions.reduce(function (sum, value) { return sum + value; }, 0) / positions.length
                : null;
            return {
                count: vm.trackerKeywordCount() || 0,
                average: posAverage,
                top10: top10,
                improved: improved
            };
        };
        function trackerVisibilityForPosition(position) {
            var value = Number(position);
            if (!value || value < 1 || value > 100) return 0;
            return 100 / Math.sqrt(value);
        }
        vm.trackerDashboardMetrics = function () {
            var keywords = (vm.tracker && Array.isArray(vm.tracker.keywords) ? vm.tracker.keywords : [])
                .filter(trackerDeviceMatches);
            var metrics = {
                total: keywords.length,
                measured: 0,
                pending: 0,
                top3: 0,
                firstPage: 0,
                ranking: 0,
                closeToFirstPage: 0,
                improved: 0,
                declined: 0,
                unchanged: 0,
                visibility: null,
                visibilityMin: null,
                visibilityMax: null,
                visibilityPath: '',
                visibilityPoints: [],
                visibilityFrom: '',
                visibilityTo: ''
            };
            var visibilityTotal = 0;
            keywords.forEach(function (keyword) {
                var state = {};
                try {
                    state = vm.trackerKeywordState(keyword) || {};
                } catch (error) {
                    state = {};
                }
                if (state.tracking) {
                    metrics.pending += 1;
                    return;
                }
                var position = Number(state.position);
                if (!position) {
                    position = Number(trackerCurrentPosition(keyword));
                }
                var difference = Number(state.difference) || 0;
                if (difference > 0) metrics.improved += 1;
                else if (difference < 0) metrics.declined += 1;
                else metrics.unchanged += 1;
                if (!position || position < 1 || position > 100) return;
                metrics.measured += 1;
                metrics.ranking += 1;
                if (position <= 3) metrics.top3 += 1;
                if (position <= 10) metrics.firstPage += 1;
                if (position >= 11 && position <= 20) metrics.closeToFirstPage += 1;
                visibilityTotal += trackerVisibilityForPosition(position);
            });
            metrics.visibility = metrics.total
                ? visibilityTotal / metrics.total
                : null;
            var averageChart = null;
            try {
                averageChart = vm.trackerAverageChart();
            } catch (error) {
                averageChart = null;
            }
            var points = averageChart && averageChart.ours && averageChart.ours.points || [];
            if (points.length) {
                var values = points.map(function (point) {
                    return trackerVisibilityForPosition(point.position);
                });
                var max = Math.max.apply(null, values);
                var min = Math.min.apply(null, values);
                var span = Math.max(max - min, 1);
                var visibilityPoints = [];
                var pairs = values.map(function (value, index) {
                    var x = points.length === 1 ? 50 : 3 + (index / (points.length - 1)) * 94;
                    var y = 4 + ((max - value) / span) * 32;
                    visibilityPoints.push({
                        x: x,
                        y: y,
                        value: Math.round(value * 10) / 10,
                        date: points[index].date || trackerDisplayDate(points[index].day)
                    });
                    return [x, y];
                });
                metrics.visibilityPath = typeof vm.previewSmoothPath === 'function'
                    ? vm.previewSmoothPath(pairs)
                    : pairs.map(function (pair, index) {
                        return (index ? ' L' : 'M') + pair[0].toFixed(2) + ',' + pair[1].toFixed(2);
                    }).join('');
                metrics.visibilityMin = Math.round(min);
                metrics.visibilityMax = Math.round(max);
                metrics.visibilityPoints = visibilityPoints;
                metrics.visibilityFrom = averageChart.from;
                metrics.visibilityTo = averageChart.to;
            }
            return metrics;
        };
        vm.trackerVisibilityHover = null;
        vm.hoverTrackerVisibilityAt = function (event) {
            var point = nearestTrackerPoint(
                event,
                vm.trackerDashboardMetrics().visibilityPoints
            );
            if (!point) {
                vm.trackerVisibilityHover = null;
                return;
            }
            var bounds = event.currentTarget.getBoundingClientRect();
            var plotHeight = Math.max(bounds.height - 14, 1);
            var left = (point.x / 100) * bounds.width;
            var top = (point.y / 40) * plotHeight;
            var xTransform = point.x < 14
                ? 'translateX(0)'
                : (point.x > 86 ? 'translateX(-100%)' : 'translateX(-50%)');
            var yTransform = top < 24 ? 'translateY(8px)' : 'translateY(calc(-100% - 8px))';
            vm.trackerVisibilityHover = {
                left: left,
                top: top,
                transform: xTransform + ' ' + yTransform,
                value: point.value,
                date: point.date
            };
        };
        vm.clearTrackerVisibilityHover = function () {
            vm.trackerVisibilityHover = null;
        };
        vm.filterTrackerCloseToFirstPage = function () {
            vm.trackerAdvancedDraft = {
                volumeMin: vm.trackerAdvancedApplied.volumeMin,
                volumeMax: vm.trackerAdvancedApplied.volumeMax,
                positionMin: 11,
                positionMax: 20,
                include: vm.trackerAdvancedApplied.include,
                exclude: vm.trackerAdvancedApplied.exclude
            };
            return vm.applyTrackerAdvanced().then(function () {
                var table = $window.document.querySelector('.st-project-workspace__table-toolbar');
                if (table && table.scrollIntoView) table.scrollIntoView({behavior: 'smooth', block: 'start'});
            });
        };
        vm.overviewCompactNumber = function (value) {
            var amount = Number(value) || 0;
            if (Math.abs(amount) >= 1000000) return (amount / 1000000).toFixed(1).replace('.', ',') + 'M';
            if (Math.abs(amount) >= 1000) return (amount / 1000).toFixed(1).replace('.', ',') + 'K';
            return $filter('number')(amount, 0);
        };
        function overviewSparklinePoints(values, maxPoints) {
            var cleanValues = (values || []).map(function (value) {
                return Number(value);
            }).filter(function (value) {
                return isFinite(value);
            });
            if (cleanValues.length > (maxPoints || 16)) {
                var limit = maxPoints || 16;
                cleanValues = Array.apply(null, {length: limit}).map(function (_, index) {
                    return cleanValues[Math.round(index * (cleanValues.length - 1) / (limit - 1))];
                });
            }
            if (!cleanValues.length) return '';

            var min = Math.min.apply(null, cleanValues);
            var max = Math.max.apply(null, cleanValues);
            var span = Math.max(max - min, 1);
            return cleanValues.map(function (value, index) {
                var x = cleanValues.length === 1 ? 50 : 2 + (index / (cleanValues.length - 1)) * 96;
                var y = 3 + ((max - value) / span) * 25;
                return x.toFixed(2) + ',' + y.toFixed(2);
            }).join(' ');
        }
        vm.overviewTrackerSparkline = function () {
            var metrics = vm.trackerDashboardMetrics();
            var values = (metrics.visibilityPoints || []).map(function (point) {
                return point.value;
            });
            return {points: overviewSparklinePoints(values, 20)};
        };
        vm.overviewGscSparklines = function () {
            var series = vm.overviewGsc && vm.overviewGsc.summary &&
                Array.isArray(vm.overviewGsc.summary.series)
                ? vm.overviewGsc.summary.series
                : [];
            if (!series.length) return null;
            return {
                clicks: {
                    points: overviewSparklinePoints(series.map(function (item) {
                        return Math.max(0, Number(item && item.clicks) || 0);
                    }))
                },
                impressions: {
                    points: overviewSparklinePoints(series.map(function (item) {
                        return Math.max(0, Number(item && item.impressions) || 0);
                    }))
                },
                ctr: {
                    points: overviewSparklinePoints(series.map(function (item) {
                        var clicks = Math.max(0, Number(item && item.clicks) || 0);
                        var impressions = Math.max(0, Number(item && item.impressions) || 0);
                        return impressions ? (clicks / impressions) * 100 : 0;
                    }))
                }
            };
        };
        vm.overviewDomain = function () {
            if (vm.overviewTraffic && vm.overviewTraffic.data && vm.overviewTraffic.data.domain) {
                return vm.overviewTraffic.data.domain;
            }
            var url = String(vm.url || '');
            if (url) {
                return url
                    .replace(/^https?:\/\//i, '')
                    .replace(/^www\./i, '')
                    .split('/')[0];
            }
            return vm.project && vm.project.name || '';
        };
        function reloadTracker(filters, options) {
            var reloadId = ++trackerReloadId;
            var silent = !!(options && options.silent);
            if (!silent) vm.trackerLoading = true;
            return KeywordTrackerService.getOneProject(vm.tracker.id, filters || trackerApiFilters()).then(function (response) {
                if (destroyed || reloadId !== trackerReloadId) return;
                vm.tracker = response && response.data && response.data.trackerProject || vm.tracker;
                resetTrackerKeywordCaches();
                vm.trackerOpenKeyword = null;
                vm.trackerOpenState = null;
                vm.trackerOpenChart = null;
                vm.trackerOpenGsc = null;
                vm.trackerOpenKeywordItem = null;
                vm.trackerOpenPages = [];
                vm.trackerHoverPoint = null;
                ensureTrackerRange();
                ensureTrackerDeviceSelection();
                trackerCompetitorsCache = null;
                trackerLocationOptionsCache = null;
                trackerAddCountriesCache = null;
                trackerCountryPickerCache = null;
                trackerAverageCache = null;
                trackerDistributionCache = null;
                vm.trackerAverageHover = null;
                ensureTrackerFormLocation();
                loadTrackerGscConnection();
            }).finally(function () {
                if (!silent && !destroyed && reloadId === trackerReloadId) vm.trackerLoading = false;
            });
        }
        function loadProject() {
            ProjectsService.findAllPreview().then(function (projects) {
                if (destroyed) return;
                vm.project = Array.isArray(projects) && projects.find(function (item) {
                    return String(item.id) === String($stateParams.projectId);
                });
                vm.isLoading = false;
                if (!vm.project) { vm.notFound = true; return; }
                loadTrackerCountryReference();
                vm.tracker = vm.project.trackerProject || null;
                if (vm.tracker) {
                    vm.tracker.keywords = Array.isArray(vm.tracker.keywords) ? vm.tracker.keywords : [];
                    vm.tracker.locations = Array.isArray(vm.tracker.locations) ? vm.tracker.locations : [];
                    vm.tracker.competitors = Array.isArray(vm.tracker.competitors) ? vm.tracker.competitors : [];
                    ensureTrackerDeviceSelection();
                }
                resetTrackerKeywordCaches();
                ensureTrackerRange();
                vm.spiderProjectId = vm.project.crawlerProject && vm.project.crawlerProject.id;
                vm.url = vm.project.crawlerProject && vm.project.crawlerProject.url || vm.tracker && vm.tracker.linkUrl || '';
                vm.faviconUrl = vm.url ? FavIconService.get(vm.url) : null;
                if (vm.spiderProjectId) loadSessions();
                if (vm.section === 'search-console') loadSearchConsole();
                if (vm.section === 'overview') { loadCrawlSession(); loadReport(); loadOverviewInsights(); }
                if (vm.section === 'links') loadCrawlSession();
                if (vm.section === 'tracker' && vm.tracker) reloadTracker();
                if (vm.section === 'tracker' && vm.tracker) loadTrackerKeywordUsage();
                if (vm.section === 'log') loadCrawlSession();
                if (vm.section === 'report') loadReport();
                if (vm.section === 'issues') { loadReport(); loadCrawlSession(); }
                if (vm.section === 'crux') { loadCruxPages(); loadCrux(); loadCruxTable(); loadCruxHistory(); }
                if (vm.section === 'sitemaps') loadSitemaps();
            }).catch(function () { if (!destroyed) { vm.isLoading = false; vm.loadError = true; } });
        }
        /* preferredSessionId is used after a restart, so the brand new session
           stays selected even if the project record still points at the old one. */
        function loadSessions(preferredSessionId) {
            vm.sessionsLoaded = true;
            vm.sessionsLoading = true;
            vm.sessionsError = false;
            return SeospiderService.getSessions(vm.spiderProjectId).then(function (response) {
                if (destroyed) return;
                vm.sessions = response && response.data && response.data.sessions || [];
                vm.sessions.sort(function (a, b) { return Number(b.id) - Number(a.id); });
                vm.sessions.forEach(function (session) {
                    session.label = $filter('date')(session.createdAt, 'dd MMM yyyy, HH:mm') + ' · ' + localizedSessionStatus(session.status);
                    session.dateLabel = $filter('date')(session.createdAt, 'dd MMM yyyy, HH:mm');
                    session.statusLabel = localizedSessionStatus(session.status);
                });
                vm.sessionMenuOpen = false;
                vm.form.sessionId = preferredSessionId || vm.project.crawlerSession && vm.project.crawlerSession.id ||
                    vm.sessions.length && vm.sessions[0].id || null;
                if (vm.form.sessionId) {
                    loadSpiderRows();
                    loadReport();
                }
                syncCrawlPolling();
            }).catch(function () { if (!destroyed) vm.sessionsError = true; })
                .finally(function () { if (!destroyed) vm.sessionsLoading = false; });
        }
        /* Crawl session picker (navbar): custom dropdown so each status shows as a badge. */
        vm.sessionMenuOpen = false;
        vm.mobileActionsOpen = false;
        vm.toggleSessionMenu = function () { vm.sessionMenuOpen = !vm.sessionMenuOpen; };
        vm.toggleMobileActions = function (event) {
            if (event && event.stopPropagation) event.stopPropagation();
            vm.sessionMenuOpen = false;
            vm.mobileActionsOpen = !vm.mobileActionsOpen;
        };
        vm.closeMobileActions = function () {
            vm.mobileActionsOpen = false;
        };
        vm.currentSession = function () {
            if (!vm.sessions || !vm.sessions.length) return null;
            var found = vm.sessions.filter(function (session) { return session.id === vm.form.sessionId; })[0];
            return found || vm.sessions[0];
        };
        vm.sessionBadgeClass = function (session) {
            var status = String(session && session.status || '').toLowerCase();
            if (status.indexOf('finish') >= 0 || status === 'done' || status === 'completed') return 'is-done';
            if (status.indexOf('progress') >= 0 || status.indexOf('running') >= 0 || status === 'active') return 'is-progress';
            if (status.indexOf('fail') >= 0 || status.indexOf('error') >= 0) return 'is-failed';
            return 'is-idle';
        };
        function localizedSessionStatus(status) {
            var value = String(status || '').toLowerCase();
            if (value.indexOf('finish') >= 0 || value === 'done' || value === 'completed') {
                return $translate.instant('workspace.sessionStatusFinished');
            }
            if (value.indexOf('progress') >= 0 || value.indexOf('running') >= 0 || value === 'active') {
                return $translate.instant('workspace.sessionStatusRunning');
            }
            if (value.indexOf('fail') >= 0 || value.indexOf('error') >= 0) {
                return $translate.instant('workspace.sessionStatusFailed');
            }
            return $translate.instant('workspace.sessionStatusPending');
        }
        vm.selectSessionItem = function (session) {
            if (!session) return;
            vm.form.sessionId = session.id;
            vm.sessionMenuOpen = false;
            vm.mobileActionsOpen = false;
            vm.selectSession();
        };
        /* Legacy "optimized / not optimized" checks filter client-side. */
        function snippetOptimized(row) {
            var title = row && row.title || '';
            var description = row && row.metaDescription || '';
            /* Same bounds as the crawler stat behind the "Google Snippet" exam. */
            return !!title && !!description && title.length >= 40 && title.length <= 69 && description.length > 50 && description.length <= 160;
        }
        function ogOptimized(row) {
            return !!(row && row.metaOgTitle && row.metaOgDescription && row.metaOgImage && row.metaOgType && row.metaOgSiteName && row.metaOgUrl);
        }
        function twOptimized(row) {
            return !!(row && row.metaOgTitle && row.metaTwitterTitle && row.metaTwitterDescription && row.metaTwitterImage && row.metaTwitterCard && row.metaTwitterSite);
        }
        var clientFilters = {
            'snippet-optimized': snippetOptimized,
            'snippet-not-optimized': function (row) { return !snippetOptimized(row); },
            'og-optimized': ogOptimized,
            'og-not-optimized': function (row) { return !ogOptimized(row); },
            'tw-optimized': twOptimized,
            'tw-not-optimized': function (row) { return !twOptimized(row); }
        };
        function loadSpiderRows() {
            if (!vm.form.sessionId) return;
            var id = ++requestId;
            vm.spiderData = {loading: true, rows: [], total: 0, error: false};
            var params = {jobId: vm.form.sessionId, q: vm.form.spiderSearch,
                offset: vm.spiderOffset, limit: vm.spiderLimit, ignoreLoadingBar: true};
            var config = vm.spiderActiveConfig();
            if (config.params) {
                Object.keys(config.params).forEach(function (key) { params[key] = config.params[key]; });
            }
            var fallbackCategory = vm.section === 'explorer' ? ((vm.explorerItem() || {}).viewId || 'pages')
                : (vm.section === 'links' ? ((vm.linkItem() || {}).viewId || 'links') : vm.spiderView);
            /* Client-side filters (legacy optimized/not optimized checks) load a
               batch and then filter + paginate in the browser. */
            var clientFilter = clientFilters[config.clientFilter];
            if (clientFilter) {
                params.limit = 500;
                params.offset = 0;
            }
            var request = spiderRequestFor(config, params, fallbackCategory);
            request
                .then(function (response) {
                    if (destroyed || id !== requestId) return;
                    var rows = Array.isArray(response.data) ? response.data : [];
                    if (!clientFilter) {
                        vm.spiderData.rows = rows;
                        vm.spiderData.total = Number(response.totalRows) || 0;
                        return;
                    }
                    var filtered = rows.filter(clientFilter);
                    vm.spiderData.total = filtered.length;
                    vm.spiderData.rows = filtered.slice(vm.spiderOffset, vm.spiderOffset + vm.spiderLimit);
                }).catch(function () { if (!destroyed && id === requestId) vm.spiderData.error = true; })
                .finally(function () { if (!destroyed && id === requestId) vm.spiderData.loading = false; });
        }
        function loadSearchConsole() {
            ensureGscRange();
            vm.gsc = {
                checked: true, checking: true, loading: false, rows: [], error: false,
                property: null, properties: [], propertyChanging: false,
                countries: [], devices: [], rowsLoading: false, rowsError: false
            };
            vm.gscTotalRows = 0;
            vm.gscTotalRowsKnown = false;
            vm.gscHasMoreRows = false;
            vm.gscTruncated = false;
            SearchConsoleService.getProjectConnection(vm.project.id).then(function (connection) {
                if (destroyed) return;
                vm.gsc.property = connection && connection.propertyUrl || null;
                vm.gsc.checking = false;
                if (!vm.gsc.property) return;
                SearchConsoleService.getProjectProperties(vm.project.id).then(function (properties) {
                    if (destroyed) return;
                    vm.gsc.properties = properties && properties.items || [];
                    if (properties && properties.selected) {
                        vm.gsc.property = properties.selected;
                    }
                }).catch(function () {
                    if (!destroyed) vm.gsc.properties = [];
                });
                if (vm.gscView !== 'settings') {
                    loadGscFilterOptions();
                    loadGscSummary(true);
                }
            }).catch(function () { if (!destroyed) { vm.gsc.checking = false; vm.gsc.error = true; } });
        }
        function loadGscFilterOptions() {
            SearchConsoleService.getProjectFilters(vm.project.id, {searchType: vm.gscSearchType}).then(function (options) {
                if (destroyed) return;
                vm.gsc.countries = (options && options.countries || []).map(function (country) {
                    var code = String(country.code || country.alpha2 || '').toUpperCase();
                    var displayName = country.label;
                    if (code.length === 2 && $window.Intl && $window.Intl.DisplayNames) {
                        try {
                            displayName = new $window.Intl.DisplayNames([$translate.use() || 'en-US'], {type: 'region'}).of(code)
                                || country.label;
                        } catch (error) {}
                    }
                    return Object.assign({}, country, {displayName: displayName});
                });
                var deviceKeys = {
                    DESKTOP: 'workspace.deviceDesktop',
                    MOBILE: 'workspace.deviceMobile',
                    TABLET: 'workspace.deviceTablet'
                };
                vm.gsc.devices = (options && options.devices || []).map(function (device) {
                    var code = String(device.code || '').toUpperCase();
                    return Object.assign({}, device, {tkey: deviceKeys[code]});
                });
            }).catch(function () {
                if (!destroyed) {
                    vm.gsc.countries = vm.gsc.countries || [];
                    vm.gsc.devices = vm.gsc.devices || [];
                }
            });
        }
        var gscSummaryRequestId = 0;
        var gscRowsRequestId = 0;
        var lastGscSummarySignature = null;
        function loadGscSummary(force) {
            if (!vm.gsc.property) return;
            var signature = [
                vm.gsc.property,
                vm.gscFilters.startDate,
                vm.gscFilters.endDate,
                vm.gscFilters.country,
                vm.gscFilters.device,
                vm.gscFilters.query,
                vm.gscFilters.page,
                vm.gscFilters.searchAppearance,
                vm.gscFilters.searchType
            ].join('|');
            if (!force && signature === lastGscSummarySignature) return;
            lastGscSummarySignature = signature;
            var id = ++gscSummaryRequestId;
            requestId += 1;
            vm.gsc.loading = true;
            vm.gsc.error = false;
            vm.gsc.rows = [];
            vm.gscTotalRowsKnown = false;
            vm.gscHasMoreRows = false;
            loadGscRows();
            SearchConsoleService.getProjectSummary(vm.project.id, vm.gscFilters)
                .then(function (summary) {
                    if (destroyed || id !== gscSummaryRequestId) return;
                    vm.gsc.summary = summary;
                    buildGscChart(summary);
                })
                .catch(function () {
                    if (!destroyed && id === gscSummaryRequestId) {
                        vm.gsc.error = true;
                        vm.gscChart = null;
                    }
                })
                .finally(function () {
                    if (!destroyed && id === gscSummaryRequestId) vm.gsc.loading = false;
                });
        }
        function gscChartLabel(date) {
            var parts = String(date || '').slice(0, 10).split('-');
            return parts.length === 3 ? Number(parts[1]) + '/' + Number(parts[2]) + '/' + parts[0].slice(2) : date;
        }
        function gscChartRows(series, granularity) {
            var rows = Array.isArray(series) ? series : [];
            if (granularity === 'daily' || !rows.length) {
                return rows.map(function (day) {
                    return {
                        label: gscChartLabel(day.date),
                        clicks: day.clicks,
                        impressions: day.impressions,
                        position: day.position
                    };
                });
            }
            var first = new Date(rows[0].date + 'T00:00:00Z').getTime();
            var buckets = {};
            var keys = [];
            rows.forEach(function (day) {
                var key;
                var label;
                if (granularity === 'monthly') {
                    key = String(day.date).slice(0, 7);
                    label = $filter('date')(new Date(key + '-01T00:00:00Z'), 'MM/yy');
                } else {
                    var index = Math.floor((new Date(day.date + 'T00:00:00Z').getTime() - first) / (7 * 24 * 60 * 60 * 1000));
                    key = 'w' + index;
                    var start = new Date(first + index * 7 * 24 * 60 * 60 * 1000);
                    label = start.getUTCMonth() + 1 + '/' + start.getUTCDate() + '/' + String(start.getUTCFullYear()).slice(2);
                }
                if (!buckets[key]) {
                    buckets[key] = {label: label, clicks: 0, impressions: 0, weightedPosition: 0, hasPosition: false};
                    keys.push(key);
                }
                var bucket = buckets[key];
                bucket.clicks += Number(day.clicks) || 0;
                bucket.impressions += Number(day.impressions) || 0;
                if (day.position !== null && day.position !== undefined && Number(day.impressions) > 0) {
                    bucket.weightedPosition += Number(day.position) * Number(day.impressions);
                    bucket.hasPosition = true;
                }
            });
            return keys.map(function (key) {
                var bucket = buckets[key];
                return {
                    label: bucket.label,
                    clicks: bucket.clicks,
                    impressions: bucket.impressions,
                    position: bucket.hasPosition && bucket.impressions
                        ? bucket.weightedPosition / bucket.impressions
                        : null
                };
            });
        }
        function buildGscChart(summary) {
            var rows = gscChartRows(summary && summary.series, vm.gscChartGranularity);
            if (!rows.length) {
                vm.gscChart = null;
                vm.gscNoMetrics = false;
                return;
            }
            var values = {
                clicks: rows.map(function (row) { return row.clicks; }),
                impressions: rows.map(function (row) { return row.impressions; }),
                ctr: rows.map(function (row) {
                    return row.impressions ? (Number(row.clicks) || 0) / row.impressions * 100 : null;
                }),
                position: rows.map(function (row) { return row.position; })
            };
            var names = {
                clicks: $translate.instant('workspace.gscTotalClicks'),
                impressions: $translate.instant('workspace.gscTotalImpressions'),
                ctr: $translate.instant('workspace.gscAverageCtr'),
                position: $translate.instant('workspace.gscAveragePosition')
            };
            var metrics = ['clicks', 'impressions', 'ctr', 'position'].filter(function (metric) {
                return vm.gscMetricVisibility[metric];
            });
            vm.gscNoMetrics = !metrics.length;
            if (!metrics.length) {
                vm.gscChart = null;
                return;
            }
            vm.gscChart = {
                labels: rows.map(function (row) { return row.label; }),
                data: metrics.map(function (metric) { return values[metric]; }),
                series: metrics.map(function (metric) { return names[metric]; }),
                datasets: metrics.map(function (metric) {
                    return {
                        metric: metric,
                        borderColor: gscMetricColors[metric],
                        backgroundColor: 'transparent',
                        pointRadius: 0,
                        pointHoverRadius: 4,
                        borderWidth: 1.5,
                        fill: false,
                        lineTension: .15,
                        yAxisID: 'axis-' + metric
                    };
                }),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {display: false},
                    animation: {duration: 220},
                    hover: {mode: 'index', intersect: false},
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            label: function (item, data) {
                                var dataset = data.datasets[item.datasetIndex] || {};
                                var value = item.yLabel;
                                if (dataset.metric === 'ctr') return dataset.label + ': ' + Number(value).toFixed(1) + '%';
                                if (dataset.metric === 'position') return dataset.label + ': ' + Number(value).toFixed(1);
                                return dataset.label + ': ' + Number(value).toLocaleString($translate.use() || 'en-US');
                            }
                        }
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {display: false, drawBorder: false},
                            ticks: {
                                maxTicksLimit: 10,
                                autoSkip: true,
                                fontColor: suiteThemeToken('--sto-color-text-muted', '#5f6368'),
                                fontSize: 11
                            }
                        }],
                        yAxes: ['clicks', 'impressions', 'ctr', 'position'].map(function (metric, index) {
                            return {
                                id: 'axis-' + metric,
                                type: 'linear',
                                display: index === 0,
                                position: index % 2 ? 'right' : 'left',
                                gridLines: {
                                    display: index === 0,
                                    drawBorder: false,
                                    color: suiteThemeToken('--sto-color-border', '#eceff1')
                                },
                                ticks: {display: false}
                            };
                        })
                    }
                }
            };
        }
        /* The SEO report is the crawl audit: the same checks the old SEO Spider
           report exposed, scoped to this project's session. */
        function loadCrawlSession() {
            if (!vm.project) return;
            var sessionId = vm.form.sessionId || (vm.project.crawlerSession && vm.project.crawlerSession.id) || null;
            if (!sessionId) { vm.sessionMissing = true; return; }
            if (vm.sessionLoading || vm.sessionLoadedFor === sessionId) return;
            var id = ++sessionRequestId;
            vm.sessionLoading = true;
            SeospiderService.getSessions(vm.spiderProjectId, sessionId).then(function (response) {
                if (destroyed || id !== sessionRequestId) return;
                vm.crawlSession = response && response.data || null;
                vm.sessionLoadedFor = sessionId;
                if (vm.section === 'report' && vm.reportSection === 'overview') loadPreviews();
            }).catch(function () { if (!destroyed && id === sessionRequestId) vm.crawlSession = null; })
                .finally(function () {
                    if (!destroyed && id === sessionRequestId) {
                        vm.sessionLoading = false;
                        syncCrawlPolling();
                    }
                });
        }
        /* ---- Crawl actions: restart the crawl or stop the one in progress. The
           scan log refreshes itself every 2 seconds while a crawl is running. ---- */
        var CRAWL_POLL_MS = 2000;
        var crawlPoll = null;
        var crawlWasInProgress = false;
        vm.crawlAction = {restarting: false, stopping: false, error: false};
        vm.crawlAutoRefresh = false;
        function activeSessionId() {
            return vm.form.sessionId ||
                (vm.project && vm.project.crawlerSession && vm.project.crawlerSession.id) || null;
        }
        function sessionStatus() {
            var detail = vm.crawlSession;
            var listed = vm.currentSession ? vm.currentSession() : null;
            /* Older sessions stored nested data under `session`. */
            var status = (detail && (detail.status || (detail.session && detail.session.status))) ||
                (listed && listed.status) || '';
            return String(status).toLowerCase();
        }
        function isCrawlInProgress() {
            var status = sessionStatus();
            return status === 'running' || status === 'deleting' || status === 'stopping';
        }
        vm.crawlInProgress = function () { return !!vm.spiderProjectId && isCrawlInProgress(); };
        function hasCrawlHistory() {
            return !!(vm.sessions && vm.sessions.length);
        }
        /* The project is created with its crawler project before the first
           scan, so an empty session list is the explicit first-scan state. */
        vm.noCrawlHistory = function () {
            return !!vm.spiderProjectId &&
                vm.sessionsLoaded &&
                !vm.sessionsLoading &&
                !vm.sessionsError &&
                !hasCrawlHistory() &&
                !isCrawlInProgress();
        };
        vm.crawlActionLabel = function () {
            if (vm.crawlAction.restarting) {
                return vm.noCrawlHistory() ? 'workspace.scanNowStarting' : 'workspace.scanLogRestarting';
            }
            return vm.noCrawlHistory() ? 'workspace.scanNow' : 'workspace.scanLogRestart';
        };
        function syncCrawlPolling() {
            var inProgress = !destroyed && !!vm.spiderProjectId && isCrawlInProgress();
            if (inProgress && !crawlPoll) crawlPoll = $interval(refreshCrawlSession, CRAWL_POLL_MS);
            if (!inProgress && crawlPoll) { $interval.cancel(crawlPoll); crawlPoll = null; }
            vm.crawlAutoRefresh = !!crawlPoll;
            /* The crawl ended (or was stopped): the picker badges need the new status. */
            if (crawlWasInProgress && !inProgress) {
                /* Crawl over: refresh the picker and fetch the finished report, so the
                   placeholders give way to the real score, radar and issues. */
                vm.reportLoadedFor = null;
                vm.sessionLoadedFor = null;
                loadSessions(activeSessionId());
                if (vm.section === 'overview' || vm.section === 'issues' || vm.section === 'report') loadReport();
                if (vm.section === 'overview' && vm.overviewTraffic.data) {
                    buildOverviewTrafficChart(vm.overviewTraffic.data);
                }
            }
            crawlWasInProgress = inProgress;
        }
        function refreshCrawlSession() {
            var sessionId = activeSessionId();
            if (destroyed || !vm.spiderProjectId || !sessionId || !isCrawlInProgress()) {
                syncCrawlPolling();
                return;
            }
            SeospiderService.getSessions(vm.spiderProjectId, sessionId).then(function (response) {
                if (destroyed || sessionId !== activeSessionId()) return;
                if (response && response.data) vm.crawlSession = response.data;
                vm.sessionLoadedFor = sessionId;
            }).catch(function () {
                /* A failed refresh keeps the last snapshot on screen. */
            }).finally(function () { if (!destroyed) syncCrawlPolling(); });
        }
        vm.restartCrawl = function () {
            if (!vm.spiderProjectId || vm.crawlAction.restarting || vm.crawlAction.stopping) return;
            if (hasCrawlHistory() &&
                !$window.confirm($translate.instant('workspace.scanLogRestartConfirm'))) return;
            var startedFromOverview = vm.isSectionActive('overview')
                || ($state.current && $state.current.name === 'app.project.detail.overview');
            vm.crawlAction.restarting = true;
            vm.crawlAction.error = false;
            /* The API starts a new session for this crawler project. */
            SeospiderService.update({id: vm.spiderProjectId}).then(function (response) {
                if (destroyed) return;
                var sessionId = response && response.data && response.data.crawlerSessionId;
                if (!sessionId) { vm.crawlAction.error = true; return; }
                /* New session: drop the cached detail and report, then follow it. */
                vm.crawlSession = null;
                vm.sessionLoadedFor = null;
                vm.reportLoadedFor = null;
                vm.sessionMissing = false;
                if (vm.project) vm.project.crawlerSession = {id: sessionId};
                vm.form.sessionId = sessionId;
                loadSessions(sessionId);
                loadCrawlSession();
                /* From Overview, stay here so the right-hand card can show live crawl data. */
                if (!startedFromOverview && vm.section !== 'log') {
                    $state.go('app.project.detail.log', {projectId: vm.project.id});
                }
            }).catch(function () { if (!destroyed) vm.crawlAction.error = true; })
                .finally(function () { if (!destroyed) vm.crawlAction.restarting = false; });
        };
        vm.startCrawlNow = function () { vm.restartCrawl(); };
        vm.stopCrawl = function () {
            var sessionId = activeSessionId();
            if (!vm.spiderProjectId || !sessionId || vm.crawlAction.stopping || vm.crawlAction.restarting) return;
            vm.crawlAction.stopping = true;
            vm.crawlAction.error = false;
            SeospiderService.stopCrawl(vm.spiderProjectId, sessionId).then(function () {
                if (destroyed) return;
                /* The API flags the session as `deleting`: show it at once, the poll
                   then keeps the log updated until the crawler actually stops. */
                if (vm.crawlSession) vm.crawlSession.status = 'deleting';
                loadSessions(sessionId);
                syncCrawlPolling();
            }).catch(function () { if (!destroyed) vm.crawlAction.error = true; })
                .finally(function () { if (!destroyed) vm.crawlAction.stopping = false; });
        };
        function loadReport() {
            if (!vm.project) return;
            var sessionId = vm.form.sessionId || (vm.project.crawlerSession && vm.project.crawlerSession.id) || null;
            if (!sessionId) { vm.reportMissing = true; vm.reportConfiguration = null; return; }
            if (vm.reportLoading || vm.reportLoadedFor === sessionId) return;
            var id = ++reportRequestId;
            vm.reportLoading = true;
            vm.reportError = false;
            vm.reportMissing = false;
            vm.issueComparisonLoading = false;
            loadCrawlSession();
            /* The report API knows short locales only: 'it-IT' would fall back to English. */
            var reportLang = String($translate.use() || 'en').split('-')[0];
            SeospiderService.report({jobId: sessionId, lang: reportLang}).then(function (response) {
                if (destroyed || id !== reportRequestId) return;
                vm.report = normalizeReport(response);
                vm.reportScores = buildReportScores(vm.report);
                vm.reportConfiguration = buildReportPdfConfiguration(vm.report, sessionId);
                syncReportSection();
                buildExplorerCounts();
                buildIssueRows();
                loadPreviousReport(sessionId);
                vm.reportLoadedFor = sessionId;
            }).catch(function () { if (!destroyed && id === reportRequestId) vm.reportError = true; })
                .finally(function () { if (!destroyed && id === reportRequestId) vm.reportLoading = false; });
        }

        /* ---- Confronto con il crawl precedente: numeri per problematica. ---- */
        var previousReportCache = {};

        function reportLang() {
            return String($translate.use() || 'en').split('-')[0];
        }

        /* Reuse the legacy SEO Spider PDF pipeline with the current crawl report. */
        function buildReportPdfConfiguration(report, sessionId) {
            if (!report || !sessionId) return null;
            var user = $localStorage.currentUser || {};
            return {
                data: report,
                config: {
                    version: '1.0',
                    params: {
                        url: vm.url || (vm.project && vm.project.url) || '',
                        locale: reportLang(),
                        projectId: sessionId,
                        email: {to: user.email},
                        categories: ReportPdfService.getCategories({
                            type: 'seo_spider',
                            score: true,
                            preview: true,
                            suggests: true,
                            problems: true
                        })
                    },
                    default: true
                },
                type: 'seo_spider'
            };
        }

        function loadPreviousReport(currentSessionId) {
            vm.issueComparisonLoading = true;
            if (vm.sessions && vm.sessions.length) {
                compareWithPreviousReport(currentSessionId, vm.sessions);
                return;
            }
            SeospiderService.getSessions(vm.spiderProjectId).then(function (response) {
                var sessions = response && response.data && response.data.sessions || [];
                sessions.sort(function (a, b) { return Number(b.id) - Number(a.id); });
                compareWithPreviousReport(currentSessionId, sessions);
            }).catch(function () {});
        }

        function compareWithPreviousReport(currentSessionId, sessions) {
            var index = -1;
            for (var i = 0; i < sessions.length; i++) {
                if (String(sessions[i].id) === String(currentSessionId)) { index = i; break; }
            }
            var previous = index > -1 ? sessions[index + 1] : null;
            if (!previous) { applyIssueComparison(null); return; }
            var previousId = previous.id;
            if (previousReportCache[previousId]) {
                applyIssueComparison(previousReportCache[previousId]);
                return;
            }
            SeospiderService.report({jobId: previousId, lang: reportLang()}).then(function (response) {
                var report = normalizeReport(response);
                var counts = {};
                comparisonGroups.forEach(function (group) {
                    var section = report && report[group];
                    if (!section || !section.exams) return;
                    Object.keys(section.exams).forEach(function (key) {
                        var exam = section.exams[key];
                        if (!exam) return;
                        var args = ((exam.preview || [])[0] || {}).args;
                        var arg = args && args[key === 'textCodeRatio' ? 1 : 0];
                        counts[group + ':' + key] = arg && arg.value !== null && arg.value !== '' && !isNaN(arg.value)
                            ? Number(arg.value)
                            : null;
                    });
                });
                previousReportCache[previousId] = counts;
                if (vm.reportLoadedFor === currentSessionId) applyIssueComparison(counts);
            }).catch(function () { vm.issueComparisonLoading = false; });
        }

        /* Variazione = pagine attuali − pagine del crawl precedente. */
        function applyIssueComparison(previousCounts) {
            vm.issueComparisonLoading = false;
            vm.issueHasPrevious = !!previousCounts;
            vm.issueRows.forEach(function (row) {
                if (!previousCounts) {
                    row.previousIssues = null;
                    row.change = null;
                    row.isNew = false;
                    return;
                }
                var previous = previousCounts[row.section + ':' + row.key];
                row.previousIssues = typeof previous === 'number' ? previous : null;
                row.change = typeof previous === 'number' && row.issues !== null ? row.issues - previous : null;
                row.isNew = row.issues > 0 && (typeof previous !== 'number' || previous === 0);
            });
            rebuildIssueView();
        }
        /* Exams of the active report section, worst score first so the audit
           reads as: what to fix, what to review, what already passes. */
        function syncReportSection() {
            var section = vm.report && vm.report[vm.reportSection];
            var exams = section && section.exams ? Object.keys(section.exams).map(function (key) { return section.exams[key]; }) : [];
            exams = exams.filter(function (exam) { return !!exam; });
            exams.sort(function (a, b) {
                var left = typeof a.score === 'number' ? a.score : 101;
                var right = typeof b.score === 'number' ? b.score : 101;
                return left - right;
            });
            vm.reportExams = exams;
        }
        /* ---- Issues: every report exam in one compact, worst-first list. ---- */
        vm.issueRows = [];
        vm.issueVerdict = function (score) {
            if (typeof score !== 'number') return '—';
            if (score >= 75) return $translate.instant('workspace.reportPassed');
            if (score >= 50) return $translate.instant('workspace.reportToReview');
            return $translate.instant('workspace.reportToFix');
        };
        vm.toggleIssue = function (issue) {
            /* Resolved exams have nothing to expand. */
            if (vm.issueResolved(issue)) return;
            issue.expanded = !issue.expanded;
            if (issue.expanded) loadIssueSample(issue);
        };
        vm.issueResolved = function (issue) {
            return !!issue && issue.score === 100 && !issue.issues;
        };
        /* First rows of the exam, taken from the same endpoint Page Explorer
           uses for that filter: ten are shown, the rest stays one click away. */
        function loadIssueSample(issue) {
            if (!issue.explorerItem || issue.sampleLoaded || issue.sampleLoading || !vm.form.sessionId) return;
            var item = vm.explorerItems.filter(function (entry) { return entry.id === issue.explorerItem; })[0];
            if (!item) return;
            issue.sampleLoading = true;
            var config = mergedConfig(item.viewId, item.variantId);
            /* Client-side checks (optimized/not optimized) need a batch to
               filter, exactly like the Page Explorer does for the same filter. */
            var clientFilter = clientFilters[config.clientFilter];
            var params = {jobId: vm.form.sessionId, offset: 0, limit: clientFilter ? 500 : 10, ignoreLoadingBar: true};
            if (config.params) {
                Object.keys(config.params).forEach(function (key) { params[key] = config.params[key]; });
            }
            var request = spiderRequestFor(config, params, item.viewId);
            if (!request) { issue.sampleLoading = false; return; }
            request.then(function (response) {
                var rows = response && Array.isArray(response.data) ? response.data : [];
                if (clientFilter) {
                    var filtered = rows.filter(clientFilter);
                    issue.sampleTotal = filtered.length;
                    issue.sampleRows = filtered.slice(0, 10);
                } else {
                    issue.sampleRows = rows;
                    issue.sampleTotal = Number(response && response.totalRows) || rows.length;
                }
                issue.sampleLoaded = true;
            }).catch(function () { issue.sampleRows = []; })
                .finally(function () { issue.sampleLoading = false; });
        }
        /* Renders an API text: the format string is a translation template with
           $1..$n placeholders filled by its args (numbers stay numbers). */
        function issueTextualHtml(textual) {
            if (!textual) return '';
            var format = textual.formatHtml ? $translate.instant(textual.formatHtml) : '';
            (textual.args || []).forEach(function (arg, index) {
                if (!arg) return;
                if (arg.type === 'button') { format = format.split('$' + (index + 1)).join(''); return; }
                var value = arg.value === undefined || arg.value === null ? '' : arg.value;
                if (typeof value === 'string') value = $translate.instant(value);
                format = format.split('$' + (index + 1)).join(value);
            });
            return $sce.trustAsHtml(format);
        }
        vm.issueTextualHtml = issueTextualHtml;
        /* Titolo localizzato a runtime: se la chiave manca nella lingua corrente
           si usa il titolo originale del report. */
        vm.issueTitleOf = function (issue) {
            if (!issue) return '';
            if (!issue.titleKey) return issue.title || '';
            var translated = $translate.instant(issue.titleKey);
            return translated === issue.titleKey ? (issue.title || '') : translated;
        };
        /* Handed to the issue-row component, which renders one exam anywhere
           in the workspace (Issues section and project overview). */
        vm.issueHooks = {
            resolved: vm.issueResolved,
            toggle: vm.toggleIssue,
            textualHtml: issueTextualHtml,
            cell: vm.spiderCell,
            cellLink: vm.spiderCellLink,
            title: vm.issueTitleOf,
            countLabel: function (issue) {
                var count = issue && issue.issues;
                if (count === null || count === undefined || count === '') return '—';
                return $translate.instant(Number(count) === 1
                    ? 'workspace.issueCountOne'
                    : 'workspace.issueCountMany', {count: count});
            },
            comparisonLoading: function () { return !!vm.issueComparisonLoading; }
        };
        vm.visibleIssueRows = function () {
            return vm.issueRows;
        };
        /* ---- Filtri e stato della tabella problematiche ----
           Le liste sono precalcolate: gli ng-repeat non ricevono mai array nuovi. */
        vm.issueFilter = 'all';
        vm.issueFilters = [
            {id: 'all', key: 'workspace.issuesFilterAll'},
            {id: 'problems', key: 'workspace.issuesFilterProblems'},
            {id: 'new', key: 'workspace.issuesFilterNew'},
            {id: 'resolved', key: 'workspace.issuesFilterResolved'}
        ];
        vm.setIssueFilter = function (id) { vm.issueFilter = id; rebuildIssueView(); };
        vm.issueStatus = null;
        vm.statusMenuOpen = false;
        vm.toggleStatusMenu = function () { vm.statusMenuOpen = !vm.statusMenuOpen; };
        vm.setIssueStatus = function (value) { vm.issueStatus = value; vm.statusMenuOpen = false; rebuildIssueView(); };
        function issueStatusOf(issue) {
            if (!issue) return null;
            if (typeof issue.score === 'number' && issue.score < 50) return 'critical';
            /* Basta un problema trovato per segnare l'esame come warning,
               anche quando il punteggio complessivo è alto. */
            if (issue.issues > 0) return 'warning';
            if (typeof issue.score === 'number' && issue.score >= 75) return 'solved';
            if (typeof issue.score === 'number') return 'warning';
            return null;
        }
        vm.issueCounts = {actual: 0, new: 0, all: 0, resolved: 0};
        vm.statusCounts = {critical: 0, warning: 0, solved: 0};
        vm.filteredRows = [];
        vm.issueGroupsView = [];
        function rebuildIssueView() {
            var rows = vm.issueRows || [];
            vm.issueCounts = {
                problems: rows.filter(function (row) { return row.issues > 0; }).length,
                new: rows.filter(function (row) { return row.isNew; }).length,
                all: rows.length,
                resolved: rows.filter(vm.issueResolved).length
            };
            vm.statusCounts = {critical: 0, warning: 0, solved: 0};
            rows.forEach(function (row) {
                var status = issueStatusOf(row);
                if (status) vm.statusCounts[status]++;
            });
            var filtered = rows.filter(function (issue) {
                if (vm.issueFilter === 'problems' && !(issue.issues > 0)) return false;
                if (vm.issueFilter === 'new' && !issue.isNew) return false;
                if (vm.issueFilter === 'resolved' && !vm.issueResolved(issue)) return false;
                if (vm.issueStatus && issueStatusOf(issue) !== vm.issueStatus) return false;
                return true;
            });
            vm.filteredRows = filtered;
            var groups = [];
            issueReportGroups.forEach(function (group) {
                var groupRows = filtered.filter(function (row) { return row.section === group; });
                if (!groupRows.length) return;
                groups.push({key: group, label: groupRows[0].sectionLabel, rows: groupRows});
            });
            vm.issueGroupsView = groups;
        }
        vm.rebuildIssueView = rebuildIssueView;
        /* Panoramica: the worst ten detected issues, with a link to the full list. */
        vm.overviewIssueRows = function () {
            return vm.issueRows.filter(function (issue) { return issue.issues > 0; }).slice(0, 10);
        };
        /* Issue count not represented by the ten rows shown in the overview. */
        vm.overviewIssuesRest = function () {
            var shown = vm.overviewIssueRows().reduce(function (sum, row) {
                return sum + (row.issues || 0);
            }, 0);
            var total = vm.issueTotals && vm.issueTotals.issues || 0;
            return Math.max(total - shown, 0);
        };
        /* Which columns each exam actually mentions: the page plus the element
           it measured (e.g. words for the word-count check, ratio for text/code). */
        var issueColumnLabels = {
            pagesTextLevelLow: ['Page', 'Words'],
            textCodeRatio: ['Page', 'Text/code ratio'],
            titleMissing: ['Page', 'Title tag'],
            titleOversize: ['Page', 'Title tag', 'Characters'],
            titleDuplicated: ['Page', 'Title tag'],
            h1Missing: ['Url', 'H1 tag'],
            h1Oversize: ['Url', 'H1 tag', 'Characters'],
            h1Multiple: ['Url', 'H1 tag', 'H1 multiple'],
            h1Duplicated: ['Url', 'H1 tag'],
            h2Missing: ['Url', 'H2 tag'],
            h2Oversize: ['Url', 'H2 tag', 'Characters'],
            h2Duplicated: ['Url', 'H2 tag'],
            metaDescriptionMissing: ['Page', 'Meta description'],
            metaDescriptionOversize: ['Page', 'Meta description', 'Characters'],
            metaDescriptionBelowsize: ['Page', 'Meta description', 'Characters'],
            metaDescriptionDuplicated: ['Page', 'Meta description'],
            imgMissAlt: ['Page', 'Preview', 'Alt'],
            imgOversizeAlt: ['Page', 'Preview', 'Alt'],
            optimizedGoogleSnippet: ['Snippet', 'Title', 'Description'],
            opengraphIncompleteTitle: ['Opengraph', 'og:title'],
            opengraphIncompleteDescription: ['Opengraph', 'og:description'],
            opengraphIncompleteImage: ['Opengraph', 'og:image'],
            opengraphIncompleteSiteName: ['Opengraph'],
            opengraphIncompleteType: ['Opengraph'],
            opengraphIncompleteUrl: ['Opengraph', 'og:url'],
            twittercardIncompleteTitle: ['Twittercard', 'Title'],
            twittercardIncompleteDescription: ['Twittercard', 'Description'],
            twittercardIncompleteImage: ['Twittercard', 'Image'],
            twittercardIncompleteCard: ['Twittercard', 'Card'],
            twittercardIncompleteSite: ['Twittercard', 'Site'],
            httpsMigration: ['Page'],
            pagesNotFound: ['Status', 'Page'],
            hreflangMissing: ['Page'],
            noXDefault: ['Page'],
            canonical: ['Page'],
            pagesDuplicated: ['Page'],
            titleDuplicated: ['Page'],
            opengraphIncomplete: ['Page'],
            twittercardIncomplete: ['Page']
        };
        /* Sub-checks of a section share the Page Explorer filter their legacy
           "view all the issues" button pointed at (e.g. every opengraph check
           opens the Opengraph: not optimized list). */
        var issueExplorerOverrides = {
            'base:optimizedGoogleSnippet': 'snippets:not-optimized',
            'social:opengraphIncompleteTitle': 'opengraph:not-optimized',
            'social:opengraphIncompleteDescription': 'opengraph:not-optimized',
            'social:opengraphIncompleteImage': 'opengraph:not-optimized',
            'social:opengraphIncompleteSiteName': 'opengraph:not-optimized',
            'social:opengraphIncompleteType': 'opengraph:not-optimized',
            'social:opengraphIncompleteUrl': 'opengraph:not-optimized',
            'social:twittercardIncompleteTitle': 'twittercard:not-optimized',
            'social:twittercardIncompleteDescription': 'twittercard:not-optimized',
            'social:twittercardIncompleteImage': 'twittercard:not-optimized',
            'social:twittercardIncompleteCard': 'twittercard:not-optimized',
            'social:twittercardIncompleteSite': 'twittercard:not-optimized'
        };
        /* Incomplete Twittercard checks state just the missing tag in the
           problems card ("Manca l'attributo \"site\""); the how-to copy stays
           in the "Come risolvere" card. */
        var missingTwitterTagByExam = {
            twittercardIncompleteCard: 'card',
            twittercardIncompleteTitle: 'title',
            twittercardIncompleteDescription: 'description',
            twittercardIncompleteImage: 'image',
            twittercardIncompleteSite: 'site'
        };
        function buildIssueRows() {
            var previousRows = vm.issueRows;
            var rows = [];
            /* The affected pages table mirrors the columns of the matching Page
               Explorer filter, so the examined element (ratio, characters, …)
               sits next to the page. */
            var explorerColumnsForIssue = function (itemId, examKey) {
                var item = vm.explorerItems.filter(function (entry) { return entry.id === itemId; })[0];
                if (!item) return [];
                var config = mergedConfig(item.viewId, item.variantId);
                var columns = config.columns && config.columns.length ? config.columns
                    : [PAGE, {label: config.valueLabel || 'Value', field: config.value || item.viewId}, {label: 'Status', field: 'status'}];
                /* Only the data the exam talks about: the page plus its element. */
                var allowed = issueColumnLabels[examKey];
                if (!allowed) return localizedColumns(columns);
                var kept = columns.filter(function (col) { return allowed.indexOf(col.label) !== -1; });
                return localizedColumns(kept.length ? kept : columns);
            };
            var explorerItemForIssue = function (section, examKey) {
                var override = issueExplorerOverrides[section + ':' + examKey];
                if (override) return override;
                var match = null;
                Object.keys(explorerCountSources).forEach(function (itemId) {
                    var source = explorerCountSources[itemId];
                    if (source.section === section && source.exam === examKey) match = itemId;
                });
                return match;
            };
            issueReportGroups.forEach(function (group) {
                var section = vm.report && vm.report[group];
                if (!section || !section.exams) return;
                var sectionConfig = vm.reportSections.filter(function (item) { return item.id === group; })[0];
                var label = sectionConfig && (sectionConfig.tkey || sectionConfig.label)
                    ? $translate.instant(sectionConfig.tkey || sectionConfig.label)
                    : (issueGroupLabels[group] ? $translate.instant(issueGroupLabels[group]) : group);
                Object.keys(section.exams).forEach(function (key) {
                    var exam = section.exams[key];
                    if (!exam) return;
                    rows.push({
                        id: exam.id || key,
                        key: key,
                        title: exam.title || '',
                        /* Titolo esplicativo localizzato: cambia con la lingua della piattaforma. */
                        titleKey: 'workspace.issueTitle.' + key,
                        section: group,
                        sectionLabel: label,
                        score: typeof exam.score === 'number' ? exam.score : null,
                        response: exam.response || '',
                        preview: exam.preview || [],
                        problems: missingTwitterTagByExam[key] && typeof exam.score === 'number' && exam.score < 100
                            ? [{formatHtml: 'workspace.issueMissingTag', args: [{type: 'text', value: missingTwitterTagByExam[key]}]}]
                            : (exam.problems || []),
                        suggests: exam.suggests || [],
                        aeo: group === 'aeo' ? exam.data : null,
                        expanded: false,
                        suggestsOpen: false,
                        explorerItem: explorerItemForIssue(group, key),
                        sampleColumns: explorerColumnsForIssue(explorerItemForIssue(group, key), key),
                        sampleRows: null,
                        sampleLoaded: false
                    });
                });
            });
            rows.sort(function (a, b) {
                return (a.score === null ? 101 : a.score) - (b.score === null ? 101 : b.score);
            });
            /* Issues and percentages come from the exam preview numbers: the first
               arg is the amount of affected pages, the second (when present) the
               pages considered by the check. */
            var numericArg = function (args, index) {
                var arg = args && args[index];
                if (!arg || arg.value === null || arg.value === '' || isNaN(arg.value)) return null;
                return Number(arg.value);
            };
            var totalPages = null;
            rows.forEach(function (row) {
                var second = numericArg((row.preview[0] || {}).args, 1);
                if (second !== null && (totalPages === null || second > totalPages)) totalPages = second;
            });
            rows.forEach(function (row) {
                var args = (row.preview[0] || {}).args;
                /* text/code ratio keeps the ratio first and the page count after it. */
                var issues = numericArg(args, row.key === 'textCodeRatio' ? 1 : 0);
                var total = row.key === 'textCodeRatio' ? totalPages : (numericArg(args, 1) || totalPages);
                row.issues = issues;
                row.issuesTotal = total;
                row.status = issueStatusOf(row);
                row.toFixPct = issues !== null && total ? Math.min(100, Math.round((issues / total) * 100)) : null;
                row.passedPct = row.toFixPct === null ? null : 100 - row.toFixPct;
                /* The exam summary sentence shown under the row title. */
                row.summaryHtml = row.preview.length ? issueTextualHtml(row.preview[0]) : null;
            });
            /* Totals for the header: every anomaly of the report, not the exams. */
            vm.issueTotals = {
                issues: rows.reduce(function (sum, row) { return sum + (row.issues || 0); }, 0),
                examsToFix: rows.filter(function (row) { return typeof row.score === 'number' && row.score < 75; }).length
            };
            /* Sampling of the exams already open keeps working after a rebuild. */
            if (previousRows) {
                rows.forEach(function (row) {
                    var previous = previousRows.filter(function (entry) { return entry.id === row.id; })[0];
                    if (!previous) return;
                    row.expanded = previous.expanded;
                    if (vm.issueResolved(row)) row.expanded = false;
                    row.suggestsOpen = previous.suggestsOpen;
                    row.sampleRows = previous.sampleRows;
                    row.sampleTotal = previous.sampleTotal;
                    row.sampleLoaded = previous.sampleLoaded;
                });
            }
            vm.issueRows = rows;
            rebuildIssueView();
        }
        function loadPreviews() {
            var url = vm.crawlSession && vm.crawlSession.url;
            if (!url || vm.previews.loading || vm.previews.url === url) return;
            vm.previews.loading = true;
            vm.previews.url = url;
            ScreenshotService.getScreenshot(url, 'desktop').then(function (result) {
                if (!destroyed) vm.previews.desktop = result || null;
            }).catch(function () { if (!destroyed) vm.previews.desktop = null; })
                .finally(function () { if (!destroyed) vm.previews.loading = false; });
            ScreenshotService.getScreenshot(url, 'mobile').then(function (result) {
                if (!destroyed) vm.previews.mobile = result || null;
            }).catch(function () { if (!destroyed) vm.previews.mobile = null; });
        }
        function normalizeReport(report) {
            if (!report) return null;
            issueReportGroups.forEach(function (group) {
                var section = report[group];
                if (!section || !section.exams) return;
                Object.keys(section.exams).forEach(function (key) {
                    var exam = section.exams[key];
                    if (!exam) return;
                    exam.id = exam.id || key;
                    exam.preview = exam.preview || [];
                    exam.suggests = exam.suggests || [];
                    exam.problems = exam.problems || [];
                    exam.exams = exam.exams || [];
                });
            });
            return report;
        }
        function buildReportScores(report) {
            var result = {score: 0, scored: 0, ok: 0, warning: 0, error: 0, checks: 0, categories: [], categoryScores: {}};
            if (!report) return result;
            var totalWeight = 0;
            reportGroups.forEach(function (group) {
                var section = report[group];
                if (!section) return;
                var score = typeof section.score === 'number' ? section.score : null;
                var label = vm.reportSections.filter(function (item) { return item.id === group; })[0];
                result.categories.push({
                    id: group,
                    label: label ? $translate.instant(label.tkey || label.label) : group,
                    score: score,
                    checks: section.exams ? Object.keys(section.exams).length : 0
                });
                result.categoryScores[group] = {score: score};
                if (score !== null) {
                    var weight = reportGroupWeights[group] || 0;
                    result.score += score * weight;
                    totalWeight += weight;
                    result.scored++;
                }
                if (!section.exams) return;
                Object.keys(section.exams).forEach(function (key) {
                    var exam = section.exams[key];
                    if (!exam || typeof exam.score !== 'number') return;
                    result.checks++;
                    if (exam.score >= 75) result.ok++;
                    else if (exam.score >= 50) result.warning++;
                    else result.error++;
                });
            });
            result.score = totalWeight ? result.score / totalWeight : null;
            return result;
        }
        function loadGscRows() {
            if (!vm.gsc.property || !vm.gscFilters.startDate || !vm.gscFilters.endDate) return;
            var id = ++gscRowsRequestId;
            vm.gsc.rowsLoading = true;
            vm.gsc.rowsError = false;
            var params = Object.assign({}, vm.gscFilters, {
                rowLimit: vm.gscPageSize,
                sortBy: vm.gscSort.field,
                sortDirection: vm.gscSort.direction,
                search: vm.form.gscSearch
            });
            SearchConsoleService.getProjectPerformance(vm.project.id, vm.gscView,
                vm.gscFilters.startDate, vm.gscFilters.endDate, vm.gscOffset, params)
                .then(function (result) {
                    if (destroyed || id !== gscRowsRequestId) return;
                    if (Array.isArray(result)) {
                        vm.gsc.rows = result;
                        vm.gscTotalRows = result.length;
                        vm.gscTotalRowsKnown = true;
                        vm.gscHasMoreRows = false;
                        vm.gscTruncated = false;
                        return;
                    }
                    vm.gsc.rows = result && result.rows || [];
                    vm.gscTotalRowsKnown = !(result && result.totalRowsKnown === false);
                    vm.gscTotalRows = vm.gscTotalRowsKnown
                        ? Number(result && result.totalRows) || 0
                        : 0;
                    vm.gscHasMoreRows = !!(result && result.hasMoreRows);
                    vm.gscTruncated = !!(result && result.truncated);
                })
                .catch(function () { if (!destroyed && id === gscRowsRequestId) vm.gsc.rowsError = true; })
                .finally(function () { if (!destroyed && id === gscRowsRequestId) vm.gsc.rowsLoading = false; });
        }
        function refreshConnection() {
            if (vm.section === 'search-console' && vm.project && !destroyed) vm.$applyAsync(loadSearchConsole);
        }
        $window.addEventListener('focus', refreshConnection);
        $window.addEventListener('storage', refreshConnection);
        var removeThemeListener = vm.$on('suiteThemeChanged', function () {
            if (!destroyed && vm.section === 'overview' && vm.overviewTraffic.data) {
                buildOverviewTrafficChart(vm.overviewTraffic.data);
            }
        });
        vm.$on('$destroy', function () {
            destroyed = true;
            removeThemeListener();
            if (overviewTrafficChartInstance) {
                overviewTrafficChartInstance.destroy();
                overviewTrafficChartInstance = null;
            }
            if (crawlPoll) { $interval.cancel(crawlPoll); crawlPoll = null; }
            $window.removeEventListener('focus', refreshConnection);
            $window.removeEventListener('storage', refreshConnection);
        });
        loadProject();
    }
    Controller.$inject = ['$scope', '$stateParams', '$state', '$window', '$localStorage', '$filter', '$timeout', 'ProjectsService',
        'KeywordTrackerService', 'SeospiderService', 'SeospiderPagesService', 'SeospiderBulkExportService', 'ReportPdfService',
        'SearchConsoleService', 'TrafficInsightsService', 'FavIconService',
        'ScreenshotService', 'SeocheckerService', 'UserService', '$translate', '$sce', '$interval', 'SuiteNavigation'];
    return Controller;
});
